var customerData = []
var allSubscriptions = [];
var allCancelledSubscriptions = [];
var allAddons = [];
var allAddresess = [];
var allPayments = [];
var shopifyProductJson = [];
var allCollections = [];
var isCollectionLoaded = false;
var successModal = null;
var successToastMessage = '';
var allProducts = [];
var allMissingProducts = [];
var subscriptionData = {};
var addonData = {};
var allCharges = [];
var allUpcomingQueuedCharges = [];
var chargeFailedDate = null;
var allErrorCharges = [];
var currentAddress = {};
var currentAddressItems = [];
var currentAddressSubscriptions = [];
var isColorPickerModal = false;
var isLoadedDone=false;
// Subscription Flow Variables
var selectedStyleCollection = null;
var selectedSize = null;
var actionType = null;
var selectedColor = null;
var selectedSizeProducts = {};
var allTopSubscription = [];
var selectedVariant = {};
var selectedProduct = null;
var addressesToMerge = [];
var mergeParentAddress = '';
var ccSuccessMessage = false;
var mergeShippingDate = '';
var isErrorExist = false;
var oldStylePrice = window.oldStylePrice ? window.oldStylePrice : '';
var processOrderNow = false;
var oldPriceJson = {};
var canadaRate = 1;
var sortedAddresses = [];
oldStylePrice.split(',').forEach(style => {
    let styleArr = style.split(':');
    oldPriceJson[styleArr[0] || ''] = styleArr[1] || '';
});

var isOldStyleCustomer = JSON.parse(window.customerDetails.customerTags != "null" ? window.customerDetails.customerTags : '[]').includes('OLD_TOP_SUBSCRIBER');
if (isOldStyleCustomer == true) {
    oldPriceJson = {};
}
if (isOldStyleCustomer) {
    oldPriceJson['ws-icon2'] = '2094';
    oldPriceJson['ws-boss2'] = '2094';
}
var retantionOffer = null;
var retantionSwapStyle = null;
var isRetantionCompleted = false;
var isShipNowDisabled = false;
var cancelBoxReModal = false;
var actualLocalePrice = null;
var isSkipDisabled = false;
var skipAllCharges = false;
var ignoreProperties = [
    'product_add_by',
    'first_swapping',
    'is_selected',
    'auto_swap',
    'old_charge_date',
    'same_product',
    'isSwapping'
];
var PAYMENT_METHOD_DECLINED = `Your payment for your last order was declined. Please <a href="javascript:void(0);" class="fw-bold text-violate" data-modal-opener="shopify_payments">UPDATE</a> your payment method and we will automatically reprocess your order within 24 hours. Please contact customer service if the issue persists.`;
var GENERAL_MESSAGE = `There was an issue processing your order please <a href="javascript:void(0);" data-zowie-start>contact customer service.</a>`;
var INVALID_SHIPPING_ADDRESS = 'We could not find your address, please <a href="javascript:void(0);" class="fw-bold text-violate" data-modal-opener="editAddress">UPDATE </a> your address information. If the issue persists please <a href="javascript:void(0);" data-zowie-start>contact customer service.</a>.';
var CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT = 'Thank you for updating your payment method! Your order was successfully processed and we will send you an order confirmation shortly.';

class NewDashboardV2 extends HTMLElement {
    constructor() {
        super();
        this._init();
    }

    async _init() {
        //to handle ios modal issue
        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        this.dashboardLoadingInterval=setInterval(() => {
            if (isLoadedDone) {
                this._manageCustomerDashboardLoadingTag();
            }else{
                this._manageCustomerDashboardLoadingTag();
            }
        }, 15000);

        await this._redirectToTab();
        await this._loadCollectionData();
        await this._onLoadData();
        await this._singleTimeEvents();
    }

    async _onLoadData() {
        await rechargeSdk._authCustomer();
        await this._loadSubscriptionData();
        this._paginateOrders();
    }

    async _loadSubscriptionData() {
        chargeFailedDate = null;
        customerData = await rechargeSdk._getCustomerDetails();
        if (customerData != false) {
            allAddresess = customerData?.include?.addresses || await rechargeSdk._getCustomerAddresses();
            allSubscriptions = customerData?.include?.subscriptions || await rechargeSdk._getSubscriptions();
            allCancelledSubscriptions = allSubscriptions.filter((subscription) => subscription.status == "cancelled")
            allSubscriptions = allSubscriptions.filter((subscription) => subscription.status == 'active')
            this._prepareProductIds();
            allAddons = await rechargeSdk._getOnetimes();
            allPayments = customerData?.include?.payment_methods || await rechargeSdk._getPaymentMethods();
            shopifyProductJson = await rechargeSdk._getProductsJSON();

            let topStyles = ['icon', 'icon2', 'boss', 'boss2'];
            allTopSubscription = [...allAddons, ...allSubscriptions].filter((item) => {
                let productType = shopifyProductJson[item.external_product_id.ecommerce]?.product_type?.toLowerCase();
                if (topStyles.includes(productType)) {
                    return item;
                }
            })
            let needReload = await this._manageOldTopSubscriberTag();

            //for old customer who are still using old collection swatch
            await this._manageUnavailableProductInCollection();
            if (needReload) {
                return false;
            } else {
                await this._listCharges();
                allErrorCharges = await this._errorCharges()
                isRetantionCompleted = false;
                this._boxIntroText();
                await this._prepareTopNotificationAndDetails();
                this._prepareHTML();
                this._bindEvents();
                this._loadLayout();
            }
            allProducts = [...allSubscriptions, ...allAddons];
            this._hideModal('cancel-popup');
        } else {
            this._loadLayout();
        }

        this.querySelectorAll('button.loading, .btn').forEach(ele => this._loadButton(ele, false));
        if (successModal !== 'cancel-success') {
            this.querySelector('.modal.open:not(:has(#ship_now_flow:not(.d-none)))')?.closest('modal-dialog')?.hide();
        }
        document.body.classList.remove('pointer-events-none');
        isShipNowDisabled = false;
        isSkipDisabled = false;
        successModal = null;

       this._scrollToBox();
    }

    _redirectToTab() {
        this.querySelectorAll('[data-manage-menu]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                let id = ele.getAttribute('data-manage-menu');
                this.querySelectorAll('[data-account-tabs]').forEach((e) => {
                    e.classList.add('d-none');

                });
                this.querySelectorAll('[data-manage-menu]').forEach((e) => {
                    e.closest('li')?.classList.remove('active');
                })

                this.querySelector(`#${id}`)?.classList.remove('d-none');
                this.querySelector(`[data-manage-menu="${id}"]`)?.closest('li')?.classList.add('active');
            })
        })

        const url = window.location.href;
        const urlObj = new URL(url);
        const queryParams = new URLSearchParams(urlObj.search);
        const paramName = queryParams.get('menu');
        if (paramName) {
            if (paramName === 'order') this.querySelector('[data-manage-menu="orderMenu"]')?.click();
            else if (paramName === 'account') this.querySelector('[data-manage-menu="accountMenu"]')?.click();
        }

        if (!document.querySelector('.subscription-account-v2.real_active_subscriber') && paramName != 'order') {
            this.querySelector('[data-manage-menu="accountMenu"]')?.click();
        }
    }

    _scrollToBox() {
        let isMobile = window.innerWidth <= 576;
        if (currentAddress?.id) {
            const element = this.querySelector(`${isMobile ? '.mobile-part' : '.desktop-part'} [data-single-container="${currentAddress.id}"] [data-subscription-id]`);
            if (!Utility.in_Viewport(element)) {
                window.scrollTo(0, element.offsetTop - 100);
            }
        } else {
            window.scrollTo(0,0);
        }
    }
     async _prepareTopNotificationAndDetails() {
        try {
            let subscriptions = await rechargeSdk._getSubscriptions();
            let activeCount = 0;
            let skippedCount = 0;
            let cancelledCount = 0;
            let chargeDates = [];
            let chargeDatesForSorting = [];
            allAddresess.forEach((address, i) => {
                let addressRelatedSubscriptions = subscriptions.filter((subscription) => subscription.address_id == address.id);
                if (addressRelatedSubscriptions.length) {
                    let next_charge_date = addressRelatedSubscriptions[0].next_charge_scheduled_at;
                    let preChargeDate = '';
                    let pendingAttempt = this._showChargeError(address.id) === CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT;
                    allCharges.forEach(charge => {
                        if (charge.address_id == address.id && charge.status === "skipped") {
                            preChargeDate = charge.scheduled_at;
                        }
                    })
                    let skippedBox = !pendingAttempt && next_charge_date && preChargeDate;
                    if (skippedBox) skippedCount++;
                    else activeCount++
                    // addressRelatedSubscriptions.forEach(sub => {
                    //     if (skippedBox) skippedCount++;
                    //     else if (sub.status === 'active') activeCount++;
                    //     else if (sub.status === 'cancelled') cancelledCount++;
                    // })

                    chargeDatesForSorting.push({ id: address.id, date: next_charge_date ?? '' })
                    next_charge_date && chargeDates.push(next_charge_date);
                }
            })

            const dateObjects = chargeDates.map(date => moment(date, 'YYYY-MM-DD'));

            chargeDatesForSorting = chargeDatesForSorting
                .sort((a, b) => {
                    if (!a.date) return 1;
                    if (!b.date) return -1;
                    let dateA = moment(a.date, 'YYYY-MM-DD', true);
                    let dateB = moment(b.date, 'YYYY-MM-DD', true);
                    return dateA.diff(dateB);
                })
                .map((item, index) => ({
                    ...item,
                    order: index + 1,
                }));

            if (chargeDatesForSorting && chargeDatesForSorting.length) sortedAddresses = chargeDatesForSorting;
            let nearestDate = '';
            if (dateObjects?.length) {
                nearestDate = dateObjects.reduce((nearest, current) => {
                    return Math.abs(current.diff(moment())) < Math.abs(nearest.diff(moment())) ? current : nearest;
                });
            }

            if (nearestDate) {
                let dateEle = this.querySelector('[data-top-shipping-date]').closest('div');
                if (dateEle) {
                    dateEle?.classList?.remove('d-none');
                    dateEle.querySelector('[data-top-shipping-date]').innerHTML = nearestDate.format('MMMM Do');
                }
            }
            this.querySelector('[data-top-information]')?.classList?.remove('d-none');
            this.querySelector('[data-top-active]').innerHTML = `Active (${ activeCount || 0})`
            this.querySelector('[data-top-skipped]').innerHTML = `Skipped (${ skippedCount || 0})`
            this.querySelector('[data-top-cancelled]').innerHTML = `Cancelled (${ cancelledCount || 0})`

        } catch (e) {
            console.error(e + ' => from top notifications')
        }
    }

    async _manageUnavailableProductInCollection() {
        try {
            let productsToCheck = [...allAddons, ...allSubscriptions];
            allMissingProducts = [];
            let missingProducts = productsToCheck.filter(sub => {
                return !Object.values(allCollections).some(collection =>
                    collection.products.some(product => product.id == sub?.external_product_id?.ecommerce)
                );
            })

            await missingProducts.forEach(async (product) => {
                if (product.external_product_id?.ecommerce) {
                    await this._getProduct(product.external_product_id?.ecommerce)
                }
            })
        } catch (err) {
            console.log(err, 'Error');
        }

    }

    _loadLayout() {
        this.querySelector('[data-subscription-layout-loader]')?.classList.add('d-none');
        if (!isCollectionLoaded) return;
        if (allSubscriptions && allSubscriptions.length > 0) {
            this.querySelector('[data-empty-subscription-layout]')?.classList.add('d-none');
            this.querySelector('[data-subscription-contain-layout]')?.classList.remove('d-none');
        } else {
            this.querySelector('[data-empty-subscription-layout]')?.classList.remove('d-none');
            this.querySelector('[data-subscription-contain-layout]')?.classList.add('d-none');
        }
        isLoadedDone = true;
    }

    _prepareProductIds() {
        window.customerDetails.rechargeSubscriptions = allSubscriptions;
        window.customerDetails.rechargeSubscriptions.sort((a, b) => {
            {
                if (a.next_charge_scheduled_at == null) return 1;
                if (b.next_charge_scheduled_at == null) return -1;
                return new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at);
            }
        });

        existingProductIds = [...existingProductIds, ...window.customerDetails.rechargeSubscriptions.map((sub) => {
            return sub.external_product_id ? sub.external_product_id.ecommerce : sub.shopify_product_id
        })]

        return window.customerDetails.rechargeSubscriptions;
    }

    _boxIntroText() {
        let required = 0;
        allAddresess.forEach(address => {
            let addressRelatedSubscriptions = allSubscriptions.filter((subscription) => subscription.address_id == address.id);
            if (addressRelatedSubscriptions.length) required++;
        })

        this.querySelector('[data-box-intro-text]').innerHTML = required >= 2
            ? 'Your next subscription boxes:'
            : 'Your next subscription box:';
    }

    async _prepareHTML() {
         this._prepareSubscriptionHtml();
         this._prepareMobileViewSubscriptionHtml();
         this._prepareQuickAddHtml();
         this._prepareQuickAddBoxes();

        let normalSubscriptions = allSubscriptions.filter((subscription) => subscription.next_charge_scheduled_at != null);
        if (normalSubscriptions.length > 0) {
            this.querySelectorAll('[data-quick-add-collection] [data-quick-add-button]').forEach(ele => {
                ele.classList.remove('disabled');
            })
        }

        this.querySelectorAll('[data-subscription-status="unselected"], [data-subscription-status="skip"], [data-subscription-status="unskip"]')
            .forEach((ele) => {
                ele.closest('[data-single-container]')?.querySelectorAll('[data-modal-opener="ship-now"]').forEach((shipNowEle) => {
                    shipNowEle.classList.add('disabled','disabled_color')
                })
            })

        this.querySelectorAll('[data-skip-all]').forEach(el => {
            let unSkipSubs = el.closest('[data-single-container]')?.querySelectorAll('[data-subscription-status="unskip"]')?.length;
            let allSubs = el.closest('[data-single-container]')?.querySelectorAll('[data-subscription-status]')?.length;
            if (unSkipSubs && unSkipSubs === allSubs) {
                el.closest('[data-skip-all]')?.setAttribute('data-skip-all', 'unskip');
                el.closest('[data-skip-all]')?.setAttribute('data-modal-opener', '');
                el.closest('[data-skip-all]').querySelector('[data-skip-all-inner]').innerHTML = 'UnSkip';
            } else if (allSubs) {
                el.closest('[data-skip-all]')?.setAttribute('data-skip-all', 'skip');
                el.closest('[data-skip-all]')?.setAttribute('data-modal-opener', 'skipNow');
                el.closest('[data-skip-all]').querySelector('[data-skip-all-inner]').innerHTML = 'Skip';
            }
        })

        //featured products slider management
        setTimeout(() => {
            let featuredContainer = this.querySelector('[data-featured-container]');
            let prevBtn = this.querySelector('[data-featured-prev]');
            let nextBtn = this.querySelector('[data-featured-next]');

            if (featuredContainer?.scrollWidth > featuredContainer?.clientWidth) {
                prevBtn?.classList?.remove('d-none');
                nextBtn?.classList?.remove('d-none');
            } else {
                prevBtn?.classList?.add('d-none');
                nextBtn?.classList?.add('d-none');
            }

            prevBtn?.addEventListener('click', function () {
                featuredContainer.scrollBy({ left: -featuredContainer.clientWidth, behavior: 'smooth' });
            });

            nextBtn?.addEventListener('click', function () {
                featuredContainer.scrollBy({ left: featuredContainer.clientWidth, behavior: 'smooth' });
            });
        }, 500)

        this.querySelectorAll('.accordion_activator').forEach(ele => {
            ele.addEventListener('click', event => {
                if (!event.target.classList.contains('view-order-text') && !event.target.classList.contains('view-order-icon')) {
                    event.stopPropagation();
                    event.preventDefault();
                    if (event.target.closest('.merge-box [data-merge-box]')) {
                        let mergeBox = ele.closest('[data-merge-box]');
                        let container = mergeBox.closest('[data-modal-section]');
                        if (mergeBox) {
                            mergeBox.classList?.toggle('active_merge_box');
                            mergeBox.setAttribute('data-merge-box', mergeBox.dataset.mergeBox == '1' ? '0' : '1');
                        }
                        if (container.querySelectorAll('.active_merge_box').length >= 2) {
                            container.querySelector('[data-merge-box-submit]')?.classList?.remove('disabled');
                        } else {
                            container.querySelector('[data-merge-box-submit]')?.classList?.add('disabled');
                        }
                        addressesToMerge = [];
                        container.querySelectorAll('.active_merge_box').forEach(ele => {
                            addressesToMerge.push(ele.closest('[data-merge-box="1"]').dataset.singleContainer);
                        })
                    }
                }
            })
        })
    }

    _openV2Modal(id) {
        try {
            let section = document.querySelector(`[data-modal-section="${id}"]`);
            if (section) {
                let modalContainer = section.closest('[data-v2-modal]');
                modalContainer?.querySelectorAll('[data-modal-section]').forEach(el => el.classList.add('d-none'));

                section.classList.remove('d-none');
                let modalId = modalContainer?.getAttribute('id');
                modalId && document.querySelector(`#${modalId}`)?.show();
            } else {
                document.querySelector(`#${id}`)?.show();
            }
        } catch (e) {
            console.log(e)
        }
    }

    _sortedOrderOfAddress(id) {
        let order = '';
        if (id && sortedAddresses && sortedAddresses.length) {
            const item = sortedAddresses.find(obj => obj.id === id);
            if (item) {
                order = item.order;
            }
        }

        return order;
    }
    _prepareSubscriptionHtml() {
        let html = "";
        let realIndex = 0;
        allAddresess.forEach((address, i) => {
            let id = address.id;
            let addressRelatedSubscriptions = allSubscriptions.filter((subscription) => subscription.address_id == id);
            let addressRelatedCancells = allCancelledSubscriptions.filter((subscription) => subscription.address_id == id);
            let addressRelatedAddons = allAddons.filter((addon) => addon.address_id == id);
            let cancelledBoxCount = 1;
            addressRelatedSubscriptions = [...addressRelatedSubscriptions, ...addressRelatedAddons]
            let activeBox = addressRelatedSubscriptions.length > 0;
            let cancelledBox = addressRelatedCancells.length > 0 && addressRelatedSubscriptions.length <= 0;
            if (activeBox || cancelledBox) {
                let next_charge_date = null;
                let preChargeDate = null;
                let total = null;
                let chargeError = null;
                let pendingAttempt = null;
                let shippingError = null;
                let skippedBox = null;
                let cancelledDate = null;
                let paymentMethod = allPayments.find((payment) => payment.id == address.payment_method_id) || false;
                if (activeBox) {
                    next_charge_date = addressRelatedSubscriptions[0].next_charge_scheduled_at;
                    if (next_charge_date != null) {
                        next_charge_date = moment(next_charge_date).format('MMMM Do')
                    }
                    preChargeDate = '';
                    allCharges.forEach(charge => {
                        if (charge.address_id == id && charge.status === "skipped") {
                            preChargeDate = moment(charge.scheduled_at).format('MMMM Do');
                        }
                    })
                    total = addressRelatedSubscriptions.reduce((acc, obj) => acc + parseFloat(obj.price), 0);
                    chargeError = this._showChargeError(address.id) != false;
                    pendingAttempt = this._showChargeError(address.id) === CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT;
                    shippingError = this._showChargeError(address.id) === INVALID_SHIPPING_ADDRESS;
                    if (!isErrorExist) this._manageCCErrorMessages(address);
                    skippedBox = !pendingAttempt && next_charge_date && preChargeDate;
                }
                if (cancelledBox) {
                    cancelledDate = addressRelatedCancells[0].cancelled_at;
                    if (cancelledDate) {
                        cancelledDate = moment(cancelledDate).format('MMMM Do')
                    }
                }
                let sortedOrder = this._sortedOrderOfAddress(address.id);
                let finalHtml = `
                    <div class="my-4 ${cancelledBox ? 'cancelled_box' : ''}" data-single-container="${address.id}" style="order: ${sortedOrder ? sortedOrder : 5 }">
                        <div class="subscription-table-header d-flex flex-column" ${i == 0 ? `data-tutorial-highlight="1"` : ``}>
                        
                            <div class="success-toast-message d-none" data-success-message>  
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                  <circle cx="9" cy="9" r="8" stroke="black" stroke-width="2"/>
                                  <path d="M7.61246 10.4742L5.78479 8.6976L5 9.46048L7.61246 12L13 6.76288L12.2152 6L7.61246 10.4742Z" fill="black"/>
                                </svg>
                                <span style="flex:1" data-message-text>Successfully skipped.</span>                    
                            </div>  
                            
                            <div class="d-flex align-items-center heading-name w-100 justify-content-between subscription-desktop-header">
                                <div class="d-flex flex-column heading"><span>${cancelledBox ? 'Cancelled on:' : 'Ship date:'}</span>
                                    ${!cancelledBox && preChargeDate ? `<span class="d-flex flex-wrap fw-semibold flex-column" style="gap: 3px"><span class="description text-decoration-line-through text-gray-600">${preChargeDate}</span>` : ``}
                                   ${cancelledBox ? `<span class="d-flex flex-wrap fw-semibold flex-column" style="gap: 3px"><span class="description text-gray-600">${cancelledDate}</span>`
                    : (next_charge_date && !preChargeDate ? `<span class="fw-semibold text-success" style="font-family: 'Termina Demi'">${next_charge_date || '-'}</span>` :
                        `<span class="fw-semibold ${preChargeDate ? 'd-none' : 'text-success'}">${chargeError ? '-': '-'}</span>`)}
                                </div>

                                <div class="d-flex flex-column heading">
                                    <span>Frequency:</span>
                                    <span class="fw-semibold" style="font-family: 'Termina Demi'">Monthly</span>
                                </div>

                                <div class="d-flex flex-column heading">
                                    <span>Order total:</span>
                                    ${cancelledBox ? `<span class="fw-semibold">-</span>` : `<span class="fw-semibold" style="font-family: 'Termina Demi'">$${total.toFixed(2)} (${addressRelatedSubscriptions.length} ${addressRelatedSubscriptions.length > 1 ? 'items' : 'item'})</span>`}
                                    
                                </div>
                                <div class="d-lg-flex d-block align-items-baseline">
                                ${cancelledBox ? 
                                    `<button class="subscription-ship-now ${!cancelledBox && !next_charge_date && !pendingAttempt ? 'disabled' : ''}" data-modal-opener="item-add" data-tutorial-guide-stepv2="1">
                                        RE-ACTIVATE
                                    </button>` : (skippedBox ?
                        `<button class="subscription-ship-now" data-modal-opener="unskip-modal">
                                        <span class="add-text text-uppercase">UNSKIP</span>
                                        <span class="spinner"></span>
                                    </button>` :
                        `<button class="subscription-ship-now ${!next_charge_date && !pendingAttempt ? 'disabled' : ''}" data-modal-opener="ship-now" data-tutorial-guide-stepv2="1">
                                        Ship now
                                    </button>`)}
                             
                                    <a class="wx-tooltip font-termina price-lock-tooltip"
                                       style="height: 17px; width: 17px;"
                                       data-link-category="SUBPORTAL" data-link-subcategory="ToolTipLOCK"
                                       data-link-text="">

                                        <svg width="16" id="Layer_1" height="16" viewBox="0 0 16 16" class="ship_now_icon"
                                             style="margin-left: 13px"  
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                  fill="#0E8533"/>
                                            <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                        </svg>
                                        <span class="wx-tooltip-text font-termina">
                                           <div>
                                            ${cancelledBox 
                                                ? `<span>Miss your favorite items? Clicking 'Reactivate' will restore your subscription and reactivate your box. </span>` 
                                                : (skippedBox ?
                        `<span class="unskip-tooltip">UN-SKIPPING your box will move your next charge date from ${next_charge_date} to ${preChargeDate}</span>` :
                        `Want your order sooner? <br> Clicking “Ship Now” means we will ship your items ASAP with no extra charge.`)}
                                               
                                            </div>
                                        </span>
                                    </a>
                                </div>
                            </div>
                             ${next_charge_date && preChargeDate ? `<span class="fw-semibold text-success mt-2" style="font-family: 'Termina Demi';font-size: 12px">
This box will now ship on ${next_charge_date || ''}</span>` :
                    `<span class="fw-semibold ${preChargeDate ? 'd-none' : 'text-success'}">${chargeError ? '': ''}</span>`}   
                        </div>
                        <div class="d-flex table-data">
                            <div>
                                <div class="left-data ${cancelledBox ? 'd-none' : ''}" data-subscription-info ${realIndex == 0 ? `data-tutorial-highlight="1"` : ``}>
                                    <div class="left-data-container" data-subscription-details>
                                        <div class="table-item d-flex align-items-center">
                                            <div style="margin-right: 12px;">
                                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <rect width="21" height="21" fill="url(#pattern0_4596_408)"/>
                                                    <defs>
                                                    <pattern id="pattern0_4596_408" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_4596_408" transform="scale(0.00390625)"/>
                                                    </pattern>
                                                    <image id="image0_4596_408" width="256" height="256" xlink:href="data:image/png;base64,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"/>
                                                    </defs>
                                                </svg>
                                            </div>

                                            <div class="d-flex flex-column">
                                                <span class="user-role mb-2">Name on order</span>
                                                <span class="text-capitalize">${address.first_name || ''}</span>
                                            </div>
                                        </div>

                                        <div class="table-item d-flex align-items-center mt-4">
                                            <div style="margin-right: 12px;">
                                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <rect width="21" height="21" fill="url(#pattern0_4596_407)"/>
                                                    <defs>
                                                    <pattern id="pattern0_4596_407" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_4596_407" transform="scale(0.00195312)"/>
                                                    </pattern>
                                                    <image id="image0_4596_407" width="512" height="512" xlink:href="data:image/png;base64,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"/>
                                                    </defs>
                                                </svg>
                                            </div>

                                            <div class="d-flex flex-column">
                                                <span class="user-role mb-2">Ships to</span>
                                                <span data-address-to-capitalize>
                                                    ${address?.address1} ${address?.address2 ? address?.address2 : ''}, ${address?.city || ''}, ${address?.province || ''}, ${address?.country_code || ''}, ${address?.zip || ''}
                                                </span>
                                            </div>

                                            <div class="align-self-start ${cancelledBox ? 'd-none' : ''}" style="margin-left: auto">
                                                <button class="edit-button text-decoration-underline mb-4"
                                                        style="margin-left: auto" data-shipping-edit-btn>Edit
                                                </button>
                                            </div>
                                        </div>

                                        <div class="table-item d-flex align-items-center mt-4 mb-3">
                                            <div style="margin-right: 12px;">
                                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <rect width="21" height="21" fill="url(#pattern0_4596_409)"/>
                                                    <defs>
                                                    <pattern id="pattern0_4596_409" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_4596_409" transform="scale(0.00195312)"/>
                                                    </pattern>
                                                    <image id="image0_4596_409" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAACAKADAAQAAAABAAACAAAAAAAL+LWFAAArDklEQVR4Ae3dMXNjx5YY4NHbF6yjRehM9x+ImznTdb5V4kvWmw2UrSONf4G40Ybiy5wNFLnsDURVucrhYDI7GipzNlDoSHzlZDPtOSNiBjMCZ0iw+6Ib9+uqI4AgcPr013zowwtK78kTgwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB/gQ+66/kpioeoprPm6pIMQQIEJiPwM+x1M18llt2pRqAj3t+Gd8e7oiPv9J3CRAgQGBKgU1Mti9eTllET3NpAN7tVh72ZxFjxBCR9w0CBAgQ6F/gOpawiVhH5H1NQSDMuQHIA/6riPE24sYgQIAAgZkIrGOdGT9GZFMwuzG3BiAP/PPbWMxuty2YAAECBPYJ3MSDV7eRDcEsxhwaAIf+LH6ULZIAAQJFBGbTDJxqAzDEj8E3EcsIv+kHgkGAAAECDxbIZmAV8eeITcRJjVNrAJ7G7iwjxgiDAAECBAiUElhHolXE9xEnMU6hAcjf8PPgfxYxRBgECBAgQKCWwCYSX0Tk3wrkFYJuR88NQB78eZk/D/68bxAgQIAAgakE8vC/jMiPB/J+d6PHBiAPewd/dz9qCiZAgMBJCuThfxGRjUBXo7cGIC/1X0QMEQYBAgQIEGhFYBOF/JeIq1YK+lQdvTQAYyzk24i8NQgQIECAQKsC6ygsG4HrVgvc1vVX2zuN3ubl/n+O+K8RQ4RBgAABAgRaFhiiuH+MyPPr/0T8a0STo+UrAOch9l3E0KScoggQIECAwMcFNvHtryPWEc2NPzRX0W9d0/Oo64eIocH6lESAAAECBO4jMMSTXkTkmZZXBJoarV0BGEMnoYYIgwABAgQInIrAJhbyp4jrVhbU0t8AfBsoq4jmuqRWNksdBAgQINCtQJ5t+bcBOV7+dnPcf7ZwBSBR8nL/eFwKsxMgQIAAgUkE1jFLXg24mWS2OyY5dgNwFnX5rP+OzfEwAQIECJyswCZWdtSPBI75EcAyFv/fIv59hEGAAAECBOYkkFe//yHi/0VcH2Phx2oAvonF5r/b/9fHWLQ5CRAgQIBAAwJ5Bp5H3ETkfzNg0nGMjwDyr/yXk66y3GQ/RapNRHZreZuxHbmB+bhBgAABAvUEziL1Yif9EPcz8vG8/SKix7GKor/usfD71pyH/6+dRB7mlxHnEUOEQYAAAQJ9CAxRZr5353v4dUQv506ekSc3FrGi/GO/ljchf0jyh+U8Ius1CBAgQOA0BPI9Pd/bLyOuI1o+i7IJyHpPYuRCXkW0CL6JuvIH4izCIECAAIF5COR7fr73byJaPJvyzFxEdD1yAS0e/quo67xrWcUTIECAQAmBPAtWEa01Anl2dj3yUkYrqDdRy0VENiUGAQIECBDYFciz4SIiz4pWzq08Q7scrRz+Dv4uf3wUTYAAgaMItNYIdNcEtHD4b+JHZ3mUHx+TEiBAgMApCCxjEZuIX48clzF/F2MZVbaAlV2cQYAAAQIEHiOQZ0kewMc+15aPWcQUrz0/MtI65j+bYqHmIECAAIFZCeTZso44ZiOQZ2yTI3F+iTgGzk3Mu4wwCBAgQIBATYFlJM8z5xhnXZ6xedY2NRZRzbH+db91zJ3zGwQIECBAYAqBPHPWEcdoAvKsberM++FIEBcxr0GAAAECBI4hcBGTHqMJeH6Mxe6b89kRAG5iznFfMR4jQIAAAQITCowxV55JUzcCefYedZzF7PmZxJQLv475FkddtckJECBAgMA7gTyT8mya8izMs/fsXQnT38vPIqZc8Gr6JZqRAAECBAjcS2AVz5ryTMwz+CjjImadcqGro6zSpAQIECBA4P4Cq3jqlGfjxf1LK/PMvOww5QKflSlbFgIECBAgUF3gImaY8oyc9KOAKS/9L6tvlQkIECBAgEBZgWWkm6oJmOyjgIsJF5WABgECBAgQ6FFgGUVP1QRUv1K+iMX8MtGCLmMegwABAgQI9CyQZ9kUTUCezXlGVxuryDzFQnIegwABAgQInILAKhbR9dk59r6AqN8gQIAAAQLHEFjFpFM0AWc1FvdiguKvY46qlzBqwMhJgAABAgQ+IZBnW55xtZuAPKuLjjGy1S76JuYYIgwCBAgQIHCKAkMsKs+62ufpGHMUG9lR1C74vFi1EhEgQIAAgTYF8qyrfZ7mmV1kLCNL7WIvi1QqCQECBAgQaF8gz7za5+pYgiE7iZqFXpcoUg4CBAgQINCRQJ59Nc/WPLsfNcZ4dc0CM/cQYRAgQIAAgTkJDLHY2ufr+BjQ7CBqFnjxmOK8lgABAgQIdCxwEbXXPGOvDrUZKhe2ifyLCIMAAQIECMxRIM/ATUTNJmCI/A8el/GKmkWND67ICwgQIECAwGkJnMdyap61eZY/eNT8b/5fPbgaLyBAgAABAqcpkGdirSYgz/IHjWU8u1YxmXeIMAgQIECAAIHfzsSaZ+7yIcgv4sm1ilk9pBDPJUCAAAECMxBYxRprnbt5pt9rDPGsWkVk3sxvECBAgAABAu8Ehrg76dn7h3dzv72Xf5BQa3wfiTe1kstLgAABAgQ6FdhE3XlG1hr3Ottfxey1upCh1srkJUCAAAECnQsMUX+t8zfP9o+OIb5ba/LVR2f2TQIECBAgQGAVBLXO4eFjvMuKE599bGLfI0CAAAECBJ7kWVmrAVh+zPeq0sSbj03qewQIECBAgMBbgU3cq9EE5Bn/dnz4R4Bfvv1O2TursulkI0CAAAECJyuwqrSyO8/4MSas0XFkziHCIECAAAECBD4tMMRTap3H43b63SsAbx/cfrPQ7cvIsymUSxoCBAgQIHDqAptYYJ6dNca4TTpFA7DaTuaWAAECBAgQuJfA6l7PeviTxn0vqXW5YbFvMo8RIECAAAECdwrk2VnjXP7d/znQWaWJru9cmm8QIECAAAECHxPIM7RGE5Bn/pPtRwBvvvhYFQd+b33g67yMAAECBAjMXWBdCUADUAlWWgIECBAgUEJgXSLJnhzv/dKfk9S4zLDYM7GHCBAgQIAAgU8L5Bla42xe706dfxRQepLr3QncJ0CAAAECBB4skGdp6fP5zR8C5t8AZIeRUXqsSyeUjwABAgQIzExgXWG9b878bADOKiTPlJtKeaUlQIAAAQJzEdhUWui4vQJQI/91jaRyEiBAgACBGQlUO0tdAZjRT5GlEiBAgEB3AptKFb+5AlApt48AasHKS4AAAQKzEdjUWmmtKwC1/k8MajnIS4AAAQIEWhWocaae1fwbgFYh1UWAAAECBOYusMgGoMZY10gqJwECBAgQmKFAlT8EzAbgixliWjIBAgQIEOhF4KZCoZ/7CKCCqpQECBAgQKBxgaHWRwCNr1t5BAgQIEBg3gIagHnvv9UTIECAwEwFajUA65l6WjYBAgQIECgtUO2PAEsXKh8BAgQIECBQTqDGHwE+qXUFoNyyZSJAgAABAgSKC2gAipNKSIAAAQIE2hfQALS/RyokQIAAAQLFBTQAxUklJECAAAEC7QtoANrfIxUSIECAAIHiAhqA4qQSEiBAgACB9gU0AO3vkQoJECBAgEBxAQ1AcVIJCRAgQIBA+wIagPb3SIUECBAgQKC4gAagOKmEBAgQIECgfQENQPt7pEICBAgQIFBcQANQnFRCAgQIECDQvoAGoP09UiEBAgQIECguoAEoTiohAQIECBBoX0AD0P4eqZAAAQIECBQX0AAUJ5WQAAECBAi0L6ABaH+PVEiAAAECBIoLaACKk0pIgAABAgTaF9AAtL9HKiRAgAABAsUFNADFSSUkQIAAAQLtC2gA2t8jFRIgQIAAgeICGoDipBISIECAAIH2BTQA7e+RCgkQIECAQHEBDUBxUgkJECBAgED7AhqA9vdIhQQIECBAoLiABqA4qYQECBAgQKB9AQ1A+3ukQgIECBAgUFxAA1CcVEICBAgQINC+gAag/T1SIQECBAgQKC6gAShOKiEBAgQIEGhfQAPQ/h6pkAABAgQIFBfQABQnlZAAAQIECLQvoAFof49USIAAAQIEigtoAIqTSkiAAAECBNoX0AC0v0cqJECAAAECxQU0AMVJJSRAgAABAu0LaADa3yMVEiBAgACB4gIagOKkEhIgQIAAgfYFNADt75EKCRAgQIBAcQENQHFSCQkQIECAQPsCGoD290iFBAgQIECguIAGoDiphAQIECBAoH0BDUD7e6RCAgQIECBQXEADUJxUQgIECBAg0L6ABqD9PVIhAQIECBAoLqABKE4qIQECBAgQaF9AA9D+HqmQAAECBAgUF9AAFCeVkAABAgQItC+gAWh/j1RIgAABAgSKC2gAipNKSIAAAQIE2hfQALS/RyokQIAAAQLFBTQAxUklJECAAAEC7QtoANrfIxUSIECAAIHiAhqA4qQSEiBAgACB9gU0AO3vkQoJECBAgEBxAQ1AcVIJCRAgQIBA+wIagPb3SIUECBAgQKC4gAagOKmEBAgQIECgfQENQPt7pEICBAgQIFBcQANQnFRCAgQIECDQvoAGoP09UiEBAgQIECguoAEoTiohAQIECBBoX0AD0P4eqZAAAQIECBQX0AAUJ5WQAAECBAi0L6ABaH+PVEiAAAECBIoLaACKk0pIgAABAgTaF9AAtL9HKiRAgAABAsUFNADFSSUkQIAAAQLtC2gA2t8jFRIgQIAAgeICGoDipBISIECAAIH2BTQA7e+RCgkQIECAQHEBDUBxUgkJECBAgED7AhqA9vdIhQQIECBAoLiABqA4qYQECBAgQKB9AQ1A+3ukQgIECBAgUFxAA1CcVEICBAgQINC+gAag/T1SIQECBAgQKC6gAShOKiEBAgQIEGhfQAPQ/h6pkAABAgQIFBfQABQnlZAAAQIECLQvoAFof49USIAAAQIEigtoAIqTSkiAAAECBNoX0AC0v0cqJECAAAECxQU0AMVJJSRAgAABAu0LaADa3yMVEiBAgACB4gIagOKkEhIgQIAAgfYFNADt75EKCRAgQIBAcQENQHFSCQkQIECAQPsCGoD290iFBAgQIECguIAGoDiphAQIECBAoH0BDUD7e6RCAgQIECBQXEADUJxUQgIECBAg0L6ABqD9PVIhAQIECBAoLqABKE4qIQECBAgQaF9AA9D+HqmQAAECBAgUF9AAFCeVkAABAgQItC+gAWh/j1RIgAABAgSKC2gAipNKSIAAAQIE2hfQALS/RyokQIAAAQLFBTQAxUklJECAAAEC7QtoANrfIxUSIECAAIHiAhqA4qQSEiBAgACB9gU0AO3vkQoJECBAgEBxAQ1AcVIJCRAgQIBA+wIagPb3SIUECBAgQKC4wB+LZ+wv4d/3V3LzFf//qPB/NV+lAgkQIDBjAQ3Akyf/fcb7X2vp/6lWYnkJECBAoIyAjwDKOMpCgAABAgS6EtAAdLVdiiVAgAABAmUENABlHGUhQIAAAQJdCWgAutouxRIgQIAAgTICGoAyjrIQIECAAIGuBDQAXW2XYgkQIECAQBkBDUAZR1kIECBAgEBXAhqArrZLsQQIECBAoIyABqCMoywECBAgQKArAQ1AV9ulWAIECBAgUEZAA1DGURYCBAgQINCVgAagq+1SLAECBAgQKCOgASjjKAsBAgQIEOhKQAPQ1XYplgABAgQIlBHQAJRxlIUAAQIECHQloAHoarsUS4AAAQIEyghoAMo4ykKAAAECBLoS0AB0tV2KJUCAAAECZQQ0AGUcZSFAgAABAl0JaAC62i7FEiBAgACBMgJ/LJOm6yyfdV294gkQIECAwAECrgAcgOYlBAgQIECgdwENQO87qH4CBAgQIHCAgAbgADQvIUCAAAECvQtoAHrfQfUTIECAAIEDBDQAB6B5CQECBAgQ6F1AA9D7DqqfAAECBAgcIKABOADNSwgQIECAQO8CGoDed1D9BAgQIEDgAAENwAFoXkKAAAECBHoX0AD0voPqJ0CAAAECBwhoAA5A8xICBAgQINC7gAag9x1UPwECBAgQOEBAA3AAmpcQIECAAIHeBTQAve+g+gkQIECAwAECGoAD0LyEAAECBAj0LqAB6H0H1U+AAAECBA4Q0AAcgOYlBAgQIECgdwENQO87qH4CBAgQIHCAgAbgADQvIUCAAAECvQtoAHrfQfUTIECAAIEDBP54wGtO7SW/3i7of5zawqznpAQ+i9X8/UmtyGKmEhhios8jziIWEduRX99EbLYPxO11RD72c8QmYuqRNf1NxHAbcfNmjPHPzW3EzZuxiX9m/BSRNRsPFNAAvAPz5vrOwr32BP6lvZJU1KDAImr6MmKMyMM0bw8dm3jh9W2s4/ZlRMkxRLIvIrZ1jnH/0HETL8xa17dRutZIe5ojfwMuHWNHVKXXLl/5nyemT564QtXRm8rEpQ4x3zcRryJq/m/ll8j/POKriEPHIl74NGKKWn+IeR5T66FrrPG6MZLW2NsqSbPYXkYNVDnr/LDO2VUD0Ms7ynR1Po2p8pA7xv8ufol5v4vI397vM45d6/Mo8r613mc9Uz9njAlr7HOVpFlsL6MGqpx1fljn7KoB6OUdpX6dT2OK1xGt/O/hRdQyRuwbPdW6r/5WHhujkBr7XSVpFtvLqIEqZ50f1jm7agB6eUepV+fTSP06otX/HTyP2oaIHK3X+iJqHLPQTsYYddbY9ypJs9heRg1UOev8sM7ZVQPQyztK+TrHSPkqooef//xDvL+LuOmk3vwYYxHR+hijwOL7/4fWV60+AgQIzFQgD6Y8oF5EnHVg8E+3df7PuB0ifoxofTyLAl9HnLdeaI36NAA1VOUkQIDA4wTywM+DPw+o1kf+e/h/G3GxU+hN3M9D9U8Rf9l5vMW7iyjqh4jnEXl/NkMDMJuttlACBDoRWEadvfzW/+eo9SziOmLfuIoHh4if9n2zsceWUU8v7kXoNABFGCUhQIBAEYH8LbSX30S/jlqf3WPVN/GcMeL7ezz32E85iwKyCTg/diFTzK8BmELZHAQIEPi0QB78y08/7ejPyEv6f4pYPaCSbAKWET00AYuoMz8SyHpPemgATnp7LY4AgQ4E8sB5FbHsoNY8/MeIqwNrXcbr8spBD6OXhuxgSw3AwXReSIAAgSICecn5rEimukm2h//1I6dZxes1AY9ELPFyDUAJRTkIECBwmED+ljmnw3+rtIo7f95+0fjtyV4J0AA0/pOnPAIETlagp4PlWezCY3/z/3AjM2cPfxOQdedejXnnlIYG4JR201oIEOhFYBmFZvQw8nL9qlKhy8j7slLu0mnzDwOH0kmPmU8DcEx9cxMgMEeBvOT/XScLz9/QV5VrPY/8+fcFrY9FFJhNwMkMDcDJbKWFECDQgUAeInk5OW9bHz9Hgc8mKPIm5jifYJ4SU5xFkssSiVrIoQFoYRfUQIDAXAQuYqF5iPQwllHkzUSFrmOeXv4o8JuodYzofmgAut9CCyBAoBOBMerMw6OHkYfxeuJCL2K+vOrQw8irON2PP3a/gnIL+JdyqWQiQIDA7wR6+dw/D+GL31Vf/4G82rCMeFF/qkfPMESGi9uIm37Hr1F66Rj75VA5AQIEigssI2Pp99la+bLWY451TF5rbSXz/hJ1DhFTjDEmKVn7NleVpFmsQYAAAQK/CbyOm+2bbsu3mwY2bOzEKvdxFTHFGGOS4j83/gZgiq0zBwECcxZYxuKHTgAuGqhzHTW8bKCO+5TwNJ60uM8TW3yOBqDFXVETAQKnJPBtJ4vJz/5XjdR60Ugd9ynj2X2e1OJzNAAt7oqaCBA4FYFlLGToZDEXDdW5jlp+bKiej5WS/2ZHl1cBNAAf21bfI0CAwOMEzh/38slenf8lvqvJZrvfRK3Vc1fVefj3ss/vrUED8B6HLwgQIFBMYIhMXxXLVjdRHrY3dad4cPasKRuTHkb+LUB3QwPQ3ZYpmACBTgR6+q0wD9vWRjYkLda1z2mMB4d932j5MQ1Ay7ujNgIEehbo5bfCFi//b/e9lwYg6z3fFt3LrQagl51SJwECPQksotizTgpu+ZDN2nr5GGDsZL/flqkBeEvhDgECBIoJjMUy1U+0rj/Fo2a4ftSrp3vxl9NNVWYmDUAZR1kIECCwKzDuftH4/dYP2HXjftvyFnFn3H7Rw60GoIddUiMBAr0JnHVUsAag3GaN5VLVz6QBqG9sBgIE5ifQy+XgHv6Tu603KLs/3cPuF63f1wC0vkPqI0CgN4Gho4LXHdR6EzXmf6a4hzH0UOS2Rg3AVsItAQIEyggMZdJMkmUzySyPn6SXOr94/FKny6ABmM7aTAQIzEOgp8//N51sSV4F6GEseihyW6MGYCvhlgABAmUEujoEyiy5epbr6jOUm2Asl6puJg1AXV/ZCRAgQIBAkwIagCa3RVEECBCYRKCn36wnAZnTJBqAOe22tRIgMIXAOMUkhea4KZSndppN7QnmmF8DMMddt2YCBAgQ6Emgyt+V1GoAxp5k1UqAAIGCAuuCuWqnqnKwVCh6qJCzp5RnNYqt1QDUqFVOAgQIECgrUOVgKVuibLUENAC1ZOUlQIAAAQINC2QD0Mt/YrFhRqURIEDgrcDN23vulBLo6UrFutSiK+f5ORuATeVJpCdAgMCcBK47WuzQSa2LTur8S6U6a6x/U+sjgLESgrQECBBoXWDTeoE79Q0791u++3nLxe3UVqv5O9uZo9jdbABuimWTiAABAgQ2HRGMHdSav/0OHdSZJW46qTPLvMkGoEbH0sv/F3ZHe6VUAgQ6Evipk1p7eK+u8ttvpf3ZVMpbY5+ua30EkAZDJQhpCRAg0LrAuvUCd+pr/YAdd2pt/e5VhQKHCjnfpKx1BSCTD29m8A8CBAjMT2Dd0ZI1AGU2K/8A8LpMqveyDO99Ve6Ldc2/AWj9h6oco0wECBB4X2D9/pdNfzU2Xd2TJ180Xt+2vPX2TuHbamepKwCFd0o6AgQIhMBNRC9/B/BVwzt2HrUtGq5vt7T17hcF7w8Fc+2mensFoMa/u1jjjxZ2i3efAAECLQusWi5up7Y8YPOgbXG0Wtc+q6t9DxZ4rMZZ+t6Zv44if60Q+YNlECBAYI4CQyy6xvtqjZyrBjcoz49fOjFcV/JLgxr7/abe7b8FcF2p+LFSXmkJECDQusAmCvyx9SJv63sat639wnbeYE13befqrm888vHxka+/6+VvznwNwF08HidAgMDjBa4en2KyDHngtjSyKelh5OX0Wvs8VgJ40wBsc5/FnRqXGV5tJ3BLgACBmQpsYt013l9L53zd0P6MnZjlHlxE1Bp5hpbe58yXZ/57o8YkmXPx3iy+IECAwLwElrHcWu+vpfNmrS2MF1FE6bXVylfrjMu8NWq+2bfB60qTLfdN5jECBAjMSGATa63xZl465+sG9mTsxCrtVxG1xjISl97fzLeO+N24iEdqTPbidzN5gAABAvMSWMZya7y/1siZtR5z5JlRY12lc+Zv0kNFqFqX/y/21TzGg6WBtvmGfRN6jAABAjMSuI61bt8TW759HXXm5edjjDEmbdlmt7aLikBDRYfxrrqzo9ldYKn7F3dN6HECBAjMROAs1lnqPbV2nssj7Ek2Ha87Mbqu7HNRyeHmY3VfVZo0N9UgQIDA3AUuA6D24V0q/zjxZrF5B16rEcoz/s6xjO+U+uH5MM/ZnbP6BgECBOYhsIhlXkd8+P7Y4tevo86sd4pxHpO0aLCvpsvKIGcVLZYfq32oOPHqYxP7HgECBGYikG/wNxH7DpfWHvthgj1ZxBy/dOJxPYHHqqLF8Kn6c4G1fgg/OfmnivN9AgQInIDAMtZQ6322dN6steao9dfupR2yaRtqQtzmL133Nt+9mpdnUcT2BaVvV5XxpCdAgEAvAqsotPR7bK18y0qozzsyGCsZ7KZdxRe19jDP9k+OIZ5Rq4DMm/kNAgQIEPjtPyRT8/22VO68RH9WeMOeR75S9dXOsyy89n3phniw5joy/73GVTyrViGre1XgSQQIEJiHwHUss9b7bcm8JZuAZSdrTr+sdYqxiklK7tdurjzT7z2W8czdF5e+P9y7Ek8kQIDAaQssYnlzagK+ifWWPlNq5VtO9KM3VDZ58DpuKhb0Q+Q2CBAgQOCdwCru1jrISubNKwHn78p+0L3nnawxvZYPWtnjnpxnYsk92s2VZ/mDx2W8YjdJ6fvjgyvyAgIECJy2wCqWV/q9tla+5QO2YhHPrXnIlVxjHpjnD1jbY5+ac5Ws/8Ncl4cUOFQu6nXkXxxSmNcQIEDghAWWsbabiA/fyFv8+rt77MMQz3nVyXquo86ziKlGnoF5Ftbc2+HQxVxVLuzi0MK8jgABAicskIfQdUTNg6FU7jzcs95945t48JeIUnPVzLOKOhcRU46LmKzmmq4es5ixcnG58CHCIECAAIH3BfIwuoyoeUCUzP3tTvlZ+w+d1H4TdZ7v1D7V3SEmKum/L9f42MWsKxeZ3aNBgAABAvsFzuLh64h9b/CtPZbv538X0ctv/ZdR6yLiGCOtau7fusSizisXmQC5CQYBAgQI3C2wjG9tImoeGo/JvYrahogcy4hNxGPy1XztOmobI4418syrub7MPZZa3DoS1S42Gw2DAAECBD4usIxvbyJqvyffN/9V1DJE7BvLeHATcd9ctZ+3jlrGiGOOPOumWGexNY4TFJyXjIYIgwABAgQ+LbCMp+ThW/sw2Zd/E/NeRpxF3GfkoXesWm9i7lXEfWuNp1YbQ2Se4uORsfQK1pFw3w9CycfyM5FF6cLlI0CAwAkLDLG2ZxHXESXfjz/MdRP5VxHnEYeORbxwGbGO+DB/ya+z1quIx9QaLy86cu21P/dPw3XRqm+TjXFbcoPuyvW8RvFyEiBAYAYCecjkoXcZsY646332Po9v4vVXEc8ixojSY4iEWetFxDriJuI+de17Tr42c1xEnEW0OJ5HUftqL/3Yvdf/2QOVVvH8pw98zSFPz3m+PuSFXkOAAAEC7wkM8VVGHgyLiO3Ir28iNtsH4nZ9e/86bvN7U4+saREx3EbcvBlj/HNzG3HzZmzinxnriNZHHv7LCYr8vuY8uTH5Q1G6Y9mX73ICLFMQIECAAIGaAnmW7TvjSj+WZ/Oi5kIy90VE6cLvyreMuQwCBAgQINCjwDKKvut8K/34s6mAridcVAIaBAgQIECgJ4FlFFv6kL8rX57Jk42zmOmuQmo8/u1kKzMRAQIECBB4nECeWTXOwrty5pk86biI2e4qpsbjzyddnckIECBAgMDDBfKsqnEG3pXz4uEllnnFlB8F5OIT1iBAgAABAi0K5Bl110Fd4/FJL/1/CJ6XHW4mXrD/WNCHu+BrAgQIEDimwCImn+I/8rPbROTZOxxz0Tn3s4jdoqa4/0vMOUYYBAgQIEDgmAJjTJ5n0hRn3+4cefY2MVZRxW5hU93/tonVK4IAAQIE5iiQZ9BU593uPKuWsPPyx/WRIF7EvDm/QYAAAQIEphDIMyfPnt1Dear7edY2d+adRVE3RwLJyy9PIwwCBAgQIFBTIM+aY1zyzwYjz9ghoslxHlVN1QXtm+dFzJ+NiEGAAAECBEoK5NmSZ8y+s2eqx/KMbXoso7qpMO6a57uoYdG0kuIIECBAoAeBPEvyTLnrvJnq8WUPWFnjZcRUKHfN42OBXn5a1EmAAIH2BPLgfxpxrMv9u2dbnqldjVVUu7uAY93Pzfs2IjfTIECAAAECHxPIsyLPjBYO/jw3VxFdjlVUfayD/8N5NQJd/ggpmgABApMItHbwd334b3fsOu58eBgf++vnUdNX2wLdEiBAgMBsBfIsyDPh2OfSh/OvT2FHsqtqsQlI7NcR30WcRRgECBAgMA+BfM/P9/48Az48eFv4Os/MRcRJjFzIVUQLsHfV8Crqyx+IryJOBj7WYhAgQGDuAvmenu/t+R7/KuKuc6CFx1dR30mOVayqBeD71JA/JPnD8lXEEGEQIECAQB8CZ1Fmvnfne/iriPu857fwnFXUOtn4bLKZ3k20irtP333Z1b3rqPYmYh2xuY24eTP+Ev/M7xsECBAgUE8gD/e/2Uk/xP2MMWIRkd/vcXwfRS+nLPwYDUCu71lEdmYGAQIECBCYu8DXAbCaGuGvpp7wdr7/Hbc/R/zHiL++fcwNAQIECBCYk0BeOf7PEatjLPpYVwC2a81LNVcRn28fcEuAAAECBGYgkL8En0dcH2utfzjWxLfz5sLPIl4euQ7TEyBAgACBqQR+jIny7Dva4Z8LPdZHADn3dvxr3FlF5NWIMcIgQIAAAQKnKvBPsbB/jMiz76gjD92WxhjFrCJ8JBAIBgECBAicjMDPsZLziKP+1r+reeyPAHZryfvriLws8n2EQYAAAQIETkEgz7Q825o5/BO1tSsAWdN2jHFnFeFqQCAYBAgQINCdQP7Wv4xYRzQ3WvgbgLtQNvGNVcS/i/gPEQYBAgQIEOhF4M9R6D9E/N9WC275CsCuWV46uYz4cvdB9wkQIECAQGMCL6OeZxFNXe7fZ9RLA7Ct/TzuZCPgY4GtiFsCBAgQaEEgL/fnwX/VQjH3qaHljwD21Z+XUrIByMblbyP8VwQDwSBAgACBowls/2t+y6ig2cv9+3R6uwKwu4ZFfJHdVsbu/zHE7nPcJ0CAAAECNQTy4M9fSDNuakxQO2fPDcDWZhF3ziMuInw0EAgGAQIECFQTyEv9FxFXEV0e/FH3m3EKDcB2LXm7vA1/LJgaBgECBAiUEngZiVa3USrnUfOcWgOwxRzizrOIZYSPBwLBIECAAIEHC+Rl/lXEZcQm4qTGqTYAu5t0Hl9sQzOwK+M+AQIECHwokIf+1U58+P2T+XoODcDuZm0bgbzVDOzKuE+AAIH5Cszm0N/d4rk1ALtrP4svshEYI/zNQCAYBAgQmJHAy1jrOuIq4jpidmPODcCHm50NwXgbQ9x+EWEQIECAQP8CP8USNhHr25jlgR9rf29oAN7j+N0XYzwy7An/umGgGAQIEGhI4OeoZfNB5EHvsA+EfUMDsE/l/o8t4qln93+6ZxIgQIBAQYE83G8K5pOKAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECjQv8G9X8pQ34x9PWAAAAAElFTkSuQmCC"/>
                                                    </defs>
                                                </svg>

                                            </div>
                                            <div class="d-flex flex-column">
                                                <span class="user-role mb-2">Payment method</span>
                                               <span class="text-capitalize">${paymentMethod?.payment_details?.brand || 'Credit card'} ending in ${paymentMethod?.payment_details?.last4}</span>
                                                <span class="${!paymentMethod?.payment_details?.exp_month ? 'd-none' : ''}">
                                                Expires ${paymentMethod?.payment_details?.exp_month && parseInt(paymentMethod?.payment_details?.exp_month) < 10 ? '0' + paymentMethod?.payment_details?.exp_month : paymentMethod?.payment_details?.exp_month}/${paymentMethod?.payment_details?.exp_year}</span>
                                            </div>
                                            <div class="align-self-start ${cancelledBox ? 'd-none' : ''}" style="margin-left: auto">
                                                <button class="edit-button text-decoration-underline mb-4" style="margin-left: auto" 
                                                data-modal-opener="${paymentMethod.processor_name === 'shopify_payments' ? 'shopify_payments' : 'payment-form'}">Edit
                                                </button>
                                            </div>
                                        </div>
                                        <div class="payment_success d-none" data-payment-edit-success>Payment method successfully updated</div>
                                    </div>
                                    <div class="edit-form d-none" data-shipping-edit-form>
                                        <div>
                                            <div class="d-flex justify-content-between">
                                                <div class="d-flex align-items-center user-role">
                                                    <div style="margin-right: 12px;">
                                                        <img width="32.1" height="21px" style="max-width: unset"
                                                             src="https://cdn.shopify.com/s/files/1/1412/6778/files/image_21_1.png?v=1720431323"
                                                             alt="">
                                                    </div>
                                                    <span>Ships to</span>
                                                </div>
                                                <button class="bg-white border-0" data-shipping-close>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                         viewBox="0 0 13 13" fill="none" style="margin-right: -18px;">
                                                        <line x1="0.353553" y1="0.646447" x2="12.3536" y2="12.6464"
                                                              stroke="black"/>
                                                        <line y1="-0.5" x2="16.9706" y2="-0.5"
                                                              transform="matrix(-0.707107 0.707107 0.707107 0.707107 13 1)"
                                                              stroke="black"/>
                                                    </svg>
                                                </button>
                                            </div>

                                            <div class="mt-3 pt-1">
                                                <div class="user-input-wrp" data-input-container>
                                                    <input type="text" class="inputText" data-shipping_address="first_name" required value="${address.first_name || ''}"/>
                                                    <span class="floating-label">Name</span>
                                                </div>

                                                <div class="user-input-static" data-input-container>
                                                    <span class="floating-label mb-3">Country/Region</span>
                                                     <input type="text" class="inputText d-none" data-shipping_address="country_code" required value="${address?.country_code === 'CA' ? 'Canada' : 'United States'}"/>
                                                    <span class="inputText">${address?.country_code === 'CA' ? 'Canada' : 'United States'}</span>
                                                </div>

                                                <div class="user-input-wrp" data-input-container>
                                                    <input type="text" class="inputText" data-shipping_address="address1" required value="${address?.address1 || ''}"/>
                                                    <span class="floating-label">Address Line 1</span>
                                                </div>

                                                <div class="user-input-wrp" data-input-container>
                                                    <input type="text" class="inputText" data-shipping_address="address2" value="${address?.address2 || ''}"/>
                                                    <span class="floating-label">Address Line 2</span>
                                                </div>

                                                <div class="user-input-wrp" data-input-container>
                                                    <select class="inputText" required data-shipping_address="province">
                                                     ${this._provinceList().map(province =>
                    `<option value="${province}" ${province === address.province ? 'selected' : ''}>${province}</option>`
                ).join('')}
                                                    </select>
                                                    <label class="floating-label">State</label>
                                                    <div style="position: absolute;top: 14px;right: 12px">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7"
                                                             viewBox="0 0 12 7" fill="none">
                                                            <line x1="0.353553" y1="0.646447" x2="6.35355" y2="6.64645"
                                                                  stroke="black"/>
                                                            <line y1="-0.5" x2="8.48528" y2="-0.5"
                                                                  transform="matrix(-0.707107 0.707107 0.707107 0.707107 12 1)"
                                                                  stroke="black"/>
                                                        </svg>
                                                    </div>
                                                </div>

                                                <div class="user-input-wrp" data-input-container>
                                                    <input type="text" class="inputText" data-shipping_address="city" required value="${address?.city || ''}"/>
                                                    <span class="floating-label">City</span>
                                                </div>

                                                <div class="user-input-wrp" data-input-container>
                                                    <input type="text" class="inputText" maxlength="5" data-shipping_address="zip" required value="${address?.zip || ''}"/>
                                                    <span class="floating-label">Zip Code</span>
                                                </div>

                                                <div class="user-input-wrp" data-input-container>
                                                    <input type="text" class="inputText" data-shipping_address="phone" required 
                                                    value="${this._formatPhone(address?.phone)}"/>
                                                    <span class="floating-label">Phone Number</span>
                                                </div>

                                                <button class="subscription-ship-now text-capitalize disabled" style="width: 100%;margin: 13px 0 21px 0" data-change-shipping_address>
                                                     <span class="add-text" data-link-category="SUBPORTAL" data-link-subcategory="UPDATEAddress" data-link-text="Update">Save Changes</span>
                                                     <span class="spinner"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                  <div class="payment-form d-none" id="editPaymentCard" data-payment-form>
                                    ${this.querySelector('[data-edit-form-skeleton]')?.innerHTML}
                                  </div>
                                    <div class="footer-box d-flex align-items-center text-decoration-underline merge_box ${!cancelledBox && (!chargeError || pendingAttempt) && !skippedBox && this._mergeBoxRequired() ? '' : 'd-none'}" ${realIndex == 0 ? `data-tutorial-guide-stepv2="2"` : ``}>
                                        <span class="cursor-pointer" data-modal-opener="merge-box">Merge boxes</span>
                                        <a class="wx-tooltip font-termina price-lock-tooltip" 
                                                   style="height: 17px; width: 17px;"
                                                   data-link-category="SUBPORTAL" data-link-subcategory="ToolTipLOCK"
                                                   data-link-text="">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" style="margin-left: 11px"
                                                         fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                              fill="#0E8533"/>
                                                        <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                                    </svg>
                                                    <span class="wx-tooltip-text font-termina skip_box_icon">
                                                    <span>Got multiple subscription boxes?</span>
                                           Simplify your experience by merging them into just one box. Click ‘Merge boxes’ to combine your subscriptions and enjoy easy management.
                                        </span>
                                                </a>
                                    </div>
                                    
                                    <div class="footer-box d-flex align-items-center text-decoration-underline merge_box ${cancelledBox || !next_charge_date || (!pendingAttempt && preChargeDate) ? 'd-none' : ''}"
                                     data-tutorial-guide-stepv2="3">
                                       <span class="cursor-pointer ${!next_charge_date || (!pendingAttempt && preChargeDate) ? 'disabled' : ''}" data-modal-opener="skip-modal">Skip this box</span>
                                        <a class="wx-tooltip font-termina price-lock-tooltip"
                                           style="height: 17px; width: 17px;"
                                           data-link-category="SUBPORTAL" data-link-subcategory="ToolTipLOCK"
                                           data-link-text="">
                                            <svg width="16" height="16" viewBox="0 0 16 16" style="margin-left: 11px"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                      fill="#0E8533"/>
                                                <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                            </svg>
                                            <span class="wx-tooltip-text font-termina skip_box_icon" style="top: -460%!important;">
                                           By clicking “Skip this box”, this order will not be placed and you will not be charged. This only applies to that single Box, all other pending orders will still be processed.
                                        </span>
                                        </a>
                                    </div>
                                   
                                   <div class="footer-box d-none align-items-center text-decoration-underline merge_box cancel_subscription ${cancelledBox ? 'd-none' : ''}" ${realIndex == 0 ? `data-tutorial-guide-stepv2="2"` : ``}>
                                        <span class="cursor-pointer" data-modal-opener="cancel-box">Cancel subscription</span>
                                        <a class="wx-tooltip font-termina price-lock-tooltip" 
                                                   style="height: 17px; width: 17px;"
                                                   data-link-category="SUBPORTAL" data-link-subcategory="ToolTipLOCK"
                                                   data-link-text="">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" style="margin-left: 11px"
                                                         fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                              fill="#0E8533"/>
                                                        <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                                    </svg>
                                                    <span class="wx-tooltip-text font-termina skip_box_icon"> 
                                            By cancelling your
                                            subscription, this box will not be shipped and you will lose all your add-ons. To remove individual items or
                                            subscriptions, click edit on the product card.
                                        </span>
                                                </a>
                                    </div>
                                    
                                </div>
                                <div class="collapse-order cursor-pointer text-nowrap" data-collapse-order="${cancelledBox ? '0' : '1'}" ${realIndex == 0 ? `data-tutorial-guide-stepv2="5"` : ``}>
                                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <line y1="-0.5" x2="8.48528" y2="-0.5"
                                              transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 0 6.00003)"
                                              stroke="black"/>
                                        <path d="M11.6465 6.35358L5.64648 0.353577" stroke="black"/>
                                    </svg>
                                    <span data-collapse-text>${cancelledBox ? 'View order' : 'Collapse order'}</span>
                                </div>
                            </div>
                            <div class="w-100">
                                <div class="right-data ${cancelledBox ? 'd-none' : ''}" data-subscription-items ${realIndex == 0 ? `data-tutorial-highlight="1"` : ``}>
                                ${this._prepareAddressSubscriptionContainer(addressRelatedSubscriptions, address)}
                                </div>
                                <div class="add-product-button ${cancelledBox ? 'd-none' : ''}">
                                    <div>
                                        <img src="https://cdn.shopify.com/s/files/1/1412/6778/files/Group_29_1.png?v=1720702930"
                                             alt="">
                                    </div>
                                    <div class="cursor-pointer ${(chargeError && !pendingAttempt) ? 'disabled' : ''}" data-modal-opener="item-add">Add Products</div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                html += finalHtml;
                realIndex++;
            }
        });

        let subscriptionContainer = this.querySelector('[data-desktop-subscription-container]');
        subscriptionContainer && (subscriptionContainer.innerHTML = html);
    }

    _prepareMobileViewSubscriptionHtml() {
        let html = `<div class="subscription-mobile-table mt-3">
                        <custom-accordion class="d-flex flex-column">`;
        let realIndex = 0;
        allAddresess.forEach((address, i) => {
            let id = address.id;
            let addressRelatedSubscriptions = allSubscriptions.filter((subscription) => subscription.address_id == id);
            let addressRelatedCancells = allCancelledSubscriptions.filter((subscription) => subscription.address_id == id);
            let addressRelatedAddons = allAddons.filter((addon) => addon.address_id == id);
            addressRelatedSubscriptions = [...addressRelatedSubscriptions, ...addressRelatedAddons]
            let isOpenTab;

            let activeBox = addressRelatedSubscriptions.length > 0;
            let cancelledBox = addressRelatedCancells.length > 0 && addressRelatedSubscriptions.length <= 0;
            if (activeBox || cancelledBox) {
                if (currentAddress && Object.keys(currentAddress).length && successModal !== 'cancel') {
                    isOpenTab = currentAddress.id === address.id;
                } else {
                    isOpenTab = (realIndex === 0)
                }

                let next_charge_date = null;
                let preChargeDate = '';
                let total = null;
                let chargeError = null;
                let pendingAttempt = null;
                let shippingError = null;
                let cancelledDate = null;
                let skippedBox = null;
                let paymentMethod = allPayments.find((payment) => payment.id == address.payment_method_id) || false;

                if (activeBox) {
                    next_charge_date = addressRelatedSubscriptions[0].next_charge_scheduled_at;
                    if (next_charge_date != null) {
                        next_charge_date = moment(next_charge_date).format('MMM Do')
                    }
                    allCharges.forEach(charge => {
                        if (charge.address_id == id && charge.status === "skipped") {
                            preChargeDate = moment(charge.scheduled_at).format('MMM Do');
                        }
                    })
                    total = addressRelatedSubscriptions.reduce((acc, obj) => acc + parseFloat(obj.price), 0);
                    chargeError = this._showChargeError(address.id) != false;
                    pendingAttempt = this._showChargeError(address.id) === CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT;
                    shippingError = this._showChargeError(address.id) === INVALID_SHIPPING_ADDRESS;
                    skippedBox = !pendingAttempt && next_charge_date && preChargeDate;
                }

                if (cancelledBox) {
                    cancelledDate = addressRelatedCancells[0].cancelled_at;
                    if (cancelledDate) {
                        cancelledDate = moment(cancelledDate).format('MMMM Do');
                    }
                }

                let sortedOrder = this._sortedOrderOfAddress(address.id);
                let finalHtml = `
                    <div class="accordion__container ${isOpenTab ? 'open' : ''} ${realIndex === 0 ? 'active_merge_box' : ''} ${cancelledBox ? 'cancelled_box' : ''}" data-single-container="${address.id}" 
                    data-merge-box="${realIndex === 0 ? '1' : '0'}" data-charge-error="${chargeError || skippedBox ? 1 : 0}" style="order: ${sortedOrder ? sortedOrder : 5 }">
                        <div class="success-toast-message d-none" data-success-message>  
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                              <circle cx="9" cy="9" r="8" stroke="black" stroke-width="2"/>
                              <path d="M7.61246 10.4742L5.78479 8.6976L5 9.46048L7.61246 12L13 6.76288L12.2152 6L7.61246 10.4742Z" fill="black"/>
                            </svg>
                            <span style="flex:1" data-message-text>Successfully skipped.</span>                    
                        </div>  
                        <a class="no-hover accordion__toggle"
                           href="javascript:void(0);" title="Open new-subscription-box"
                           rel="nofollow" aria-label="Open new-subscription-box"
                           role="button"
                           aria-expanded="${isOpenTab ? 'true' : 'false'}"
                           aria-controls="new-subscription-box"
                           data-link-category="subscription-box" data-link-subcategory="OpenAccordion"
                           data-link-text="new-subscription-box"
                        >
                            <div class="accordion_activator">
                                <div class="d-flex justify-content-between heading">
                                    ${preChargeDate ? `<div class="d-flex flex-column" style="gap: 11px">
                                        <div class="d-flex" style="gap: 2px"><span>Skipped date:</span><span class="text-gray-600 fw-semibold">${preChargeDate}</span></div>
                                        </div>
                                    ` 
                                : `<div class="d-flex" style="gap: 3px">
                                        <span>${cancelledBox ? 'Cancelled on:' : 'Ship date:'}</span>
                                        <span class="fw-semibold text-success">${cancelledDate || next_charge_date || '-'}</span>
                                    </div>` }
                                    <div class="text-decoration-underline view-order-text" data-tutorial-guide-stepv2="5" data-view-more-mobile="${isOpenTab ? 1 : 0}">
                                        ${isOpenTab ? 'Collapse' : 'View Order'}<i
                                                class="fa fa-thin fa-chevron-down f-12 ms-2 view-order-icon"
                                                aria-hidden="true"></i>
                                    </div>
                                </div>

                                <div class="d-flex heading ${!preChargeDate ? 'd-none' : ''}">
                                    <span>Next ship date:</span>
                                    <span class="fw-semibold text-success">${next_charge_date || '-'}</span>
                                </div>
                                <div class="d-flex heading">
                                    <span>Frequency:</span>
                                    <span class="fw-semibold">Monthly</span>
                                </div>

                                <div class="d-flex heading merge-box_adjust flex-wrap">
                                    <span>Order total:</span>
                                    ${cancelledBox ? `<span class="fw-semifold ${cancelledBox ? '' : 'd-none'}">-</span>`
                                        : `<span class="fw-semibold ${!cancelledBox ? '' : 'd-none'}">$${total.toFixed(2)}  (${addressRelatedSubscriptions.length} ${addressRelatedSubscriptions.length > 1 ? 'items' : 'item'}) </span>`}
                                    
                                    
                                    ${preChargeDate ? `<span class="bg-white px-3 skipped-bedge" style="margin-left: auto">SKIPPED</span>` : `<span class="price-discount-bedge" style="margin-left: auto">SAVE 25%</span>`}
                                </div>

                                <div class="d-flex align-items-center justify-content-between merge_box_exempt"
                                     style="gap: 12px">
                                     ${skippedBox ?
                    `<button class="subscription-ship-now flex-grow-1" data-modal-opener="unskip-modal">
                                                            <span class="add-text text-uppercase">UNSKIP</span>
                                                            <span class="spinner"></span>
                                                        </button>` :
                    `<button class="subscription-ship-now flex-grow-1 ${!next_charge_date && !pendingAttempt && !cancelledBox ? 'disabled' : ''}" ${cancelledBox ? `data-modal-opener="item-add"` : `data-modal-opener="ship-now" data-tutorial-guide-stepv2="1"`}>
                                            ${cancelledBox ? `RE-ACTIVATE` : `Ship now`}
                                    </button>`}
                                    <svg class="cursor-pointer" width="16" height="16" viewBox="0 0 16 16"
                                         fill="none" xmlns="http://www.w3.org/2000/svg" data-modal-opener="${cancelledBox ? 're-activate-tooltip-modal' : (skippedBox ? 'unskip-tooltip-modal' : 'ship-now-tooltip')}">
                                        <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                              fill="#0E8533"/>
                                        <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                    </svg>
                                </div>
                            </div>
                        </a>
                        <div class="accordion__block toggle-content ${isOpenTab ? 'open' : ''}"
                             id="new-subscription-box"
                             data-type="content"
                        >
                        
                            <div class="accordion-description">
                               ${this._prepareAddressSubscriptionContainer(addressRelatedSubscriptions, address)}
                                <div class="add-product-button merge_box_exempt ${cancelledBox ? 'd-none' : ''}">
                                    <div>
                                        <img src="https://cdn.shopify.com/s/files/1/1412/6778/files/Group_29_1.png?v=1720702930"
                                             alt="">
                                    </div>
                                    <div class="cursor-pointer ${chargeError && !pendingAttempt ? 'disabled' : ''}" data-modal-opener="item-add">Add Products</div>
                                </div>

                                <div class="d-flex flex-column justify-content-between align-items-start merge_box_exempt ${cancelledBox ? 'd-none' : ''}" style="gap: 12px">
                                    <div class="footer-box d-flex align-items-center text-decoration-underline ${!next_charge_date || (!pendingAttempt && preChargeDate) ? 'd-none' : ''}" data-tutorial-guide-stepv2="3">
                                       <span class="cursor-pointer" data-modal-opener="skip-modal">Skip this box</span>
                                        <svg width="16" height="16" viewBox="0 0 16 16"
                                             style="margin-left: 6px" data-modal-opener="skip-tooltip-modal"
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                  fill="#0E8533"/>
                                            <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                        </svg>
                                    </div>

<!--                                    <div class="d-flex align-items-end flex-column" style="gap: 5px">-->
                                        <div class="footer-box d-flex align-items-center text-decoration-underline ${(!chargeError || pendingAttempt) && !skippedBox && this._mergeBoxRequired() ? '' : 'd-none'}" data-tutorial-guide-stepv2="2">
                                           <span class="cursor-pointer" data-modal-opener="merge-box">Merge boxes</span>
                                            <svg width="16" height="16" viewBox="0 0 16 16"
                                                 style="margin-left: 6px" data-modal-opener="merge-tooltip-modal"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                      fill="#0E8533"/>
                                                <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                            </svg>
                                        </div>
                                        <div class="footer-box d-none align-items-center text-decoration-underline ${cancelledBox ? 'd-none' : ''}" data-tutorial-guide-stepv2="2">
                                           <span class="cursor-pointer" data-modal-opener="cancel-box">Cancel subscription</span>
                                            <svg width="16" height="16" viewBox="0 0 16 16"
                                                 style="margin-left: 6px" data-modal-opener="cancel-tooltip-modal"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.07 7.96C7.88333 7.88 8.48333 7.76667 8.87 7.62C9.26333 7.46667 9.46 7.22667 9.46 6.9C9.46 6.59333 9.3 6.37667 8.98 6.25C8.66 6.11667 8.25667 6.05 7.77 6.05C6.70333 6.05 5.83667 6.43333 5.17 7.2L4.27 6.3C4.69667 5.84 5.20333 5.47333 5.79 5.2C6.37667 4.92667 7.04667 4.79 7.8 4.79C8.36 4.79 8.89 4.87 9.39 5.03C9.89667 5.18333 10.3067 5.41667 10.62 5.73C10.9333 6.04333 11.09 6.42667 11.09 6.88C11.09 7.45333 10.8367 7.90333 10.33 8.23C9.82333 8.55667 9.15667 8.75 8.33 8.81V9.77H7.07V7.96ZM7.69 12.12C7.41 12.12 7.18 12.0433 7 11.89C6.82667 11.73 6.74 11.53 6.74 11.29C6.74 11.05 6.82667 10.85 7 10.69C7.18 10.53 7.41 10.45 7.69 10.45C7.96333 10.45 8.18667 10.53 8.36 10.69C8.54 10.85 8.63 11.05 8.63 11.29C8.63 11.53 8.54 11.73 8.36 11.89C8.18667 12.0433 7.96333 12.12 7.69 12.12Z"
                                                      fill="#0E8533"/>
                                                <circle cx="8" cy="8" r="7.5" stroke="#0E8533"/>
                                            </svg>
                                        </div>
<!--                                    </div>-->
                                    
                                </div>

                                <div>
                                    <div class="mt-4">
                                        <span style="font-size: 15px">Your info:</span>
                                        <div class="table-item d-flex align-items-center mt-3">
                                            <div style="margin-right: 12px;">
                                                <svg class="merge_box_exempt" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <rect width="21" height="21" fill="url(#pattern0_4596_4082_${realIndex})"/>
                                                    <defs>
                                                    <pattern id="pattern0_4596_4082_${realIndex}" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0_4596_408" transform="scale(0.00390625)"/>
                                                    </pattern>
                                                    <image id="image0_4596_408" width="256" height="256" xlink:href="data:image/png;base64,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"/>
                                                    </defs>
                                                </svg>
                                                
                                                <img style="height: 21px; min-width: 21px" class="merge_box_only" src="https://cdn.shopify.com/s/files/1/1412/6778/files/svgviewer-png-output_3.png?v=1726080254" alt="">
                                            </div>

                                            <div class="d-flex flex-column">
                                                <span class="user-role">Name on order</span>
                                                <span class="text-capitalize">${address.first_name || ''}</span>
                                            </div>
                                        </div>
                                        <div class="table-item d-flex justify-content-between align-items-center mt-3">
                                            <div class="d-flex align-items-center w-100">
                                                <div style="margin-right: 12px;">
                                                    <svg class="merge_box_exempt" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <rect width="21" height="21" fill="url(#pattern0_4596_4072_${realIndex})"/>
                                                        <defs>
                                                        <pattern id="pattern0_4596_4072_${realIndex}" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                        <use xlink:href="#image0_4596_407" transform="scale(0.00195312)"/>
                                                        </pattern>
                                                        <image id="image0_4596_407" width="512" height="512" xlink:href="data:image/png;base64,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"/>
                                                        </defs>
                                                    </svg>
                                                    <img style="height: 21px; min-width: 21px" class="merge_box_only" src="https://cdn.shopify.com/s/files/1/1412/6778/files/svgviewer-png-output_1.png?v=1726080075" alt="">

                                                 </div>
                                                <div class="d-flex flex-column w-100">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-role">Ships to</span>
                                                        <button class="edit-button text-decoration-underline merge_box_exempt ${cancelledBox ? 'd-none' : ''}" data-modal-opener="edit-address">
                                                            Edit
                                                        </button>
                                                    </div>
                                                    <span style="padding-right: 50px" data-address-to-capitalize>
                                                        ${address?.address1} ${address?.address2 ? address?.address2 : ''}, ${address?.city || ''}, ${address?.province || ''}, ${address?.country_code || ''}, ${address?.zip || ''}
                                                            </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-item d-flex align-items-center justify-content-between mt-3 mb-3">
                                            <div class="d-flex align-items-center w-100">
                                                <div style="margin-right: 12px;">
                                                     <svg class="merge_box_exempt" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <rect width="21" height="21" fill="url(#pattern0_4596_4092_${realIndex})"/>
                                                        <defs>
                                                        <pattern id="pattern0_4596_4092_${realIndex}" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                        <use xlink:href="#image0_4596_409" transform="scale(0.00195312)"/>
                                                        </pattern>
                                                        <image id="image0_4596_409" width="512" height="512" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAACAKADAAQAAAABAAACAAAAAAAL+LWFAAArDklEQVR4Ae3dMXNjx5YY4NHbF6yjRehM9x+ImznTdb5V4kvWmw2UrSONf4G40Ybiy5wNFLnsDURVucrhYDI7GipzNlDoSHzlZDPtOSNiBjMCZ0iw+6Ib9+uqI4AgcPr013zowwtK78kTgwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB/gQ+66/kpioeoprPm6pIMQQIEJiPwM+x1M18llt2pRqAj3t+Gd8e7oiPv9J3CRAgQGBKgU1Mti9eTllET3NpAN7tVh72ZxFjxBCR9w0CBAgQ6F/gOpawiVhH5H1NQSDMuQHIA/6riPE24sYgQIAAgZkIrGOdGT9GZFMwuzG3BiAP/PPbWMxuty2YAAECBPYJ3MSDV7eRDcEsxhwaAIf+LH6ULZIAAQJFBGbTDJxqAzDEj8E3EcsIv+kHgkGAAAECDxbIZmAV8eeITcRJjVNrAJ7G7iwjxgiDAAECBAiUElhHolXE9xEnMU6hAcjf8PPgfxYxRBgECBAgQKCWwCYSX0Tk3wrkFYJuR88NQB78eZk/D/68bxAgQIAAgakE8vC/jMiPB/J+d6PHBiAPewd/dz9qCiZAgMBJCuThfxGRjUBXo7cGIC/1X0QMEQYBAgQIEGhFYBOF/JeIq1YK+lQdvTQAYyzk24i8NQgQIECAQKsC6ygsG4HrVgvc1vVX2zuN3ubl/n+O+K8RQ4RBgAABAgRaFhiiuH+MyPPr/0T8a0STo+UrAOch9l3E0KScoggQIECAwMcFNvHtryPWEc2NPzRX0W9d0/Oo64eIocH6lESAAAECBO4jMMSTXkTkmZZXBJoarV0BGEMnoYYIgwABAgQInIrAJhbyp4jrVhbU0t8AfBsoq4jmuqRWNksdBAgQINCtQJ5t+bcBOV7+dnPcf7ZwBSBR8nL/eFwKsxMgQIAAgUkE1jFLXg24mWS2OyY5dgNwFnX5rP+OzfEwAQIECJyswCZWdtSPBI75EcAyFv/fIv59hEGAAAECBOYkkFe//yHi/0VcH2Phx2oAvonF5r/b/9fHWLQ5CRAgQIBAAwJ5Bp5H3ETkfzNg0nGMjwDyr/yXk66y3GQ/RapNRHZreZuxHbmB+bhBgAABAvUEziL1Yif9EPcz8vG8/SKix7GKor/usfD71pyH/6+dRB7mlxHnEUOEQYAAAQJ9CAxRZr5353v4dUQv506ekSc3FrGi/GO/ljchf0jyh+U8Ius1CBAgQOA0BPI9Pd/bLyOuI1o+i7IJyHpPYuRCXkW0CL6JuvIH4izCIECAAIF5COR7fr73byJaPJvyzFxEdD1yAS0e/quo67xrWcUTIECAQAmBPAtWEa01Anl2dj3yUkYrqDdRy0VENiUGAQIECBDYFciz4SIiz4pWzq08Q7scrRz+Dv4uf3wUTYAAgaMItNYIdNcEtHD4b+JHZ3mUHx+TEiBAgMApCCxjEZuIX48clzF/F2MZVbaAlV2cQYAAAQIEHiOQZ0kewMc+15aPWcQUrz0/MtI65j+bYqHmIECAAIFZCeTZso44ZiOQZ2yTI3F+iTgGzk3Mu4wwCBAgQIBATYFlJM8z5xhnXZ6xedY2NRZRzbH+db91zJ3zGwQIECBAYAqBPHPWEcdoAvKsberM++FIEBcxr0GAAAECBI4hcBGTHqMJeH6Mxe6b89kRAG5iznFfMR4jQIAAAQITCowxV55JUzcCefYedZzF7PmZxJQLv475FkddtckJECBAgMA7gTyT8mya8izMs/fsXQnT38vPIqZc8Gr6JZqRAAECBAjcS2AVz5ryTMwz+CjjImadcqGro6zSpAQIECBA4P4Cq3jqlGfjxf1LK/PMvOww5QKflSlbFgIECBAgUF3gImaY8oyc9KOAKS/9L6tvlQkIECBAgEBZgWWkm6oJmOyjgIsJF5WABgECBAgQ6FFgGUVP1QRUv1K+iMX8MtGCLmMegwABAgQI9CyQZ9kUTUCezXlGVxuryDzFQnIegwABAgQInILAKhbR9dk59r6AqN8gQIAAAQLHEFjFpFM0AWc1FvdiguKvY46qlzBqwMhJgAABAgQ+IZBnW55xtZuAPKuLjjGy1S76JuYYIgwCBAgQIHCKAkMsKs+62ufpGHMUG9lR1C74vFi1EhEgQIAAgTYF8qyrfZ7mmV1kLCNL7WIvi1QqCQECBAgQaF8gz7za5+pYgiE7iZqFXpcoUg4CBAgQINCRQJ59Nc/WPLsfNcZ4dc0CM/cQYRAgQIAAgTkJDLHY2ufr+BjQ7CBqFnjxmOK8lgABAgQIdCxwEbXXPGOvDrUZKhe2ifyLCIMAAQIECMxRIM/ATUTNJmCI/A8el/GKmkWND67ICwgQIECAwGkJnMdyap61eZY/eNT8b/5fPbgaLyBAgAABAqcpkGdirSYgz/IHjWU8u1YxmXeIMAgQIECAAIHfzsSaZ+7yIcgv4sm1ilk9pBDPJUCAAAECMxBYxRprnbt5pt9rDPGsWkVk3sxvECBAgAABAu8Ehrg76dn7h3dzv72Xf5BQa3wfiTe1kstLgAABAgQ6FdhE3XlG1hr3Ottfxey1upCh1srkJUCAAAECnQsMUX+t8zfP9o+OIb5ba/LVR2f2TQIECBAgQGAVBLXO4eFjvMuKE599bGLfI0CAAAECBJ7kWVmrAVh+zPeq0sSbj03qewQIECBAgMBbgU3cq9EE5Bn/dnz4R4Bfvv1O2TursulkI0CAAAECJyuwqrSyO8/4MSas0XFkziHCIECAAAECBD4tMMRTap3H43b63SsAbx/cfrPQ7cvIsymUSxoCBAgQIHDqAptYYJ6dNca4TTpFA7DaTuaWAAECBAgQuJfA6l7PeviTxn0vqXW5YbFvMo8RIECAAAECdwrk2VnjXP7d/znQWaWJru9cmm8QIECAAAECHxPIM7RGE5Bn/pPtRwBvvvhYFQd+b33g67yMAAECBAjMXWBdCUADUAlWWgIECBAgUEJgXSLJnhzv/dKfk9S4zLDYM7GHCBAgQIAAgU8L5Bla42xe706dfxRQepLr3QncJ0CAAAECBB4skGdp6fP5zR8C5t8AZIeRUXqsSyeUjwABAgQIzExgXWG9b878bADOKiTPlJtKeaUlQIAAAQJzEdhUWui4vQJQI/91jaRyEiBAgACBGQlUO0tdAZjRT5GlEiBAgEB3AptKFb+5AlApt48AasHKS4AAAQKzEdjUWmmtKwC1/k8MajnIS4AAAQIEWhWocaae1fwbgFYh1UWAAAECBOYusMgGoMZY10gqJwECBAgQmKFAlT8EzAbgixliWjIBAgQIEOhF4KZCoZ/7CKCCqpQECBAgQKBxgaHWRwCNr1t5BAgQIEBg3gIagHnvv9UTIECAwEwFajUA65l6WjYBAgQIECgtUO2PAEsXKh8BAgQIECBQTqDGHwE+qXUFoNyyZSJAgAABAgSKC2gAipNKSIAAAQIE2hfQALS/RyokQIAAAQLFBTQAxUklJECAAAEC7QtoANrfIxUSIECAAIHiAhqA4qQSEiBAgACB9gU0AO3vkQoJECBAgEBxAQ1AcVIJCRAgQIBA+wIagPb3SIUECBAgQKC4gAagOKmEBAgQIECgfQENQPt7pEICBAgQIFBcQANQnFRCAgQIECDQvoAGoP09UiEBAgQIECguoAEoTiohAQIECBBoX0AD0P4eqZAAAQIECBQX0AAUJ5WQAAECBAi0L6ABaH+PVEiAAAECBIoLaACKk0pIgAABAgTaF9AAtL9HKiRAgAABAsUFNADFSSUkQIAAAQLtC2gA2t8jFRIgQIAAgeICGoDipBISIECAAIH2BTQA7e+RCgkQIECAQHEBDUBxUgkJECBAgED7AhqA9vdIhQQIECBAoLiABqA4qYQECBAgQKB9AQ1A+3ukQgIECBAgUFxAA1CcVEICBAgQINC+gAag/T1SIQECBAgQKC6gAShOKiEBAgQIEGhfQAPQ/h6pkAABAgQIFBfQABQnlZAAAQIECLQvoAFof49USIAAAQIEigtoAIqTSkiAAAECBNoX0AC0v0cqJECAAAECxQU0AMVJJSRAgAABAu0LaADa3yMVEiBAgACB4gIagOKkEhIgQIAAgfYFNADt75EKCRAgQIBAcQENQHFSCQkQIECAQPsCGoD290iFBAgQIECguIAGoDiphAQIECBAoH0BDUD7e6RCAgQIECBQXEADUJxUQgIECBAg0L6ABqD9PVIhAQIECBAoLqABKE4qIQECBAgQaF9AA9D+HqmQAAECBAgUF9AAFCeVkAABAgQItC+gAWh/j1RIgAABAgSKC2gAipNKSIAAAQIE2hfQALS/RyokQIAAAQLFBTQAxUklJECAAAEC7QtoANrfIxUSIECAAIHiAhqA4qQSEiBAgACB9gU0AO3vkQoJECBAgEBxAQ1AcVIJCRAgQIBA+wIagPb3SIUECBAgQKC4gAagOKmEBAgQIECgfQENQPt7pEICBAgQIFBcQANQnFRCAgQIECDQvoAGoP09UiEBAgQIECguoAEoTiohAQIECBBoX0AD0P4eqZAAAQIECBQX0AAUJ5WQAAECBAi0L6ABaH+PVEiAAAECBIoLaACKk0pIgAABAgTaF9AAtL9HKiRAgAABAsUFNADFSSUkQIAAAQLtC2gA2t8jFRIgQIAAgeICGoDipBISIECAAIH2BTQA7e+RCgkQIECAQHEBDUBxUgkJECBAgED7AhqA9vdIhQQIECBAoLiABqA4qYQECBAgQKB9AQ1A+3ukQgIECBAgUFxAA1CcVEICBAgQINC+gAag/T1SIQECBAgQKC6gAShOKiEBAgQIEGhfQAPQ/h6pkAABAgQIFBfQABQnlZAAAQIECLQvoAFof49USIAAAQIEigtoAIqTSkiAAAECBNoX0AC0v0cqJECAAAECxQU0AMVJJSRAgAABAu0LaADa3yMVEiBAgACB4gIagOKkEhIgQIAAgfYFNADt75EKCRAgQIBAcQENQHFSCQkQIECAQPsCGoD290iFBAgQIECguIAGoDiphAQIECBAoH0BDUD7e6RCAgQIECBQXEADUJxUQgIECBAg0L6ABqD9PVIhAQIECBAoLqABKE4qIQECBAgQaF9AA9D+HqmQAAECBAgUF9AAFCeVkAABAgQItC+gAWh/j1RIgAABAgSKC2gAipNKSIAAAQIE2hfQALS/RyokQIAAAQLFBTQAxUklJECAAAEC7QtoANrfIxUSIECAAIHiAhqA4qQSEiBAgACB9gU0AO3vkQoJECBAgEBxAQ1AcVIJCRAgQIBA+wIagPb3SIUECBAgQKC4wB+LZ+wv4d/3V3LzFf//qPB/NV+lAgkQIDBjAQ3Akyf/fcb7X2vp/6lWYnkJECBAoIyAjwDKOMpCgAABAgS6EtAAdLVdiiVAgAABAmUENABlHGUhQIAAAQJdCWgAutouxRIgQIAAgTICGoAyjrIQIECAAIGuBDQAXW2XYgkQIECAQBkBDUAZR1kIECBAgEBXAhqArrZLsQQIECBAoIyABqCMoywECBAgQKArAQ1AV9ulWAIECBAgUEZAA1DGURYCBAgQINCVgAagq+1SLAECBAgQKCOgASjjKAsBAgQIEOhKQAPQ1XYplgABAgQIlBHQAJRxlIUAAQIECHQloAHoarsUS4AAAQIEyghoAMo4ykKAAAECBLoS0AB0tV2KJUCAAAECZQQ0AGUcZSFAgAABAl0JaAC62i7FEiBAgACBMgJ/LJOm6yyfdV294gkQIECAwAECrgAcgOYlBAgQIECgdwENQO87qH4CBAgQIHCAgAbgADQvIUCAAAECvQtoAHrfQfUTIECAAIEDBDQAB6B5CQECBAgQ6F1AA9D7DqqfAAECBAgcIKABOADNSwgQIECAQO8CGoDed1D9BAgQIEDgAAENwAFoXkKAAAECBHoX0AD0voPqJ0CAAAECBwhoAA5A8xICBAgQINC7gAag9x1UPwECBAgQOEBAA3AAmpcQIECAAIHeBTQAve+g+gkQIECAwAECGoAD0LyEAAECBAj0LqAB6H0H1U+AAAECBA4Q0AAcgOYlBAgQIECgdwENQO87qH4CBAgQIHCAgAbgADQvIUCAAAECvQtoAHrfQfUTIECAAIEDBP54wGtO7SW/3i7of5zawqznpAQ+i9X8/UmtyGKmEhhios8jziIWEduRX99EbLYPxO11RD72c8QmYuqRNf1NxHAbcfNmjPHPzW3EzZuxiX9m/BSRNRsPFNAAvAPz5vrOwr32BP6lvZJU1KDAImr6MmKMyMM0bw8dm3jh9W2s4/ZlRMkxRLIvIrZ1jnH/0HETL8xa17dRutZIe5ojfwMuHWNHVKXXLl/5nyemT564QtXRm8rEpQ4x3zcRryJq/m/ll8j/POKriEPHIl74NGKKWn+IeR5T66FrrPG6MZLW2NsqSbPYXkYNVDnr/LDO2VUD0Ms7ynR1Po2p8pA7xv8ufol5v4vI397vM45d6/Mo8r613mc9Uz9njAlr7HOVpFlsL6MGqpx1fljn7KoB6OUdpX6dT2OK1xGt/O/hRdQyRuwbPdW6r/5WHhujkBr7XSVpFtvLqIEqZ50f1jm7agB6eUepV+fTSP06otX/HTyP2oaIHK3X+iJqHLPQTsYYddbY9ypJs9heRg1UOev8sM7ZVQPQyztK+TrHSPkqooef//xDvL+LuOmk3vwYYxHR+hijwOL7/4fWV60+AgQIzFQgD6Y8oF5EnHVg8E+3df7PuB0ifoxofTyLAl9HnLdeaI36NAA1VOUkQIDA4wTywM+DPw+o1kf+e/h/G3GxU+hN3M9D9U8Rf9l5vMW7iyjqh4jnEXl/NkMDMJuttlACBDoRWEadvfzW/+eo9SziOmLfuIoHh4if9n2zsceWUU8v7kXoNABFGCUhQIBAEYH8LbSX30S/jlqf3WPVN/GcMeL7ezz32E85iwKyCTg/diFTzK8BmELZHAQIEPi0QB78y08/7ejPyEv6f4pYPaCSbAKWET00AYuoMz8SyHpPemgATnp7LY4AgQ4E8sB5FbHsoNY8/MeIqwNrXcbr8spBD6OXhuxgSw3AwXReSIAAgSICecn5rEimukm2h//1I6dZxes1AY9ELPFyDUAJRTkIECBwmED+ljmnw3+rtIo7f95+0fjtyV4J0AA0/pOnPAIETlagp4PlWezCY3/z/3AjM2cPfxOQdedejXnnlIYG4JR201oIEOhFYBmFZvQw8nL9qlKhy8j7slLu0mnzDwOH0kmPmU8DcEx9cxMgMEeBvOT/XScLz9/QV5VrPY/8+fcFrY9FFJhNwMkMDcDJbKWFECDQgUAeInk5OW9bHz9Hgc8mKPIm5jifYJ4SU5xFkssSiVrIoQFoYRfUQIDAXAQuYqF5iPQwllHkzUSFrmOeXv4o8JuodYzofmgAut9CCyBAoBOBMerMw6OHkYfxeuJCL2K+vOrQw8irON2PP3a/gnIL+JdyqWQiQIDA7wR6+dw/D+GL31Vf/4G82rCMeFF/qkfPMESGi9uIm37Hr1F66Rj75VA5AQIEigssI2Pp99la+bLWY451TF5rbSXz/hJ1DhFTjDEmKVn7NleVpFmsQYAAAQK/CbyOm+2bbsu3mwY2bOzEKvdxFTHFGGOS4j83/gZgiq0zBwECcxZYxuKHTgAuGqhzHTW8bKCO+5TwNJ60uM8TW3yOBqDFXVETAQKnJPBtJ4vJz/5XjdR60Ugd9ynj2X2e1OJzNAAt7oqaCBA4FYFlLGToZDEXDdW5jlp+bKiej5WS/2ZHl1cBNAAf21bfI0CAwOMEzh/38slenf8lvqvJZrvfRK3Vc1fVefj3ss/vrUED8B6HLwgQIFBMYIhMXxXLVjdRHrY3dad4cPasKRuTHkb+LUB3QwPQ3ZYpmACBTgR6+q0wD9vWRjYkLda1z2mMB4d932j5MQ1Ay7ujNgIEehbo5bfCFi//b/e9lwYg6z3fFt3LrQagl51SJwECPQksotizTgpu+ZDN2nr5GGDsZL/flqkBeEvhDgECBIoJjMUy1U+0rj/Fo2a4ftSrp3vxl9NNVWYmDUAZR1kIECCwKzDuftH4/dYP2HXjftvyFnFn3H7Rw60GoIddUiMBAr0JnHVUsAag3GaN5VLVz6QBqG9sBgIE5ifQy+XgHv6Tu603KLs/3cPuF63f1wC0vkPqI0CgN4Gho4LXHdR6EzXmf6a4hzH0UOS2Rg3AVsItAQIEyggMZdJMkmUzySyPn6SXOr94/FKny6ABmM7aTAQIzEOgp8//N51sSV4F6GEseihyW6MGYCvhlgABAmUEujoEyiy5epbr6jOUm2Asl6puJg1AXV/ZCRAgQIBAkwIagCa3RVEECBCYRKCn36wnAZnTJBqAOe22tRIgMIXAOMUkhea4KZSndppN7QnmmF8DMMddt2YCBAgQ6Emgyt+V1GoAxp5k1UqAAIGCAuuCuWqnqnKwVCh6qJCzp5RnNYqt1QDUqFVOAgQIECgrUOVgKVuibLUENAC1ZOUlQIAAAQINC2QD0Mt/YrFhRqURIEDgrcDN23vulBLo6UrFutSiK+f5ORuATeVJpCdAgMCcBK47WuzQSa2LTur8S6U6a6x/U+sjgLESgrQECBBoXWDTeoE79Q0791u++3nLxe3UVqv5O9uZo9jdbABuimWTiAABAgQ2HRGMHdSav/0OHdSZJW46qTPLvMkGoEbH0sv/F3ZHe6VUAgQ6Evipk1p7eK+u8ttvpf3ZVMpbY5+ua30EkAZDJQhpCRAg0LrAuvUCd+pr/YAdd2pt/e5VhQKHCjnfpKx1BSCTD29m8A8CBAjMT2Dd0ZI1AGU2K/8A8LpMqveyDO99Ve6Ldc2/AWj9h6oco0wECBB4X2D9/pdNfzU2Xd2TJ180Xt+2vPX2TuHbamepKwCFd0o6AgQIhMBNRC9/B/BVwzt2HrUtGq5vt7T17hcF7w8Fc+2mensFoMa/u1jjjxZ2i3efAAECLQusWi5up7Y8YPOgbXG0Wtc+q6t9DxZ4rMZZ+t6Zv44if60Q+YNlECBAYI4CQyy6xvtqjZyrBjcoz49fOjFcV/JLgxr7/abe7b8FcF2p+LFSXmkJECDQusAmCvyx9SJv63sat639wnbeYE13befqrm888vHxka+/6+VvznwNwF08HidAgMDjBa4en2KyDHngtjSyKelh5OX0Wvs8VgJ40wBsc5/FnRqXGV5tJ3BLgACBmQpsYt013l9L53zd0P6MnZjlHlxE1Bp5hpbe58yXZ/57o8YkmXPx3iy+IECAwLwElrHcWu+vpfNmrS2MF1FE6bXVylfrjMu8NWq+2bfB60qTLfdN5jECBAjMSGATa63xZl465+sG9mTsxCrtVxG1xjISl97fzLeO+N24iEdqTPbidzN5gAABAvMSWMZya7y/1siZtR5z5JlRY12lc+Zv0kNFqFqX/y/21TzGg6WBtvmGfRN6jAABAjMSuI61bt8TW759HXXm5edjjDEmbdlmt7aLikBDRYfxrrqzo9ldYKn7F3dN6HECBAjMROAs1lnqPbV2nssj7Ek2Ha87Mbqu7HNRyeHmY3VfVZo0N9UgQIDA3AUuA6D24V0q/zjxZrF5B16rEcoz/s6xjO+U+uH5MM/ZnbP6BgECBOYhsIhlXkd8+P7Y4tevo86sd4pxHpO0aLCvpsvKIGcVLZYfq32oOPHqYxP7HgECBGYikG/wNxH7DpfWHvthgj1ZxBy/dOJxPYHHqqLF8Kn6c4G1fgg/OfmnivN9AgQInIDAMtZQ6322dN6steao9dfupR2yaRtqQtzmL133Nt+9mpdnUcT2BaVvV5XxpCdAgEAvAqsotPR7bK18y0qozzsyGCsZ7KZdxRe19jDP9k+OIZ5Rq4DMm/kNAgQIEPjtPyRT8/22VO68RH9WeMOeR75S9dXOsyy89n3phniw5joy/73GVTyrViGre1XgSQQIEJiHwHUss9b7bcm8JZuAZSdrTr+sdYqxiklK7tdurjzT7z2W8czdF5e+P9y7Ek8kQIDAaQssYnlzagK+ifWWPlNq5VtO9KM3VDZ58DpuKhb0Q+Q2CBAgQOCdwCru1jrISubNKwHn78p+0L3nnawxvZYPWtnjnpxnYsk92s2VZ/mDx2W8YjdJ6fvjgyvyAgIECJy2wCqWV/q9tla+5QO2YhHPrXnIlVxjHpjnD1jbY5+ac5Ws/8Ncl4cUOFQu6nXkXxxSmNcQIEDghAWWsbabiA/fyFv8+rt77MMQz3nVyXquo86ziKlGnoF5Ftbc2+HQxVxVLuzi0MK8jgABAicskIfQdUTNg6FU7jzcs95945t48JeIUnPVzLOKOhcRU46LmKzmmq4es5ixcnG58CHCIECAAIH3BfIwuoyoeUCUzP3tTvlZ+w+d1H4TdZ7v1D7V3SEmKum/L9f42MWsKxeZ3aNBgAABAvsFzuLh64h9b/CtPZbv538X0ctv/ZdR6yLiGCOtau7fusSizisXmQC5CQYBAgQI3C2wjG9tImoeGo/JvYrahogcy4hNxGPy1XztOmobI4418syrub7MPZZa3DoS1S42Gw2DAAECBD4usIxvbyJqvyffN/9V1DJE7BvLeHATcd9ctZ+3jlrGiGOOPOumWGexNY4TFJyXjIYIgwABAgQ+LbCMp+ThW/sw2Zd/E/NeRpxF3GfkoXesWm9i7lXEfWuNp1YbQ2Se4uORsfQK1pFw3w9CycfyM5FF6cLlI0CAwAkLDLG2ZxHXESXfjz/MdRP5VxHnEYeORbxwGbGO+DB/ya+z1quIx9QaLy86cu21P/dPw3XRqm+TjXFbcoPuyvW8RvFyEiBAYAYCecjkoXcZsY646332Po9v4vVXEc8ixojSY4iEWetFxDriJuI+de17Tr42c1xEnEW0OJ5HUftqL/3Yvdf/2QOVVvH8pw98zSFPz3m+PuSFXkOAAAEC7wkM8VVGHgyLiO3Ir28iNtsH4nZ9e/86bvN7U4+saREx3EbcvBlj/HNzG3HzZmzinxnriNZHHv7LCYr8vuY8uTH5Q1G6Y9mX73ICLFMQIECAAIGaAnmW7TvjSj+WZ/Oi5kIy90VE6cLvyreMuQwCBAgQINCjwDKKvut8K/34s6mAridcVAIaBAgQIECgJ4FlFFv6kL8rX57Jk42zmOmuQmo8/u1kKzMRAQIECBB4nECeWTXOwrty5pk86biI2e4qpsbjzyddnckIECBAgMDDBfKsqnEG3pXz4uEllnnFlB8F5OIT1iBAgAABAi0K5Bl110Fd4/FJL/1/CJ6XHW4mXrD/WNCHu+BrAgQIEDimwCImn+I/8rPbROTZOxxz0Tn3s4jdoqa4/0vMOUYYBAgQIEDgmAJjTJ5n0hRn3+4cefY2MVZRxW5hU93/tonVK4IAAQIE5iiQZ9BU593uPKuWsPPyx/WRIF7EvDm/QYAAAQIEphDIMyfPnt1Dear7edY2d+adRVE3RwLJyy9PIwwCBAgQIFBTIM+aY1zyzwYjz9ghoslxHlVN1QXtm+dFzJ+NiEGAAAECBEoK5NmSZ8y+s2eqx/KMbXoso7qpMO6a57uoYdG0kuIIECBAoAeBPEvyTLnrvJnq8WUPWFnjZcRUKHfN42OBXn5a1EmAAIH2BPLgfxpxrMv9u2dbnqldjVVUu7uAY93Pzfs2IjfTIECAAAECHxPIsyLPjBYO/jw3VxFdjlVUfayD/8N5NQJd/ggpmgABApMItHbwd334b3fsOu58eBgf++vnUdNX2wLdEiBAgMBsBfIsyDPh2OfSh/OvT2FHsqtqsQlI7NcR30WcRRgECBAgMA+BfM/P9/48Az48eFv4Os/MRcRJjFzIVUQLsHfV8Crqyx+IryJOBj7WYhAgQGDuAvmenu/t+R7/KuKuc6CFx1dR30mOVayqBeD71JA/JPnD8lXEEGEQIECAQB8CZ1Fmvnfne/iriPu857fwnFXUOtn4bLKZ3k20irtP333Z1b3rqPYmYh2xuY24eTP+Ev/M7xsECBAgUE8gD/e/2Uk/xP2MMWIRkd/vcXwfRS+nLPwYDUCu71lEdmYGAQIECBCYu8DXAbCaGuGvpp7wdr7/Hbc/R/zHiL++fcwNAQIECBCYk0BeOf7PEatjLPpYVwC2a81LNVcRn28fcEuAAAECBGYgkL8En0dcH2utfzjWxLfz5sLPIl4euQ7TEyBAgACBqQR+jIny7Dva4Z8LPdZHADn3dvxr3FlF5NWIMcIgQIAAAQKnKvBPsbB/jMiz76gjD92WxhjFrCJ8JBAIBgECBAicjMDPsZLziKP+1r+reeyPAHZryfvriLws8n2EQYAAAQIETkEgz7Q825o5/BO1tSsAWdN2jHFnFeFqQCAYBAgQINCdQP7Wv4xYRzQ3WvgbgLtQNvGNVcS/i/gPEQYBAgQIEOhF4M9R6D9E/N9WC275CsCuWV46uYz4cvdB9wkQIECAQGMCL6OeZxFNXe7fZ9RLA7Ct/TzuZCPgY4GtiFsCBAgQaEEgL/fnwX/VQjH3qaHljwD21Z+XUrIByMblbyP8VwQDwSBAgACBowls/2t+y6ig2cv9+3R6uwKwu4ZFfJHdVsbu/zHE7nPcJ0CAAAECNQTy4M9fSDNuakxQO2fPDcDWZhF3ziMuInw0EAgGAQIECFQTyEv9FxFXEV0e/FH3m3EKDcB2LXm7vA1/LJgaBgECBAiUEngZiVa3USrnUfOcWgOwxRzizrOIZYSPBwLBIECAAIEHC+Rl/lXEZcQm4qTGqTYAu5t0Hl9sQzOwK+M+AQIECHwokIf+1U58+P2T+XoODcDuZm0bgbzVDOzKuE+AAIH5Cszm0N/d4rk1ALtrP4svshEYI/zNQCAYBAgQmJHAy1jrOuIq4jpidmPODcCHm50NwXgbQ9x+EWEQIECAQP8CP8USNhHr25jlgR9rf29oAN7j+N0XYzwy7An/umGgGAQIEGhI4OeoZfNB5EHvsA+EfUMDsE/l/o8t4qln93+6ZxIgQIBAQYE83G8K5pOKAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECjQv8G9X8pQ34x9PWAAAAAElFTkSuQmCC"/>
                                                        </defs>
                                                    </svg>
                                                    <img style="height: 21px; min-width: 21px" class="merge_box_only" src="https://cdn.shopify.com/s/files/1/1412/6778/files/svgviewer-png-output_2.png?v=1726080185" alt="">

                                                 </div>
                                                <div class="d-flex flex-column w-100">
                                                    <div class="d-flex justify-content-between">
                                                        <span class="user-role">Payment method</span>
                                                        <button class="edit-button text-decoration-underline merge_box_exempt ${cancelledBox ? 'd-none' : ''}" 
                                                        data-modal-opener="${paymentMethod.processor_name === 'shopify_payments' ? 'shopify_payments' : 'edit-payment-mobile'}">
                                                            Edit
                                                        </button>
                                                    </div>
                                                   
                                                    <span style="padding-right: 80px" class="text-capitalize">${paymentMethod?.payment_details?.brand || 'Credit card'} ending in ${paymentMethod?.payment_details?.last4}</span>
                                                    <span class="${!paymentMethod?.payment_details?.exp_month ? 'd-none' : ''}">
                                                    Expires ${paymentMethod?.payment_details?.exp_month && parseInt(paymentMethod?.payment_details?.exp_month) < 10 ? '0' + paymentMethod?.payment_details?.exp_month : paymentMethod?.payment_details?.exp_month}/${paymentMethod?.payment_details?.exp_year}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `
                html += finalHtml
                realIndex++;
            }
        });
        html += `</custom-accordion></div>`

        let subscriptionContainerHtml = this.querySelector('[data-mobile-subscription-container]')
        let mergeBox = this.querySelector('[data-merge-box-container] [data-merge-box-first]')
        subscriptionContainerHtml && (subscriptionContainerHtml.innerHTML = html);
        mergeBox && (mergeBox.innerHTML = html);
        setTimeout(() => {
            this.querySelector('.merge-box [data-single-container].accordion__container.open [data-view-more-mobile]')?.click();
            this.querySelectorAll('[data-address-to-capitalize]').forEach(el => {
                const text = el.textContent.trim();
                if (!/^\d/.test(text)) {
                    el.classList.add('text-capitalize');
                }
            })
        }, 500)
    }

    _manageCCErrorMessages(address) {
        let paymentMethodError = this._showChargeError(address.id) === PAYMENT_METHOD_DECLINED;
        let shippingError = this._showChargeError(address.id) === INVALID_SHIPPING_ADDRESS;
        let generalError = this._showChargeError(address.id) === GENERAL_MESSAGE;
        let pendingAttempt = this._showChargeError(address.id) === CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT;
        let isMobile = window.innerWidth <= 576;

        let chargeError = allErrorCharges?.find((charge)=>{return charge.address_id == address.id});
        let error_type = chargeError?.error_type?.toUpperCase() || '';

        this.querySelector('[data-cc-error-container]')?.classList?.add('d-none');
        if (paymentMethodError) {
            let paymentMethod = allPayments.find((payment) => payment.id == address.payment_method_id) || false;
            this.querySelector('[data-cc-error-container]')?.classList?.remove('d-none');
            this.querySelector('[data-cc-error-action]')?.classList?.remove('d-none');
            this.querySelector('[data-cc-error-container]')?.setAttribute('data-cc-error-container', address.id);
            let messageForPaymentError = 'There was an error with your payment method. In order to not disrupt your upcoming subscriptions, please update your payment method.';
            if (error_type) {
                messageForPaymentError = this._getChargeErrorReason(error_type);
            }
            this.querySelector('[data-cc-error-text]').innerHTML = messageForPaymentError;
            this.querySelector('[data-cc-error-action]').innerHTML =
                `<button class="text-uppercase edit_dark_btn" 
data-modal-opener="${paymentMethod?.processor_name === 'shopify_payments' ? 'shopify_payments' : (isMobile ? 'edit-payment-mobile' : 'payment-form')}">Edit payment</button>`
            isErrorExist = true;
        } else if (shippingError) {
            this.querySelector('[data-cc-error-container]')?.classList?.remove('d-none');
            this.querySelector('[data-cc-error-action]')?.classList?.add('d-none');
            this.querySelector('[data-cc-error-container]')?.setAttribute('data-cc-error-container', address.id);
            this.querySelector('[data-cc-error-text]').innerHTML = `please UPDATE your address. If the issue persists please <a href="javascript:void(0);" class="text-decoration-underline fw-bold" data-zowie-start>contact</a> customer service.`;
            isErrorExist = true;
        } else if (generalError) {
            this.querySelector('[data-cc-error-container]')?.classList?.remove('d-none');
            this.querySelector('[data-cc-error-action]')?.classList?.add('d-none');
            let reason = this._getGeneralErrorReason(error_type);
            this.querySelector('[data-cc-error-text]').innerHTML = `There was an issue processing your order. Please <a href="javascript:void(0);" class="text-decoration-underline fw-bold" data-zowie-start="">contact </a> customer service.`;
            isErrorExist = true;
        } else if (pendingAttempt) {
            this.querySelector('[data-pending-attempt]')?.classList?.remove('d-none');
            isErrorExist = true;
        }
        if (ccSuccessMessage) {
            this.querySelector('[data-cc-error-container]')?.classList?.add('d-none');
            this.querySelector('[data-cc-success-message]')?.classList?.remove('d-none');
        }
    }

    _mergeBoxRequired() {
        let required = 0;
        allAddresess.forEach(address => {
            let addressRelatedSubscriptions = allSubscriptions.filter((subscription) => subscription.address_id == address.id);
            if (addressRelatedSubscriptions.length) {
                let next_charge_date = addressRelatedSubscriptions[0].next_charge_scheduled_at;
                let preChargeDate = '';
                let pendingAttempt = this._showChargeError(address.id) === CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT;
                allCharges.forEach(charge => {
                    if (charge.address_id == address.id && charge.status === "skipped") {
                        preChargeDate = charge.scheduled_at;
                    }
                })
                let skippedBox = !pendingAttempt && next_charge_date && preChargeDate;
                let chargeError = this._showChargeError(address.id) != false;
                if (!skippedBox && !chargeError) required++;
            }
        })

        return required >= 2;
    }

    _prepareQuickAddHtml() {
        this.querySelectorAll('[data-quick-add-collection]').forEach(container => {
            let swatchContainer = container.querySelector('[data-quick-add-swatches]');
            let collectionHandle = swatchContainer.getAttribute('data-quick-add-swatches');
            collectionHandle = this._formatCollectionHandle(collectionHandle);
            let selectedCollection = allCollections[collectionHandle];
            if (selectedCollection) {
                this._prepareQuickAddColors(container);
                this._prepareQuickAddSize(container);
            }
        })
    }

    _prepareQuickAddBoxes() {
        let section = this.querySelector('[data-quick-add-section]');
        section.classList.remove('d-none');

        section.querySelectorAll('[data-quick-add-box]').forEach(box => {
            let type = box.dataset.quickAddBox;
            box.querySelector('[data-style-type-name]').innerHTML = type;
            box.querySelectorAll(`[data-style-type]`).forEach(v => v.classList.add('d-none'));
            box.querySelectorAll(`[data-style-type=${type}]`).forEach(v => v.classList.remove('d-none'));
            if (!box.getAttribute('data-quick-select-color')) {
                box.querySelector('[data-core-color-container]')?.classList?.add('d-none');
                box.querySelector('[data-limited-color-container]')?.classList?.add('d-none');
            }
            if (!box.getAttribute('data-quick-select-size')) {
                box.querySelector('[data-account-size-step]')?.classList?.add('d-none');
                this._selectSizeValue('', box);
                box.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));
            }
            let prices = this._getPriceInterval(box);
            if (box.querySelector('[data-price-interval]')) {
                box.querySelector('[data-price-interval]').innerHTML = `${this._formatMoney(prices[0])}-${this._formatMoney(prices[1])}`;
            }
        })

        section.querySelectorAll('[data-single_style]').forEach(item => {
            let styleHandle = item.getAttribute('data-single_style');
            if (!this._isAnySizeAvailableInCollection(styleHandle)) {
                item.classList.add('disabled');
            }
        })
    }

    _resetQuickAdd(container) {
        let box = container.closest('[data-quick-add-box]');
        let type = box.dataset.quickAddBox;
        // box.querySelector('[data-size-select-tag]').value = '';
        this._selectSizeValue('', box);
        if (type === 'tops') {
            box.querySelector('[data-quick-add-img]')?.setAttribute('src',
                'https://cdn.shopify.com/s/files/1/1412/6778/files/Boss_d_svg.svg?v=1715677804');
        } else {
            box.querySelector('[data-quick-add-img]')?.setAttribute('src',
                'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804');
        }
        container.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));
        box.querySelectorAll('.custom-options,.custom-select-wrapper').forEach(ele => ele.classList.remove('open'));
        box.querySelector('[data-style-select]').textContent = 'Choose your style';
        box.querySelector('[data-style-select]').dataset.styleSelect = '';
        box.querySelector('[data-color-product-id].selected')?.classList?.remove('selected');
        let prices = this._getPriceInterval(box);
        box.querySelector('[data-price-interval]').innerHTML = `${this._formatMoney(prices[0])}-${this._formatMoney(prices[1])}`;
        box.querySelector('[data-actual-style-price]')?.classList?.add('d-none');
        box.setAttribute('data-quick-select-size', '');
        box.setAttribute('data-quick-select-color', '');
        box.setAttribute('data-quick-select-product', '');
        box.setAttribute('data-quick-collection', '');
        box.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));
        box.querySelectorAll('[data-style-select-container] .custom-option').forEach(ele => ele.classList?.remove('selected'));
        box.querySelectorAll('[data-limited-color-container],[data-core-color-container],[data-account-size-step]').forEach(ele => ele.classList?.add('d-none'));
        let quickAddButton = box.querySelector('[data-quick-add-process]');
        if (quickAddButton) {
            quickAddButton.querySelector('[data-button-text]').innerHTML = 'Select a style';
            quickAddButton.setAttribute('data-quick-add-process', 0)
        }
    }

    _prepareQuickAddColors(container) {
        let swatchContainer = container.querySelector('[data-quick-add-swatches]');
        let collectionHandle = swatchContainer.getAttribute('data-quick-add-swatches');
        collectionHandle = this._formatCollectionHandle(collectionHandle);
        let selectedCollection = allCollections[collectionHandle];
        let selectedSwatch = container.getAttribute('data-selected-color')?.toLowerCase().trim();
        let sizeSelect = container.getAttribute('data-selected-size')?.toLowerCase().trim();
        let remainingLimited = 8;
        let remainingCore = 9;
        let allColorsInHtml = [];

        let swatchHtml = '';
        let limitedColorsHtml = "";
        let coreColorsHtml = "";
        let selectedSwatchType = '';
        let selectedSwatchHtml = '';
        selectedCollection.products.forEach((product, i) => {
            if (product.tags && product.tags.length && product.tags.includes("WSINGLES")) {
                let color = product.variants[0]?.option2?.toLowerCase();
                let colorSrc = this._findColorSwatchByProduct(product);
                let isLimited = product.tags.includes('pp-limited_color') || false;
                let isColorAvailable = true;
                let oosColor = true;
                let repeatedColor = allColorsInHtml.includes(color);

                if (sizeSelect) {
                    isColorAvailable = false;
                    selectedCollection.products.forEach(product => {
                        if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                            isColorAvailable = true;
                        } else {
                            product.variants?.forEach(variant => {
                                if (variant?.available && variant?.inventory_quantity >= 5 && (variant.option2.toLowerCase()?.replace(/\u00A0/g, ' ') == color?.toLowerCase()) && (variant.option1?.toLowerCase() == sizeSelect)) {
                                    isColorAvailable = true;
                                }
                            })
                        }
                    })
                }
                selectedCollection.products.forEach(product => {
                    if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                        oosColor = false;
                    }
                    else {
                        product.variants?.forEach(variant => {
                            if (variant?.available && variant?.inventory_quantity >= 5 && (variant.option2?.toLowerCase() == color?.toLowerCase()?.replace(/\u00A0/g, ' '))) {
                                oosColor = false;
                            }
                        })
                    }
                })
                if (color === selectedSwatch) {
                    selectedSwatchType = color === selectedSwatch && isLimited ? 'limited' : 'core';
                }
                // if (color === selectedSwatch) {
//                 selectedSwatchHtml = `<a class="swatch-image quick-swatch-images rounded-circle position-relative selected
// ${color === 'pride pure' ? 'highlight-color' : ''} ${!isColorAvailable ? 'unavailable ' : ''} ${oosColor || repeatedColor ? 'd-none' : ''}"
//                         data-swatch-color="${color}" data-product-id="${product.id}" data-color-type="${isLimited ? 'limited' : 'core'}">
//                          <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
//                     </a>`;
//             } else {
//                 swatchHtml = `
//                     <a class="swatch-image quick-swatch-images rounded-circle position-relative
// ${color === 'pride pure' ? 'highlight-color' : ''} ${!isColorAvailable ? 'unavailable ' : ''} ${oosColor || repeatedColor ? 'd-none' : ''}"
//                         data-swatch-color="${color}" data-product-id="${product.id}" data-color-type="${isLimited ? 'limited' : 'core'}">
//                          <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
//                     </a>
//                     `;
//             }

                swatchHtml = `
                    <a class="swatch-image quick-swatch-images rounded-circle position-relative ${color === selectedSwatch ? 'selected' : ''} ${color === 'pride pure' ? 'highlight-color' : ''} ${!isColorAvailable ? 'unavailable ' : ''} ${oosColor || repeatedColor ? 'd-none' : ''}"
                        data-swatch-color="${color}" data-color="${color}" data-product-id="${product.id}" data-color-type="${isLimited ? 'limited' : 'core'}">
                         <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
                    </a>
                    `;
                allColorsInHtml.push(color);

                if (isLimited) {
                    if (remainingLimited > 0) limitedColorsHtml += swatchHtml;
                    // if (!oosColor) remainingLimited -= 1;
                } else {
                    if (remainingCore > 0) coreColorsHtml += swatchHtml;
                    // if (!oosColor) remainingCore -= 1;
                }
            }
        })
        // if (Math.abs(remainingLimited) > 0) {
        //     limitedColorsHtml += `<span class="swatch-image remaining text-success fw-semibold d-flex justify-content-center align-items-center cursor-pointer"
        //             data-modal-opener="featured-colors">+${Math.abs(remainingLimited)}</span>`;
        // }
        // if (Math.abs(remainingCore) > 0) {
        //     coreColorsHtml += `<span class="swatch-image remaining text-success fw-semibold d-flex justify-content-center align-items-center cursor-pointer"
        //             data-modal-opener="featured-colors">+${Math.abs(remainingCore)}</span>`;
        // }
        swatchContainer.querySelector(`[data-color-print="${selectedSwatchType === 'limited' ? 'limited' : 'core'}"]`)?.classList?.remove('d-none');
        // swatchContainer.querySelector('[data-limited-colors]').innerHTML = selectedSwatchType === 'limited' ? selectedSwatchHtml + limitedColorsHtml : limitedColorsHtml;
        // swatchContainer.querySelector('[data-core-colors]').innerHTML = selectedSwatchType === 'limited' ? coreColorsHtml : selectedSwatchHtml + coreColorsHtml;
        swatchContainer.querySelector('[data-limited-colors]').innerHTML = limitedColorsHtml;
        swatchContainer.querySelector('[data-core-colors]').innerHTML = coreColorsHtml;
        swatchContainer.classList.remove('d-none');

        //bind color events
        this.querySelectorAll('[data-quick-add-collection] [data-swatch-color]').forEach(item => {
            item.addEventListener('click', event => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let swatch = event.target.closest('[data-swatch-color]');
                let container = swatch.closest('[data-selected-color]');
                let parent = container.closest('[data-quick-add-collection]');
                let color = swatch.getAttribute('data-swatch-color');
                container.setAttribute('data-selected-color', color);
                this._prepareQuickAddSize(container);
                let productId = swatch.getAttribute('data-product-id');
                let product = this._findProductByCollectionHandle(productId,
                    this._formatCollectionHandle(parent.getAttribute('data-quick-add-collection')));
                let featureImg = product ? product.images[0] + '&width=300' : false;
                parent.querySelector('[data-quick-add-image] img')?.setAttribute('src', featureImg);
                parent.setAttribute('data-selected-product', productId);
                container.querySelector('[data-swatch-color].selected')?.classList.remove('selected');
                swatch.classList.add('selected');
                container.querySelector('[data-color-print]').innerHTML = this._capitalizeWords(color);

                let type = swatch.getAttribute('data-color-type');
                let colorPrint = parent.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                if (colorPrint) {
                    parent.querySelectorAll(`[data-color-print]`).forEach(ele => ele.classList.add('d-none'));
                    colorPrint?.classList?.remove('d-none');
                    colorPrint.innerHTML = color;
                }
            })
        })

        //data modal opener event handle for more colors
        this.querySelectorAll('[data-modal-opener="featured-colors"]').forEach(ele => {
            ele.addEventListener('click', event => {
                event.stopImmediatePropagation();
                this._openV2Modal('featured-colors');
                this.querySelector('.featured-colors [data-quick-add-submit]')?.classList?.add('disabled');
                this._manageQuickAddModal(event);
            })
        })

        let isMobile = window.innerWidth <= 575;
        if (!isMobile) {
            this._bindMouseOverEffectColor(container);
        }
    }

    _prepareQuickAddSize(container) {
        let swatchContainer = container.querySelector('[data-quick-add-swatches]');
        let collectionHandle = swatchContainer.getAttribute('data-quick-add-swatches');
        collectionHandle = this._formatCollectionHandle(collectionHandle);
        let selectedCollection = allCollections[collectionHandle];
        let option1ValuesArray = selectedCollection.products.flatMap(entry => entry.variants.flatMap(variant => {
            if (variant?.available && variant?.inventory_quantity >= 5) return variant.option1?.toLowerCase()
        }));
        let uniqueOptionValuesArray = Array.from(new Set(option1ValuesArray));

        container.querySelectorAll('[data-size-select-container] [data-single_size]').forEach(ele => {
            let size = ele.getAttribute('data-single_size');
            let colorSelect = container.getAttribute('data-selected-color')?.toLowerCase().trim();
            let isSizeAvailable = false;
            selectedCollection.products.forEach(product => {
                if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                    isSizeAvailable = true;
                } else {
                    product.variants?.forEach(variant => {
                        if (variant?.available && variant?.inventory_quantity >= 5 && (variant.option1?.toLowerCase() == size.toLowerCase()) && (variant.option2?.toLowerCase() == colorSelect)) {
                            isSizeAvailable = true;
                        }
                    })
                }
            })

            if (uniqueOptionValuesArray.includes(size) && isSizeAvailable) {
                ele.closest('[data-single_size]')?.classList.remove('disabled');
            } else {
                ele.closest('[data-single_size]')?.classList.add('disabled');
            }
        });

        container.querySelectorAll('[data-quick-add-collection] [data-size-select-container] [data-single_size]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                let parent = event.target.closest('[data-quick-add-collection]');
                let element = event.target.closest('[data-single_size]');
                let size = element.getAttribute('data-single_size');
                parent.querySelectorAll('[data-single_size].selected').forEach(ele => ele.classList.remove('selected'));
                element.classList.add('selected');
                parent.closest("[data-selected-size]")?.setAttribute('data-selected-size', size)
                this._prepareQuickAddColors(container);
                parent.querySelector('[data-submit-quick-add]')?.setAttribute('data-submit-quick-add', 1);
                parent.querySelector('[data-submit-quick-add]').classList.add('primary-btn');
                parent.querySelector('[data-submit-quick-add] [data-button-text]').innerHTML = 'Add to box';
            })
        })
    }

    _fillShippingAddress() {
        this.querySelector('[data-modal-section] [data-shipping_address="province"]').innerHTML =
            `${this._provinceList().map(province =>
                `<option value="${province}" ${province === currentAddress['province'] ? 'selected' : ''}>${province}</option>`
            ).join('')}`;
        this.querySelectorAll('[data-shipping_address]').forEach(ele => {
            if (!['country_code', 'province'].includes(ele.getAttribute('data-shipping_address'))) {
                ele.value = currentAddress[ele.getAttribute('data-shipping_address')];
            }
            if (ele.getAttribute('data-shipping_address') == 'phone') {
                let value = currentAddress[ele.getAttribute('data-shipping_address')].replace('+1', '').trim();
                let x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                ele.value = value
            }
            if (ele.getAttribute('data-shipping_address') == 'country_code') {
                let countryValue = currentAddress['country_code'] == 'CA' ? 'Canada' : 'United States'
                ele.value = countryValue;
                let spanEle = ele.closest('[data-input-container]')?.querySelector('.inputText');
                if (spanEle) {
                    spanEle.innerHTML = countryValue
                }
            }
        });
    }

    _formatPhone(value) {
        if (value) {
            let x = value.replace('+1', '').trim().replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }
        return '';
    }

    _provinceList() {
        return ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "Armed Forces Americas", "Armed Forces Europe", "Armed Forces Pacific", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Federated States of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas",
            "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico",
            "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
        ]
    }

    _prepareAddressSubscriptionContainer(addressRelatedSubscriptions, address) {
        let html = '';
        let unselectedOrUnskipHtml = "";
        let otherHtml = "";
        addressRelatedSubscriptions.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        addressRelatedSubscriptions.forEach((subscription) => {
            let tempHtml = "";
            let isSelected = (subscription.properties.find((prop) => {
                return prop.name == 'isSwapping' || prop.name == 'COLOR_BLOCK'
            })?.value || false).toString();
            let isSwappingProp = (subscription.properties.find((prop) => {
                return prop.name == 'isSwapping'
            })?.value || false);
            let style = this._findSubscriptionStyle(subscription);
            let displayType = 'unselected';
            let imgSrc = "";
            let size = subscription.variant_title.split('/')[0].trim();
            let status = this._findSubscriptionStatus(subscription);
            let isSkip = false
            let itemPurchaseType = subscription.status != undefined ? 'subscription' : 'addon';
            let defaultImg = "https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804";
            let frameImage = this._findDefaultImageByCollection(style);
            let productID = subscription.external_product_id.ecommerce;
            let product = allCollections[style?.toLowerCase().replaceAll(' ', '-')]?.products?.find((item) => item.id == productID)
            style = style.replace('icon2', 'icon 2.0').replace('boss2', 'boss 2.0').replace('ballerfly7', 'Baller Fly 7”').replace('ballerfly5', 'Baller Fly 5”');
            let colorImgSrc = product ? product.featured_image + '&width=200' : (allMissingProducts[productID]?.featured_image || frameImage || defaultImg);
            let actualPrice = shopifyProductJson[subscription.external_product_id.ecommerce]?.variants[subscription?.external_variant_id?.ecommerce]?.price || 0;
            if (address.presentment_currency == "CAD") {
                if (Shopify?.currency?.active === 'CAD') {
                    let rate = parseFloat(Shopify?.currency?.rate || 1);
                    actualPrice = parseFloat(actualPrice)*rate*100;
                }
            }
            let discountPercentage = 0;
            if (actualPrice > 0) {
                discountPercentage = ((actualPrice - parseFloat(subscription.price)) / actualPrice) * 100;
                discountPercentage = Math.round(discountPercentage);
            }
            actualPrice = this._formatMoney(actualPrice);

            // let isLockedColor = (subscription.properties.find((prop) => {
            //     return prop.name == 'COLOR_BLOCK'
            // })?.value || false);
            if (isSelected == 'false') {
                displayType = 'unselected';
                imgSrc = frameImage || defaultImg;

                if (isSkip == true) {
                    displayType = 'skip';
                    imgSrc = frameImage || defaultImg;
                }
            }
            if (isSelected == 'true') {
                displayType = 'selected';
                imgSrc = colorImgSrc;
            }

            if (itemPurchaseType == 'addon') {
                displayType = 'addon';
                imgSrc = colorImgSrc;
            }

            if (status === 'skip') {
                displayType = 'unskip';
                imgSrc = frameImage || defaultImg;
            }

            if (imgSrc.includes('ecomm')) {
                for (const image of product?.images || []) {
                    if (image && !image?.includes('ecomm')) {
                        imgSrc = image;
                        break;
                    }
                }
            }

            let isOssVariant = false;
            if (product) {
                let currVariant = this._findVariantById(subscription?.external_variant_id?.ecommerce, product);
                if (currVariant.inventory_quantity <= 0 && (isSwappingProp || itemPurchaseType === 'addon')) isOssVariant = true;
            }

            tempHtml = `
                <div class="user-data" data-subscription-id="${subscription.id}" data-subscription-status="${displayType}">
                    <div class="justify-content-between align-items-center d-md-flex d-block">
                        <div class="d-flex align-items-start">
                            <div class="user-image">
                              ${(displayType == 'selected' || displayType == 'addon') ? `<img width="100%" height="100%"
                                     src="${imgSrc}"
                                     alt="">` :
                `  <div style="height: 35px;width: 36px;"><img width="100%" height="100%"
                                         src="${imgSrc}"
                                         alt=""></div>`}
                            </div>
                           
                            <div class="item-information d-flex flex-column" style="gap: 1px">
                                <span class="text-capitalize">${style.replace('boss swim', 'u-boss swim')}</span> 
                                <span class="pt-1 user-text-v2">${displayType == 'unselected' || displayType == 'unskip' ? `${size} / -` : subscription.variant_title}</span>
                                <span class="user-text-v2 d-flex align-items-center" style="margin-top: 2px;margin-bottom: -4px">${this._formatMoney(parseFloat(subscription.price) * 100)} 
                                    <span class="ml-2 text-decoration-line-through me-2">${actualPrice}</span>  
                                    <span class="saving-badge fw-semibold cursor-pointer merge_box_exempt ${isOssVariant ? 'bg-red-200 line-height-normal' : ''}" style="margin-left: auto;margin-right: 6px">${isOssVariant ? 'OUT OF STOCK' : `SAVE ${discountPercentage > 0 ? discountPercentage : 0}%`}</span>
                                </span>
                            </div>
                        </div>
                        <div class="merge_box_exempt pick_color_info_box position-relative d-none d-md-block">
                            ${displayType == 'selected' ?
                                ` <button class="edit-button text-decoration-underline" data-modal-opener="subscription-edit" data-tutorial-guide-stepv2="4">Edit</button>` : ``
                            }
                            ${displayType == 'unselected' ?
                                `<button class="edit-button text-decoration-underline" data-modal-opener="subscription-edit" data-actual-type="pick-color-modal"><span>Edit</span></button>
                                <span class="pick_color_info">Please select a color</span>` : ``
                            }
                            ${displayType == 'addon' ?
                            ` <button class="edit-button text-decoration-underline" data-modal-opener="one-time-edit">Edit</button>` : ``}
                            ${displayType == 'unskip' ?
                            `<button class="edit-button text-decoration-underline" data-modal-opener="subscription-edit" data-actual-type="pick-color-modal"><span>Edit</span></button>
                            <span class="pick_color_info">Please select a color</span>` : ``}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-2">
                   
                        <div>
                            <div class="user-text-v2 d-flex align-items-center ${itemPurchaseType === 'addon' ? 'd-none' : ''}" style="gap: 6px; height: 20px"> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="34" viewBox="0 0 16 34" fill="none">
                                  <line x1="14.0928" y1="11.1445" x2="14.0928" y2="15.1445" stroke="black"/>
                                  <line x1="9.59277" y1="15.6445" x2="13.5928" y2="15.6445" stroke="black"/>
                                  <rect x="13.8428" y="15.3945" width="0.5" height="0.5" fill="black" stroke="black" stroke-width="0.5"/>
                                  <path d="M14 15.9961V15.9961C11.6082 10.2521 3.49753 10.178 1.00118 15.8774V15.8774" stroke="black"/>
                                  <line x1="1.5" y1="22.9961" x2="1.5" y2="18.9961" stroke="black"/>
                                  <line x1="6" y1="18.4961" x2="2" y2="18.4961" stroke="black"/>
                                  <rect x="1.75" y="18.7461" width="0.5" height="0.5" transform="rotate(180 1.75 18.7461)" fill="black" stroke="black" stroke-width="0.5"/>
                                  <path d="M1.59277 18.1445V18.1445C3.9846 23.8885 12.0952 23.9626 14.5916 18.2633V18.2633" stroke="black"/>
                                </svg>
                                <span class="ml-1">Subscribed</span>
                            </div>
                            
                            <div class="user-text-v2 d-flex align-items-center ${itemPurchaseType !== 'addon' ? 'd-none' : ''}" style="gap: 6px"> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <circle cx="8" cy="8" r="7" stroke="black"/>
                                  <path d="M8.16309 4L8.076 8.84434L11.1514 10.4246" stroke="black" stroke-width="0.5"/>
                                </svg>
                                <span class="ml-1">One-Time</span>
                            </div>
                            <div class="swapped-bedge d-none" data-subscription-success-message>
                            <span>Item was swapped successfully.</span>
                        </div>
                        </div>
                        
                        <div class="merge_box_exempt pick_color_info_box position-relative d-md-none d-block mobile_buttons">
                            ${displayType == 'selected' ?
                                ` <button class="edit-button text-decoration-underline" data-modal-opener="subscription-edit" data-tutorial-guide-stepv2="4">Edit</button>` : ``}
                            ${displayType == 'addon' ?
                                ` <button class="edit-button text-decoration-underline" data-modal-opener="one-time-edit">Edit</button>` : ``}
                            ${displayType == 'unselected' ?
                                 `<button class="edit-button text-decoration-underline" data-modal-opener="subscription-edit" data-actual-type="pick-color-modal"><span>Edit</span></button>
                                        <span class="pick_color_info">Please select a color</span>` : ``}
                            ${displayType == 'unskip' ?
                                `<button class="edit-button text-decoration-underline" data-modal-opener="subscription-edit" data-actual-type="pick-color-modal"><span>Edit</span></button>
                                    <span class="pick_color_info">Please select a color</span>` : ``}
                          
                        </div>
                    </div>
                </div>
            `;

            if (displayType === 'unselected' || displayType === 'unskip') {
                unselectedOrUnskipHtml += tempHtml;
            } else {
                otherHtml += tempHtml;
            }
            html += tempHtml;
        });

        return unselectedOrUnskipHtml + otherHtml;
    }

    _findSubscriptionStatus(sub) {
        let status = 'unselected';
        sub.properties.forEach((prop) => {
            let name = prop.name;
            let value = prop.value != null ? prop.value.toString().toLowerCase() : null;
            if (name == 'isSwapping' && value == 'true') {
                status = 'selected';
            }
            if (name == 'old_charge_date' && (value != null && value != 'null' && value != '') && !moment(value).isBefore(moment(), 'day')) {
                if (moment(sub.next_charge_scheduled_at).isSame(moment(value).add(1, 'months'))) {
                    status = 'skip';
                }
            }
        });
        let subscriptionChargeQueued = allCharges.find((charge) => {
            return charge.line_items.some(item => (item.purchase_item_id === sub.id && charge.status.toLowerCase() == 'queued'));
        });
        let subscriptionChargeSkipped = allCharges.find((charge) => {
            return charge.line_items.some(item => (item.purchase_item_id === sub.id && charge.status.toLowerCase() == 'skipped'));
        });

        if (subscriptionChargeQueued?.status.toLowerCase() == 'queued' && subscriptionChargeSkipped?.status.toLowerCase() == 'skipped') {
            status = 'skip';
        }

        if (sub.next_charge_scheduled_at == null) {
            status = "invalid";
        }
        return status;
    }

    _findSubscriptionStyle(item) {
        let variant_title = item?.variant_title?.toLowerCase().split('/')[1];
        let styleType = item?.product_title?.toLowerCase()?.replaceAll(variant_title, '') || item.product_title;
        return styleType.replace('pima cotton ', '')
                .replace('rib tank', 'tank top rib')
                .replace('baller concentrate and cry', 'baller')
                .replace('icon 2.0', 'icon2').replace('boss 2.0', 'boss2')
                .replace('baller fly 7"', 'ballerfly7')
                .replace('baller fly 5"', 'ballerfly5')
                .replace('"', '&#34;')
                .replace('boxer shorts', 'boxer')
                .replace('u-boss', 'boss')
                .replace('pride', '')
                .replace('luxe bralette', 'bralette luxe')
                .trim();
    }

    _paginateOrders() {
        const paginationContainer = this.querySelector('[data-order-pagination]');
        const pageNumbers = this.querySelectorAll('[data-page-number]');
        const nextArrow = paginationContainer.querySelector('[data-page-next]');
        const prevArrow = paginationContainer.querySelector('[data-page-prev]');
        let currentPage = 1;
        const totalPages = parseInt(paginationContainer.getAttribute('data-order-pagination'));

        const updatePagination = () => {
            pageNumbers.forEach(item => {
                const pageNumber = parseInt(item.getAttribute('data-page-number'));
                const targetPage = this.querySelector(`#data-order-group-${pageNumber}`);
                item.parentElement.classList.toggle('current-page-number', currentPage === pageNumber);
                targetPage.style.opacity = currentPage === pageNumber ? 1 : 0;
                targetPage.classList.toggle('d-none', currentPage !== pageNumber);
            });

            prevArrow.classList.toggle('d-none', currentPage === 1);
            nextArrow.classList.toggle('d-none', currentPage === totalPages);
        };

        paginationContainer.addEventListener('click', event => {
            event.preventDefault();
            const target = event.target.closest('[data-page-number]');
            if (target) {
                currentPage = parseInt(target.getAttribute('data-page-number'));
                updatePagination();
            }
        });

        prevArrow.addEventListener('click', event => {
            event.preventDefault();
            if (currentPage > 1) {
                currentPage--;
                updatePagination();
            }
        });

        nextArrow.addEventListener('click', event => {
            event.preventDefault();
            if (currentPage < totalPages) {
                currentPage++;
                updatePagination();
            }
        });

        updatePagination();
    }

    _bindEvents() {
        this._openModalOpenerEvents();
        this._funnelEvents();
        this._dashboardEvents();
    }

    _manageStyleBox() {
        this.querySelectorAll('[data-single_style]').forEach(item => {
            item.classList.remove('selected');
            let styleHandle = item.getAttribute('data-single_style');
            if (!this._isAnySizeAvailableInCollection(styleHandle)) {
                item.classList.add('disabled');
            }
            item.addEventListener('click', event => {
                event.stopImmediatePropagation();
                this._applyStyle(event);
            })
        })
    }

    _applyStyle(event) {
        this.querySelectorAll('[data-single_style].selected').forEach(el => {
            el.classList.remove('selected');
        });
        let collectionHandle = event.target.closest('[data-single_style]')?.getAttribute('data-single_style');
        collectionHandle = this._formatCollectionHandle(collectionHandle);
        selectedStyleCollection = allCollections[collectionHandle];
        event.target.closest('[data-single_style]').classList.add('selected');
        let container = event.target.closest('[data-flow-step]') || event.target.closest('[data-editing-step]');
        container?.querySelector('[data-style-change-confirm]')?.classList.remove('disabled');
    }

    _formatCollectionHandle(handle) {
        if (!handle) return handle;
        let collectionHandle = handle?.toLowerCase()?.replaceAll(' ', '-');
        if (collectionHandle === "baller-highwaisted") {
            collectionHandle = collectionHandle.replace("baller-highwaisted", "baller-high-waisted");
        }
        if (collectionHandle === "biker-highwaisted") {
            collectionHandle = collectionHandle.replace("biker-highwaisted", "biker-high-waisted");
        }
        return collectionHandle.replace('icon 2.0', 'icon2').replace('boss 2.0', 'boss2');
    }

    _isMatchInCollection(assign = false) {
        let available = false;
        selectedStyleCollection.products.forEach(product => {
            if (product.tags && product.tags.length && product.tags.includes("WSINGLES")) {
                if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                    product.variants?.forEach(variant => {
                        available = true;
                        if (assign) {
                            selectedProduct = product;
                            selectedVariant = variant;
                        }
                    })
                } else {
                    product.variants?.forEach(variant => {
                        if (variant?.available && variant?.inventory_quantity >= 5 && (variant.option1?.toLowerCase() == selectedSize.toLowerCase()) && (variant.option2?.toLowerCase() == selectedColor)) {
                            available = true;
                            if (assign) {
                                selectedProduct = product;
                                selectedVariant = variant;
                            }
                        }
                    })
                }
            }
        })

        return available;
    }

    _isSizeAvailableInCollection() {
        let available = false;
        selectedStyleCollection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5 && variant.option1?.toLowerCase() == selectedSize?.toLowerCase()) available = true;
                })
            }

        })

        return available;
    }

    _isAnySizeAvailableInCollection(handle) {
        let collectionHandle = this._formatCollectionHandle(handle);
        let collection = allCollections[collectionHandle];
        let available = false;
        collection?.products?.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5) available = true;
                })
            }
        })

        return available;
    }

    /**
     * Find product based on size and color
     */
    _findProductBySizeNColor() {
        return selectedStyleCollection.products.find((item) => ((item.option1.toLowerCase() == selectedSize.toLowerCase()) && (item.option2.toLowerCase() == selectedColor)))
    }

    /**
     * Find variant based on color
     */
    _findColorVariantByColor(product = selectedProduct) {
        return product.variants.find((item) => item.option2.toLowerCase() == selectedColor.toLowerCase())
    }

    _findVariantById(variantId, product = selectedProduct) {
        return product.variants.find((item) => item.id == variantId)
    }

    /**
     * Find variant based on size
     */
    _findColorVariantBySize(product = selectedProduct) {
        return product.variants.find((item) => item.option1.toLowerCase() == selectedSize.toLowerCase())
    }

    /**
     * Find product based on collection
     */
    _findProductByCollection(id, collection = selectedStyleCollection) {
        return collection.products.find((item) => item.id == id)
    }

    _findProductByCollectionHandle(id, handle) {
        let collection = allCollections[handle];
        return collection.products.find((item) => item.id == id)
    }

    /*find product from selected collection using color name*/
    _findProductFromCollectionByColor(title) {
        return selectedStyleCollection.products.find((item) => item.title == title)
    }

    /**
     * Find image based on product
     */
    _findImageByProduct(product = selectedProduct) {
        if (product) {
            return product.images[product.images.length - 1] + '&width=300';
        }
        let productId = subscriptionData?.external_product_id?.ecommerce || addonData?.external_product_id?.ecommerce;
        if (productId && allMissingProducts[productId]) {
            return allMissingProducts[productId].last_image;
        }

        return false;
    }

    /**
     * Find Color Swatch on product
     */
    _findColorSwatchByProduct(product = selectedProduct) {
        if (product) {
            return product?.color_swatch || (product?.featured_image + '&width=200');
        }

        let productId = subscriptionData?.external_product_id?.ecommerce || addonData?.external_product_id?.ecommerce;
        if (productId && allMissingProducts[productId]) {
            return allMissingProducts[productId].featured_image;
        }

        return false;
    }

    _findDefaultImageByCollection(collection) {
        let collectionHandle = this._formatCollectionHandle(collection);
        switch (collectionHandle) {
            case 'baller' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804'
            case 'ballerfly5' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller5-outline.png?v=1729084740'
            case 'ballerfly7' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller7-outline.png?v=1729084740'
            case 'baller-flex' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804'
            case 'baller-high-waisted' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_HW_d_svg.svg?v=1715677804'
            case 'baller-rib' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_RIB_svg.svg?v=1715677805'
            case 'biker' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Biker_d_svg.svg?v=1715677804'
            case 'biker-flex' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Biker_d_svg.svg?v=1715677804'
            case 'biker-high-waisted' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Biker_HW_d_svg.svg?v=1715678140'
            case 'bikini' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Bikini_d_svg.svg?v=1715677805'
            case 'bikini-swim' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Bikini_d_svg.svg?v=1715677805'
            case 'bold' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Bold_d_svg.svg?v=1715677804'
            case 'boss' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Boss_d_svg.svg?v=1715677804'
            case 'boss-flex' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Boss_d_svg.svg?v=1715677804'
            case 'classic' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Classic_d_svg.svg?v=1715677804'
            case 'dreamer' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/dreamer_d_svg.svg?v=1715677805'
            case 'icon' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Icon_d_svg.svg?v=1715677804'
            case 'star' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Star_d_svg.svg?v=1715677804'
            case 'tank-top-rib' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Tank_top_d_svg.svg?v=1715673333'
            case 'rib-tank' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Tank_top_d_svg.svg?v=1715673333'
            case 'icon2' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/icon2_d.svg?v=1715681798'
            case 'boss2' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/boss_2d.svg?v=1715681798'
            case 'boss-swim' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/boss_2d.svg?v=1715681798'
            case 'bralette-luxe' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/LuxeBra.png?v=1734011781'
            case 'sleep-joggers' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Joggers.svg?v=1761052793'
            case 'sleep-shorts' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Sleep_shorts.svg?v=1761052793'
            case 'sleep-long-sleeve-tee' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Long_sleeve.svg?v=1761052793'
            case 'sleep-short-sleeve-tee' :
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Sleep_tee.svg?v=1761052793'
            default:
                return 'https://cdn.shopify.com/s/files/1/1412/6778/files/Baller_d_svg.svg?v=1715677804'
        }

    }

    _openModalOpenerEvents() {
        this.querySelectorAll('[data-modal-opener]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                document.querySelector('#site-overlay')?.classList?.remove('full-overlay');
                let modalID = ele.getAttribute('data-modal-opener');
                let shouldOpenModal = true;
                isColorPickerModal = false;
                cancelBoxReModal = false;
                actualLocalePrice = null;
                if (!modalID) {
                    shouldOpenModal = false;
                }

                if (modalID === 'payment-form') {
                    let address_id = event.target.closest('[data-single-container]')?.getAttribute('data-single-container')
                        || event.target.closest('[data-cc-error-container]')?.getAttribute('data-cc-error-container');
                    currentAddress = allAddresess.find(address => {
                        return address.id == address_id
                    });
                    let boxContainer = event.target.closest('[data-single-container]') || this.querySelector(`.desktop-part [data-single-container="${address_id}"]`);
                    boxContainer.querySelector('[data-subscription-details]')?.classList?.add('d-none');
                    boxContainer.querySelector('[data-payment-form]')?.classList?.remove('d-none');
                    boxContainer.querySelector('[data-same-billing-checker]') && (boxContainer.querySelector('[data-same-billing-checker]').checked = true);
                    boxContainer.querySelector('[data-billing-address-container]')?.classList?.add('d-none');
                    boxContainer.querySelector('[data-payment-form] [data-shipping_address="province"]').innerHTML =
                        `${this._provinceList().map(province =>
                            `<option value="${province}">${province}</option>`
                        ).join('')}`;
                    this._assignEditPaymentFormEvent(event, boxContainer);
                    shouldOpenModal = false;
                }
                if (modalID === 'subscription-edit' || modalID === 'item-add') {
                    let parentContainer = event.target.closest('[data-single-container]');
                    if (!parentContainer.closest('.cancelled_box') && parentContainer.querySelectorAll('[data-subscription-status]').length
                        == parentContainer.querySelectorAll('[data-subscription-status="unskip"]').length) {
                        this.querySelector('#skipGuideV2 [data-unskip-tut-text]').innerHTML =
                            modalID === 'subscription-edit' ? `Please <strong>UNSKIP</strong> before editing a subscription.`
                                : `Please <strong>unskip</strong> before adding a product.`;
                        this._loadSkipGuide(event);

                        shouldOpenModal = false;
                    }
                    if (parentContainer.closest('.cancelled_box')) {
                        cancelBoxReModal = true;
                    }
                    document.querySelector('[data-modal-section="subscription-edit"] [data-single_style="boxer"]')?.classList.add('d-none');
                }

                if (modalID === 'quick-add-tooltip-modal' || modalID === 'also-like-tooltip-modal') {
                    let isMobile = window.innerWidth <= 576;
                    if (!isMobile) {
                        shouldOpenModal = false;
                    }
                }

                if (shouldOpenModal) {
                    try {
                        this._openV2Modal(modalID);
                    } catch (e) {
                        console.log(e)
                    }
                }

                if (event.target.closest('[data-single-container]') || ['ship-now', 'skip-modal', 'shopify_payments', 'edit-payment-mobile', 'cancel-box'].includes(modalID)) {
                    let address_id = event.target.closest('[data-single-container]')?.getAttribute('data-single-container')
                        || event.target.closest('[data-cc-error-container]')?.getAttribute('data-cc-error-container')|| subscriptionData.address_id;
                    currentAddress = allAddresess.find(address => {
                        return address.id == address_id
                    });
                    currentAddressItems = allProducts.filter(item => {
                        return item.address_id == address_id
                    });
                    currentAddressSubscriptions = allSubscriptions.filter(item => {
                        return item.address_id == address_id
                    });

                    if (modalID === 'ship-now') {
                        processOrderNow = false;
                        if (event.target.closest('.disabled_shipping')) {
                            this._hideModal('ship-now');
                            this._toastMessage('Ship now is not available for this subscription!', 'error');
                            return;
                        }
                        if (event.target.closest('.disabled_color')) {
                            this._hideModal('ship-now');
                            event.target.closest('[data-single-container]')?.querySelectorAll('[data-actual-type="pick-color-modal"]').forEach(item => {
                                item.closest('.pick_color_info_box')?.classList?.add('active');
                            })
                            return;
                        }
                        this.querySelector('[data-ship-now-step-1]')?.classList.remove('d-none');
                        this.querySelector('[data-ship-now-step-2]')?.classList.add('d-none')
                        if (event.target.closest('[data-process-order-now]')) {
                            processOrderNow = true;
                        }
                    }

                    if (modalID === 'skip-modal') {
                        if (event.target.closest('.disabled_skip')) {
                            this._hideModal('skip-modal');
                            this._toastMessage('Skip is not available for this subscription!', 'error');
                            return;
                        }

                        let id = event.target.closest('[data-single-container]')?.querySelector('[data-subscription-id]:not([data-subscription-status="addon"])')
                            ?.getAttribute('data-subscription-id');
                        if (id) {
                            subscriptionData = allSubscriptions.find((item) => item.id == id);
                        }
                        this.querySelector(`.skip-modal [data-subscription-date]`).innerHTML = moment(subscriptionData.next_charge_scheduled_at).format('MMMM Do');
                        this.querySelector(`.skip-modal [data-subscription-next-date]`).innerHTML = moment(subscriptionData.next_charge_scheduled_at).add(1, 'months').format('MMMM Do');
                    }

                    if (modalID === 'shopify_payments') {
                        this.querySelector('[data-consumer-email]').innerHTML = customerData?.email || '';
                        let response = rechargeSdk._updatePaymethodMethod(currentAddress.payment_method_id, currentAddress.id);
                        if (!response) {
                            this._toastMessage('E-mail was not sent, please try again later.', 'error');
                        }
                        if (response && event.target.closest('[data-cc-error-container]')) {
                            ccSuccessMessage = true;
                            this.querySelector('[data-cc-success-message]')?.classList?.remove('d-none');
                            this.querySelector('[data-cc-error-container]')?.classList?.add('d-none');
                            if (window.innerWidth <= 576) {
                                this._hideModal('shopify_payments');
                                this._openV2Modal('cc-success-message')
                            }
                        }
                    }

                    if (modalID === 'edit-payment-mobile') {
                        let container = this.querySelector('[data-modal-section="edit-payment-mobile"]');
                        container.querySelector('[data-same-billing-checker]') && (container.querySelector('[data-same-billing-checker]').checked = true);
                        container.querySelector('[data-billing-address-container]')?.classList?.add('d-none');
                        container.querySelector('[data-shipping_address="province"]').innerHTML =
                            `${this._provinceList().map(province =>
                                `<option value="${province}">${province}</option>`
                            ).join('')}`;
                        this._assignEditPaymentFormEvent(event, container);
                    }

                    if (modalID === 'cancel-box') {
                        this.querySelector('[data-modal-section="cancel-box"]')?.classList?.remove('success');
                        isSkipDisabled = !!ele.closest('[data-single-container]')?.querySelector('[data-modal-opener="skip-modal"].disabled');
                        if (isSkipDisabled) {
                            this.querySelector('.skip_sub_button')?.classList?.add('disabled');
                        } else {
                            this.querySelector('.skip_sub_button')?.classList?.remove('disabled');
                        }
                    }
                }

                if (modalID === 'pick-color-modal') {
                    this.querySelector('.pick-color-modal [data-submit-pick-color]')?.classList?.add('disabled');
                    this.querySelectorAll('.pick-color-modal [data-color-print]').forEach(ele => ele.classList.add('d-none'));
                    this._fillItemDetailsInModal(event, modalID);
                }

                if (modalID === 'subscription-edit') {
                    if (event.target.closest('[data-actual-type="pick-color-modal"]')) {
                        isColorPickerModal = true;
                    }
                    this.querySelector('.subscription-edit [data-submit-edit-subscription]')?.classList?.add('disabled');
                    this._fillItemDetailsInModal(event, modalID);

                    let container = this.querySelector(`[data-modal-section="${modalID}"]`);
                    this.querySelectorAll('[data-style-activator]').forEach(ele => {
                        ele.closest('[data-style-activator]').setAttribute('data-style-activator', 0);
                    })
                    container.querySelector('[data-edit-style-part]')?.classList?.add('d-none');
                    container.querySelector('[data-collapsed-details]')?.classList?.add('d-none');
                    container.querySelector('[data-edit-size-part]')?.classList?.remove('d-none');
                    if (currentAddressSubscriptions.length == 1 || isColorPickerModal) {
                        container.querySelector('[data-purchase-option]')?.classList?.add('d-none');
                    } else {
                        container.querySelector('[data-purchase-option]')?.classList?.remove('d-none');
                    }
                    if (container.querySelector('[data-purchase-type-checkbox]')) {
                        container.querySelector('[data-purchase-type-checkbox]').checked = true;
                        container.querySelector('[data-purchase-option]').setAttribute('data-purchase-option', 'subscription');
                    }
                    isShipNowDisabled = !!ele.closest('[data-single-container]')?.querySelector('[data-modal-opener="ship-now"].disabled');
                    isSkipDisabled = !!ele.closest('[data-single-container]')?.querySelector('[data-modal-opener="skip-modal"].disabled');
                }

                if (modalID === 'one-time-edit') {
                    this.querySelector('.one-time-edit [data-submit-edit-one-time]')?.classList?.add('disabled');
                    this.querySelector('.one-time-edit [data-one-time-remove]')?.classList?.remove('disabled');
                    this._fillOneTimeItemDetails(event, modalID);

                    let container = this.querySelector(`[data-modal-section="${modalID}"]`);
                    this.querySelectorAll('[data-style-activator]').forEach(ele => {
                        ele.closest('[data-style-activator]').setAttribute('data-style-activator', 0);
                    })
                    container.querySelector('[data-edit-style-part]')?.classList?.add('d-none');
                    container.querySelector('[data-collapsed-details]')?.classList?.add('d-none');
                    container.querySelector('[data-edit-size-part]')?.classList?.remove('d-none');
                }

                if (modalID === 'item-add') {
                    this.querySelector('.item-add [data-submit-add-product]')?.classList?.add('disabled');
                    const addTextElement = this.querySelector('.item-add [data-submit-add-product] .add-text');
                    this.querySelector('.item-add [data-purchase-option]').setAttribute('data-purchase-option', 'oneTime');
                    if (addTextElement) {
                        addTextElement.innerHTML = 'Select a style';
                    }

                    this._initiateItemAdd(event, modalID);
                }

                if (modalID === 'unskip-modal') {
                    let id = event.target.closest('[data-single-container]')?.querySelector('[data-subscription-id]')?.getAttribute('data-subscription-id');
                    subscriptionData = allSubscriptions.find((item) => item.id == id);
                    this.querySelector(`.unskip-modal [data-subscription-date]`).innerHTML = moment(subscriptionData.next_charge_scheduled_at).subtract(1, 'months').format('MMMM Do');
                    this.querySelector(`.unskip-modal [data-subscription-next-date]`).innerHTML = moment(subscriptionData.next_charge_scheduled_at).format('MMMM Do');
                }

                if (modalID === 'unskip-tooltip-modal') {
                    let tooltipSubscription = currentAddressSubscriptions ? currentAddressSubscriptions[0] : null;
                    if (subscriptionData) {
                        this.querySelector(`.unskip-tooltip-modal [data-tooltip-prev-date]`).innerHTML = moment(tooltipSubscription.next_charge_scheduled_at).subtract(1, 'months').format('MMMM Do');
                        this.querySelector(`.unskip-tooltip-modal [data-tooltip-next-date]`).innerHTML = moment(tooltipSubscription.next_charge_scheduled_at).format('MMMM Do');
                    }
                }

                if (modalID === 'edit-address') {
                    let container = this.querySelector('.edit-address [data-shipping-edit-form]');
                    container.querySelectorAll('[data-input-container].error').forEach(ele => ele.classList.remove('error'));
                    container.querySelector('[data-change-shipping_address]').classList.add('disabled');
                    this._fillShippingAddress();
                }

                if (modalID === "cancel-popup") {
                    this.querySelector('.modal-subscription-section')?.scrollIntoView({
                        block: "center",
                        inline: "center"
                    });
                    this._hideModal('subscription-edit');
                    if (currentAddressSubscriptions.length == 1) {
                        this.querySelectorAll('[data-last-subscription-msg]').forEach((ele) => {
                            ele.classList.remove('d-none')
                        })
                    } else {
                        this.querySelectorAll('[data-last-subscription-msg]').forEach((ele) => {
                            ele.classList.add('d-none')
                        })
                    }
                    this.querySelectorAll('#cancel-popup [data-modal-opener="ship-now"]').forEach(ele => {
                        isShipNowDisabled ? ele.classList.add('disabled_shipping') : ele.classList.remove('disabled_shipping');
                    })

                    this.querySelectorAll('#cancel-popup [data-modal-opener="skip-modal"]').forEach(ele => {
                        isSkipDisabled ? ele.classList.add('disabled_skip') : ele.classList.remove('disabled_skip');
                    })

                    if (this.querySelector('[data-accept_policy]').checked) {
                        this.querySelector('[data-accept_policy]').checked = false;
                    }
                    if (this.querySelector('[data-cancel_reason]:checked') && this.querySelector('[data-cancel_reason]:checked').checked) {
                        this.querySelector('[data-cancel_reason]:checked').checked = false
                    }
                    if (this.querySelector('[data-cancel_comment]')) {
                        this.querySelector('[data-cancel_comment]').value = "";
                    }

                    this.querySelectorAll('[data-cancel-subscription]').forEach((ele) => {
                        ele.classList.add('disabled')
                    })

                    if (this.querySelector('[data-discount-info]')) {
                        this.querySelector('[data-discount-info]').innerHTML = 'Save 25% off our entire store!';
                    }
                    this._showCancelReasonError(false);
                }

                if (modalID === 'merge-box') {
                    this.querySelector('.merge-box [data-merge-box-submit]')?.classList?.add('disabled');
                    this.querySelector('[data-merge-box-first]')?.classList?.remove('d-none');
                    this.querySelector('[data-merge-box-title]')?.classList?.remove('d-none');
                    this.querySelector('[data-merge-box-second]')?.classList?.add('d-none');
                    this.querySelector('[data-merge-box-container]')?.setAttribute('data-merge-box-container', 1);
                    this.querySelectorAll('[data-merge-box]').forEach((ele, i) => {
                        ele.setAttribute('data-merge-box', '0');
                        ele.classList.remove('active_merge_box');
                    })
                }
            })
        })

        this.querySelectorAll('[data-change-shipping_address]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                this._updateShippingAddress(event)
            })
        })

        this.querySelectorAll('[data-update-payment-method]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                this._updateStripePaymentMethod(event)
            })
        })

        this.querySelector('#ship_now_flow [data-ship-now]')?.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            this._startProcessCharge();
        })

        // Manage Cancel Popup Flow events
        this.querySelector('[data-accept_policy]')?.addEventListener('change', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            this._manageCancelButton();
            if (event.target.checked) {
                event.target?.closest('.cancelCheckBox')?.classList?.remove('cancel_error');
            }
        })

        this.querySelectorAll('[data-cancel-subscription]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                if (event.target.closest('[data-cancel-subscription].disabled')) {
                    let container = event.target.closest('[data-cancel-reason-container]');
                    let reason = container.querySelector('[data-cancel_comment]');
                    let checkbox = container.querySelector('[data-accept_policy]');
                    if (reason?.value?.length <= 10) reason?.classList?.add('cancel_error');
                    if (!checkbox.checked ) checkbox.closest('.cancelCheckBox')?.classList?.add('cancel_error');
                    return false;
                }
                if (this.querySelector('[data-cancel_reason]:checked') != null) {
                    this.querySelector('[data-cancel-reason-container]').classList.remove('border', 'border-danger');
                    this.querySelector('[data-please-select-reason]').classList.remove('text-danger');
                    this.querySelector('[data-please-select-reason]').classList.add('d-none');

                    this._cancelSubscription(event);
                } else {
                    this.querySelector('[data-please-select-reason]').classList.add('text-danger');
                    this.querySelector('[data-please-select-reason]').classList.remove('d-none');
                    this.querySelector('[data-cancel-reason-container]').classList.add('border', 'border-danger');
                }
            })
        })

        this.querySelectorAll('[data-cancel-box-all-subscription]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                this._cancelSubscriptionsAndRemoveOnetimes(event);
            })
        })

        this.querySelectorAll('[data-cancel_reason]').forEach((ele) => {
            ele.addEventListener('change', (event) => {
                let reason = ele.value;
                this.querySelector('[data-please-select-reason]').classList.remove('text-danger');
                this.querySelector('[data-please-select-reason]').classList.add('d-none');
                this._manageCancelButton();
                if (isRetantionCompleted) {
                    if (reason == 'I’m unhappy with the product') {
                        this._showCancelReasonError(true)
                        if (this.querySelector('[data-cancel-reason-container] textarea')) {
                            this.querySelector('[data-cancel-reason-container] textarea').placeholder = 'Please tell us why you are unhappy with your product'
                        }
                    } else {
                        this._showCancelReasonError(false);
                        if (this.querySelector('[data-cancel-reason-container] textarea')) {
                            this.querySelector('[data-cancel-reason-container] textarea').placeholder = 'Please tell us more about your experience'
                        }
                    }
                } else {
                    this._showCancelReasonError(false);
                }
            })
        })
        this.querySelector('[data-change-popup="swap"]')?.addEventListener('click', (event) => {
            event.preventDefault();
            this._retantionOfferSwap();
        })

        const cancelCommentElement = this.querySelector('[data-cancel_comment]');
        if (cancelCommentElement) {
            cancelCommentElement.addEventListener('input', this._handleCancelComment);
            cancelCommentElement.addEventListener('focus', this._handleCancelComment);
            cancelCommentElement.addEventListener('blur', this._handleCancelComment);
        }
    }

    _assignEditPaymentFormEvent(event, container) {
        this.querySelectorAll('[data-card-details]').forEach(element => {
            element.addEventListener('keypress', (event) => {
                var target = element.getAttribute('data-card-details');
                this._checkDigit(event, target);
            })
            element.addEventListener('input', (event) => {
                var target = element.getAttribute('data-card-details');
                var maxlength = element.getAttribute('data-maxlength') || 1;
                this._checkValidation(event.target, target, parseInt(maxlength));
                container.querySelector('[data-update-payment-method]')?.classList.remove('disabled');
                container.querySelectorAll('[data-card-details]').forEach((inputEle) => {
                    if (inputEle.classList.contains('border-danger') || !inputEle.value) {
                        container.querySelector('[data-update-payment-method]').classList.add('disabled');
                    }
                })
            })
        });
    }

    _initiateItemAdd(event, modalId) {
        let container = document.querySelector(`[data-modal-section="${modalId}"]`);
        container.querySelector('[data-style-tab-button="underwear"]')?.click();
        container.querySelector('[data-actual-style-price]')?.classList?.add('d-none');
        if (cancelBoxReModal) {
            if (container.querySelector('[data-purchase-type-checkbox]')) {
                container.querySelector('[data-purchase-type-checkbox]').checked = true;
                container.querySelector('[data-purchase-type-checkbox]').disabled = true;
                container.querySelector('[data-purchase-option]').setAttribute('data-purchase-option', 'subscription');
            }
        }
        this._manageStyleBox();
    }

    _selectStyleValue(value, container) {
        let collectionHandle = value;
        if (collectionHandle) {
            collectionHandle = collectionHandle.replace("baller-high-waisted", "baller-highwaisted")
                .replace("biker-high-waisted", "biker-highwaisted");
        }
        container.querySelector('[data-style-select]').textContent = collectionHandle || 'Choose your style';
        container.querySelector('[data-style-select]').setAttribute('data-style-select', collectionHandle);

        return collectionHandle;
    }

    _selectSizeValue(value, container) {
        container.querySelector('[data-size-select]').textContent = value || 'Select a size';
        container.querySelector('[data-size-select]').setAttribute('data-size-select', value);
        container.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.remove('selected'));
        if (value) {
            container.querySelectorAll(`[data-size-select-container] .custom-option`).forEach(ele => ele.classList?.remove('selected'));
            container.querySelectorAll(`[data-size-select-container] .custom-option[data-value="${value.toLowerCase()}"]`).forEach(ele => ele.classList?.add('selected'));
        }
    }

    _fillStylePartDetails(event, container) {
        let img = this._findImageByProduct(selectedProduct)
        container.querySelector('[data-style-step-image]')?.classList?.remove('d-none');
        container.querySelector('[data-style-step-image]').src = img;
        let handle = this._selectStyleValue(selectedStyleCollection?.collection?.handle || '', container);
        let category = container.querySelector(`[data-single_style="${handle}"]`)?.dataset?.styleType;
        this._fillStyleTabDetails(container, container.querySelector(`[data-style-tab-button="${category}"]`));

        let styleContainer = container.querySelector('[data-edit-style-part]');
        this._handleItemAddColorSection(styleContainer);
        this._handleSizeSection(styleContainer);
    }

    _fillItemDetailsInModal(event, modalId) {
        let container = this.querySelector(`[data-modal-section="${modalId}"]`);
        let subscriptionId = event.target.closest('[data-subscription-id]')?.getAttribute('data-subscription-id');
        subscriptionId && (subscriptionData = allSubscriptions.find((subscription) => subscription.id == subscriptionId));
        var style = this._findSubscriptionStyle(subscriptionData);
        selectedStyleCollection = allCollections[style?.toLowerCase().replaceAll(' ', '-')];
        let productId = subscriptionData.external_product_id.ecommerce;
        let variantId = subscriptionData.external_variant_id.ecommerce;
        selectedProduct = selectedStyleCollection.products.find((item) => item.id == productId);
        let temp_size = subscriptionData?.variant_title?.split('/')[0]?.trim();
        let temp_color = subscriptionData?.variant_title?.split('/')[1]?.trim();
        selectedVariant = selectedProduct?.variants?.find(item => item.id == variantId);
        selectedSize = selectedVariant?.option1?.toLowerCase() || temp_size?.toLowerCase();
        selectedColor = selectedVariant?.option2?.toLowerCase()?.replace(/\u00A0/g, ' ')
            || temp_color?.toLowerCase()?.replace(/\u00A0/g, ' ') ;
        let imageSrc = this._getFeaturedImageSource(selectedProduct);
        let wireImage = this._findImageByProduct(selectedProduct);
        let swapImageSource = this._findColorSwatchByProduct(selectedProduct);
        selectedSizeProducts = {};
        selectedSizeProducts = selectedStyleCollection.products.filter(product => {
            return product.variants.some(variant => {
                return variant?.option1?.toLowerCase() === selectedSize && variant?.available === true && variant?.inventory_quantity >= 5;
            });
        });
        container.querySelector('[data-actual-style-price]')?.classList?.add('d-none');

        if (isColorPickerModal) {
            imageSrc = wireImage = this._findDefaultImageByCollection(style);
            selectedColor = selectedProduct = selectedVariant = null;
            container.querySelector('[data-swap-color-image]')?.classList?.add('d-none');
        } else {
            container.querySelector('[data-swap-color-image]')?.classList?.remove('d-none');
        }

        if (modalId === 'subscription-edit') {
            this._handleSizeSection(container);
            container.querySelector('[data-collapsed-image]').src = imageSrc;
            container.querySelector('[data-collapsed-name]').innerHTML = style;
            container.querySelector('[data-collapsed-size]').innerHTML = selectedSize;
            container.querySelector('[data-collapsed-color]').innerHTML = selectedColor;

            this._fillStylePartDetails(event, container);
        }

        container.querySelectorAll('[data-mobile-image]').forEach(e => e.setAttribute('src', imageSrc));
        container.querySelectorAll('[data-desktop-image]').forEach(e => e.setAttribute('src', wireImage));
        container.querySelector('[data-swap-color-image]').src = swapImageSource;
        container.querySelectorAll('[data-item-title]').forEach(e => {
            e.innerHTML = style;
            e.closest('[data-item-title]')?.setAttribute('data-item-title', style);
        });
        container.querySelectorAll('[data-item-size]').forEach(e => e.innerHTML = selectedSize || '-');
        container.querySelectorAll('[data-item-color]').forEach(e => e.innerHTML = selectedColor || '-');
        container.querySelectorAll('[data-item-price],[data-collapsed-price],[data-price-interval]').forEach(e =>
            e.innerHTML = this._formatMoney(parseFloat(subscriptionData.price) * 100));

        this._prepareColorsHtml(container);
    }

    _fillOneTimeItemDetails(event, modalId) {
        let container = this.querySelector(`[data-modal-section="${modalId}"]`);

        let addonId = event.target.closest('[data-subscription-id]')?.getAttribute('data-subscription-id');
        addonId && (addonData = allAddons.find(item => item.id == addonId));
        let productId = addonData.external_product_id.ecommerce;
        let variantId = addonData.external_variant_id.ecommerce;
        let address_id = event.target.closest('[data-single-container]')?.getAttribute('data-single-container');
        currentAddress = allAddresess.find(address => {
            return address.id == address_id
        });

        let oneTimeProduct = shopifyProductJson[productId];
        let collectionType = oneTimeProduct?.type;
        let collectionHandle = this._formatCollectionHandle(collectionType);
        selectedStyleCollection = allCollections[collectionHandle];
        let style = selectedStyleCollection?.collection?.handle;
        let temp_size = addonData?.variant_title?.split('/')[0]?.trim();
        let temp_color = addonData?.variant_title?.split('/')[1]?.trim();
        selectedProduct = selectedStyleCollection.products.find((item) => item.id == productId);
        selectedVariant = selectedProduct?.variants?.find(item => item.id == variantId);
        selectedSize = selectedVariant?.option1?.toLowerCase() || temp_size?.toLowerCase();
        selectedColor = selectedVariant?.option2?.toLowerCase()?.replace(/\u00A0/g, ' ')
            || temp_color?.toLowerCase()?.replace(/\u00A0/g, ' ');
        let imageSrc = this._getFeaturedImageSource(selectedProduct);
        let wireImage = this._findImageByProduct(selectedProduct);
        let swapImageSource = this._findColorSwatchByProduct(selectedProduct);
        selectedSizeProducts = {};
        selectedSizeProducts = selectedStyleCollection.products.filter(product => {
            return product.variants.some(variant => {
                return variant?.option1?.toLowerCase() === selectedSize && variant?.available === true && variant?.inventory_quantity >= 5;
            });
        });

        this._handleSizeSection(container);
        this._fillStylePartDetails(event, container);

        container.querySelectorAll('[data-mobile-image], [data-collapsed-image]').forEach(e => e.setAttribute('src', imageSrc));
        container.querySelectorAll('[data-desktop-image]').forEach(e => e.setAttribute('src', wireImage));
        container.querySelector('[data-swap-color-image]').src = swapImageSource;
        container.querySelectorAll('[data-item-title], [data-collapsed-name]').forEach(e => {
            e.innerHTML = style;
            e.closest('[data-item-title]')?.setAttribute('data-item-title', style);
        });
        container.querySelectorAll('[data-item-size], [data-collapsed-size]').forEach(e => e.innerHTML = selectedSize || '-');
        container.querySelectorAll('[data-item-color], [data-collapsed-color]').forEach(e => e.innerHTML = selectedColor || '-');
        container.querySelectorAll('[data-item-price],[data-collapsed-price],[data-price-interval]').forEach(e =>
            e.innerHTML = this._formatMoney(parseFloat(addonData.price) * 100));
        if (container.querySelector('[data-subscription-consent]')) {
            container.querySelector('[data-subscription-consent]').checked = false;
        }

        this._prepareColorsHtml(container);
    }

    _manageQuickAddModal(event) {
        selectedSize = selectedVariant = null;
        let container = event.target.closest('[data-quick-add-collection]');
        let collectionHandle = container.getAttribute('data-quick-add-collection');
        collectionHandle = this._formatCollectionHandle(collectionHandle);
        selectedStyleCollection = allCollections[collectionHandle];
        let style = selectedStyleCollection?.collection?.title;
        let productId = container.getAttribute('data-selected-product');
        selectedProduct = this._findProductByCollection(productId);
        let price = selectedProduct?.variants[0]?.selling_plan_allocations[0]?.price;
        let selectedSwatch = container.getAttribute('data-selected-color')?.toLowerCase().trim();
        selectedSwatch = selectedSwatch.replace('boss 2.0', '').replace('icon 2.0', '').trim();
        selectedColor = selectedSwatch?.replace(/\u00A0/g, ' ');

        let modalContainer = this.querySelector(`[data-modal-section="featured-colors"]`);
        let swapImageSource = this._findColorSwatchByProduct(selectedProduct);
        let imageSrc = selectedProduct.featured_image + '&width=300';
        let wireImage = this._findImageByProduct(selectedProduct);
        modalContainer.querySelectorAll('[data-mobile-image]').forEach(ele => ele.setAttribute('src', imageSrc));
        modalContainer.querySelectorAll('[data-desktop-image]').forEach(ele => ele.setAttribute('src', wireImage));
        modalContainer.querySelectorAll('[data-item-title]').forEach(ele => {
            ele.innerHTML = style;
            ele.closest('[data-item-title]')?.setAttribute('data-item-title', style);
        });
        modalContainer.querySelectorAll('[data-item-size]').forEach(ele => ele.innerHTML = selectedSize || '-');
        modalContainer.querySelectorAll('[data-item-color]').forEach(ele => ele.innerHTML = selectedColor || '-');
        modalContainer.querySelectorAll('[data-item-price]').forEach(ele => ele.innerHTML = this._formatMoney(parseFloat(price)));
        modalContainer.querySelector('[data-swap-color-image]') && (modalContainer.querySelector('[data-swap-color-image]').src = swapImageSource);

        this._handleItemAddColorSection(modalContainer);
        this._handleSizeSection(modalContainer);
    }

    _prepareColorsHtml(container) {
        let limitedColorsHtml = "";
        let coreColorsHtml = "";
        let selectedSwatchType = '';
        let allColorsInHtml = [];
        let isCoreColorAvailable = false;
        selectedSizeProducts.forEach((product) => {
            let color = product.variants[0]?.option2?.toLowerCase();
            if (color && !product?.type?.includes('pack')) {
                let colorSrc = this._findColorSwatchByProduct(product);
                let isLimited = product.tags.includes('pp-limited_color') || false;
                let isColorAvailable = selectedSize ? this._isColorAvailableForSize(color) : true;
                let isColorAvailableForAnySize = this._isColorAvailableForAnySize(color);
                let selectedSwatch = selectedProduct && selectedProduct.id == product.id;
                let repeatedColor = allColorsInHtml.includes(color);
                let colorHtml = `
                <a href="#" data-color-product-id="${product.id}" 
                class="d-block rounded-circle swatch-image position-relative ${color === 'pride pure' ? 'highlight-color' : ''} ${!isColorAvailable ? 'unavailable ' : ''}
${selectedSwatch ? 'selected' : ''} ${!isColorAvailableForAnySize || repeatedColor ? 'd-none' : ''}"
                 data-color="${color}" aria-label="${color}" data-color-type="${isLimited ? 'limited' : 'core'}" >
                    <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
                </a>
            `;
                allColorsInHtml.push(color);
                if (selectedSwatch) {
                    selectedSwatchType = selectedSwatch && isLimited ? 'limited' : 'core';
                }
                if (isLimited) {
                    limitedColorsHtml += colorHtml;
                } else {
                    coreColorsHtml += colorHtml;
                    if (isColorAvailableForAnySize && !repeatedColor) isCoreColorAvailable = true;
                }
            }
        });

        container.querySelector(`[data-limited-container]`).innerHTML = limitedColorsHtml;
        container.querySelector(`[data-core-container]`).innerHTML = coreColorsHtml;

        if (!limitedColorsHtml) {
            container.querySelectorAll(`[data-limited-color-container]`).forEach(el => el.classList.add('d-none'));
        } else {
            container.querySelectorAll(`[data-limited-color-container]`).forEach(el => el.classList.remove('d-none'));
        }

        if (!isCoreColorAvailable) {
            container.querySelectorAll(`[data-core-color-container]`).forEach(el => el.classList.add('d-none'));
        } else {
            container.querySelectorAll(`[data-core-color-container]`).forEach(el => el.classList.remove('d-none'));
        }

        if (selectedColor) {
            container.querySelectorAll('[data-color-print]').forEach(ele => ele.innerHTML = selectedColor);
            container.querySelector(`[data-color-print="${selectedSwatchType === 'limited' ? 'limited' : 'core'}"]`)?.classList?.remove('d-none');
        }

        let isMobile = window.innerWidth <= 575;
        if (!isMobile) {
            this._bindMouseOverEffectColor(container);
        }
        this._bindColorEvents(container);
    }

    _bindColorEvents(container) {
        container.querySelectorAll('[data-color-product-id]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                ele.closest('[data-color-container]')?.querySelector('.selected')?.classList.remove('selected');
                ele.closest('[data-color-product-id]')?.classList.add('selected');
                selectedColor = ele.getAttribute('data-color')?.replace(/\u00A0/g, ' ');
                let productId = ele.getAttribute('data-color-product-id');
                selectedProduct = this._findProductByCollection(productId);
                selectedVariant = this._findColorVariantBySize(selectedProduct);
                if (!container.closest('[data-modal-section="pick-color-modal"]')) this._handleSizeSection(container);
                let swapImageSource = this._findColorSwatchByProduct(selectedProduct);
                container.querySelectorAll('[data-item-color]').forEach(e => e.innerHTML = selectedColor || '-');
                let imageSrc = this._getFeaturedImageSource(selectedProduct);
                let wireImage = this._findImageByProduct(selectedProduct);
                if (container.querySelector('[data-swap-color-image]')) {
                    container.querySelector('[data-swap-color-image]')?.classList?.remove('d-none');
                    container.querySelector('[data-swap-color-image]').src = swapImageSource;
                }

                container.querySelectorAll('[data-desktop-image]').forEach(e => e.setAttribute('src', wireImage));
                container.querySelectorAll('[data-mobile-image]').forEach(e => e.setAttribute('src', imageSrc));

                if (selectedVariant) {
                    container.querySelector('[data-submit-pick-color]')?.classList?.remove('disabled')
                    container.querySelector('[data-submit-edit-subscription]')?.classList?.remove('disabled');
                    container.querySelector('[data-submit-edit-one-time]')?.classList?.remove('disabled');
                }

                let type = ele.getAttribute('data-color-type');
                let colorPrint = container.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                if (colorPrint) {
                    container.querySelectorAll(`[data-color-print]`).forEach(ele => ele.classList.add('d-none'));
                    colorPrint?.classList?.remove('d-none');
                    colorPrint.innerHTML = selectedColor;
                }
            })
        })
    }

    _getPriceInterval(container) {
        let divs = container.querySelectorAll('[data-price-value]:not(.d-none)');
        let prices = Array.from(divs).map(div => {
            let rate = parseFloat(div.getAttribute('data-price-value'));
            if (!isNaN(rate)) return rate;
        });
        prices = prices.filter(Boolean);
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);

        return [minPrice, maxPrice];
    };

    _getFeaturedImageSource(product) {
        if (product?.featured_image) {
            return product?.featured_image + '&width=250';
        }
        let productId = subscriptionData?.external_product_id?.ecommerce || addonData?.external_product_id?.ecommerce;
        if (productId && allMissingProducts[productId]) {
            return allMissingProducts[productId].featured_image;
        }
        return this._findDefaultImageByCollection(selectedStyleCollection?.collection?.handle);
    }

    _manageCancelButton() {
        let checked = this.querySelector('#cancel-popup [data-accept_policy]').closest('input').checked;
        let isReasonFilled = this.querySelector('[data-cancel_comment]').value && this.querySelector('[data-cancel_comment]').value.length >= 10;
        let reasonSelected = this.querySelector('[data-cancel_reason]:checked') && this.querySelector('[data-cancel_reason]:checked').checked
        if (reasonSelected && this.querySelector('[data-cancel_reason]:checked')?.value !== 'Others') {
            isReasonFilled = true;
        }
        if (checked) {
            this.querySelector('[data-cancel_reason]')?.closest('.cancelCheckBox')?.classList?.remove('cancel_error');
        }
        if (isReasonFilled) {
            this.querySelector('[data-cancel_comment]')?.classList?.remove('cancel_error');
        }
        if (checked && isReasonFilled && reasonSelected) {
            this.querySelectorAll('[data-cancel-subscription]').forEach((ele) => {
                ele.classList.remove('disabled')
            })

        } else {
            this.querySelectorAll('[data-cancel-subscription]').forEach((ele) => {
                ele.classList.add('disabled')
            })
        }
    }

    _isSizeAvailableForColor(size, collection = selectedStyleCollection) {
        let available = false;
        collection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5 && (variant.option1?.toLowerCase() == size.toLowerCase()) && (variant.option2?.toLowerCase() == selectedColor)) {
                        available = true;
                    }
                })
            }
        })

        return available;
    }

    _isColorAvailableForSize(color) {
        let available = false;
        selectedStyleCollection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5 && (variant.option2?.toLowerCase()?.replace(/\u00A0/g, ' ') == color?.toLowerCase()) && (variant.option1?.toLowerCase() == selectedSize)) {
                        available = true;
                    }
                })
            }
        })

        return available;
    }

    _isColorAvailableForAnySize(color) {
        let available = false;
        selectedStyleCollection.products.forEach(product => {
            if (product.tags?.includes('SUBSCRIPTION_SHOW_ALWAYS')) {
                available = true;
            } else {
                product.variants?.forEach(variant => {
                    if (variant?.available && variant?.inventory_quantity >= 5 && (variant?.option2?.toLowerCase() == color?.toLowerCase()?.replace(/\u00A0/g, ' '))) {
                        available = true;
                    }
                })
            }
            if (window.globalVariables.woxer_only === 'true') {
                if (product?.tags?.includes(window.globalVariables.woxer_only_product_tag) == true && !customerData?.email?.includes('@woxer.com')) {
                    available = false
                }
            }
        })
 
        return available;
    }

    async _addOneTimeItemInSubscription(event) {
        this._loadButton(event.target);
        currentAddress = allAddresess.find((address) => {
            return this._nearestScheduleSubscription()?.address_id == address.id
        });
        let price = ((selectedVariant.selling_plan_allocations[0]?.price || 0) / 100.00) || selectedVariant.price / 100.00;
        let properties = [{ "name": "connected_address_id", "value": currentAddress.id.toString() }];

        if (currentAddress.presentment_currency == "CAD" && selectedProduct) {
            if (Shopify?.currency?.active === 'CAD' && actualLocalePrice) {
                price = actualLocalePrice/100
            } else {
                await this._getCARate2(selectedProduct.id);
                price = price*(canadaRate || 1)
            }
        }

        let config = {
            address_id: currentAddress.id,
            add_to_next_charge: true,
            quantity: 1,
            external_variant_id: {
                ecommerce: selectedVariant.id.toString()
            },
            presentment_currency: currentAddress.presentment_currency,
            price: price.toString(),
            use_shopify_variant_defaults: true,
            properties: properties
        }

        let response = await rechargeSdk._createOnetimeAddon(config);
        if (response) {
            await this._loadSubscriptionData();
            this._toastMessage('Product Successfully Added', 'success');
        } else {
            this._toastMessage('Something went wrong. try again!', 'error');
            this._loadButton(event.target, false);
        }
    }

    _nearestScheduleSubscription() {
        let today = moment();

        let nearestSubscription = allSubscriptions ? allSubscriptions[0] : null;
        let nearestDateDifference = Math.abs(moment(nearestSubscription.next_charge_scheduled_at).diff(today));

        allSubscriptions.forEach(subscription => {
            let subscriptionDate = moment(subscription.next_charge_scheduled_at);
            let dateDifference = Math.abs(subscriptionDate.diff(today));

            if (dateDifference < nearestDateDifference) {
                nearestDateDifference = dateDifference;
                nearestSubscription = subscription;
            }
        });

        return nearestSubscription;
    }

    _capitalizeWords(str) {
        return str.replace(/\b\w/g, function (char) {
            return char.toUpperCase();
        });
    }

    async _updateShippingAddress(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        event.target.closest('button').classList.add('loading');
        let shippingAddressObj = {};
        event.target.closest('[data-shipping-edit-form]').querySelectorAll('[data-shipping_address]').forEach(ele => {
            if (ele.getAttribute('data-shipping_address') != 'country_code') {
                shippingAddressObj[ele.getAttribute('data-shipping_address')] = ele.value;
            }
        });
        var response = await rechargeSdk._updateShippingAddress(currentAddress.id, shippingAddressObj);
        if (response == true) {
            await this._loadSubscriptionData();
            this._toastMessage('Address successfully updated', 'success');
        } else if (typeof response === 'string') {
            this._toastMessage(response, 'error');
            this.querySelector('[data-shipping_address="zip"]')?.closest('[data-input-container]')?.classList?.add('error');
        } else {
            this._toastMessage('Please enter a valid address', 'error');
        }
        event.target.closest('button').classList.remove('loading');
        document.body.classList.remove('pointer-events-none');
    }

    /**
     * Validation function on focusout
     **/
    _checkValidation(event, target, maxlength) {
        event.classList.remove('border-danger')
        if (target == 'CN') {
            if (event.value.length > 0 && event.value.length <= maxlength) {
                // event.nextElementSibling?.classList.add('d-none');
                event.nextElementSibling?.setAttribute('data-card-error', 'false');
                return true;
            } else {
                event.classList.add('border-danger');
                event.nextElementSibling?.classList.remove('d-none');
                event.nextElementSibling?.setAttribute('data-card-error', 'true');
                return false;
            }
        } else if (target == 'EX') {
            if (event.value.length > 0 && event.value.length <= maxlength) {
                // event.nextElementSibling?.classList.add('d-none');
                event.nextElementSibling?.setAttribute('data-card-error', 'false');
                return true;
            } else {

                event.classList.add('border-danger');
                event.nextElementSibling?.setAttribute('data-card-error', 'true');
                event.nextElementSibling?.classList.remove('d-none');
                return false;
            }
        } else if (target == 'CVV') {
            if (event.value.length > 0 && event.value.length <= maxlength) {
                // event.nextElementSibling?.classList.add('d-none');
                event.nextElementSibling?.setAttribute('data-card-error', 'false');
                return true;
            } else {
                event.classList.add('border-danger');
                event.nextElementSibling?.classList.remove('d-none');
                event.nextElementSibling?.setAttribute('data-card-error', 'true');
                return false;
            }
        }
    }

    async _updateStripePaymentMethod(event) {
        try {
            this._loadButton(event.target);
            let cardModal = event.target.closest('#editPaymentCard')
            let paymentMethod = allPayments.find(payment => {
                return payment.id == currentAddress.payment_method_id
            })
            let url = '/community/api/update-payment-method';
            let paymentConfig = {
                type: 'card',
                card_number: parseInt(cardModal.querySelector('[data-card-details="CN"]').value.replaceAll(' ', '')),
                exp_month: cardModal.querySelector('[data-card-details="EX"]').value.split('/')[0],
                exp_year: new Date().getFullYear().toString().slice(0, 2) + cardModal.querySelector('[data-card-details="EX"]').value.split('/')[1],
                cvc: cardModal.querySelector('[data-card-details="CVV"]').value.split('/')[0],
                shopify_customer_id: customerData.external_customer_id.ecommerce,
                recharge_customer_id: customerData.id,
                payment_method_id: paymentMethod.processor_payment_method_token,
                recharge_payment_id: paymentMethod.id,
                stripe_customer_id: paymentMethod.processor_customer_token,
                email: customerData.email
            }
            let response = await fetch(url,
                {
                    method: 'PUT',
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(paymentConfig)
                })
            ;
            let data = response.json();
            if (response.ok) {
                successModal = 'updateStripe';
                await this._loadSubscriptionData();
                let isMobile = window.innerWidth <= 575;
                if (!isMobile) {
                    let currentAddressId = currentAddress?.id || allAddresess[0]?.id;
                    let container = this.querySelectorAll(`.desktop-part [data-single-container="${currentAddressId}"]`);
                    container?.querySelector('[data-payment-edit-success]')?.classList?.remove('d-none');
                } else {
                    this._toastMessage('Payment method successfully updated', 'success');
                }
            } else {
                this._toastMessage('Please enter a valid payment method', 'error');
            }
        } catch (error) {
            // log the error message to the console
            let message = JSON.parse(error.message)
        }
        this._loadButton(event.target, false);
    }

    async _skipSubscription(event, eventType) {
        event.stopImmediatePropagation();
        event.target.closest('button')?.classList?.add('loading');
        let successResponse = false;

        if (eventType == 'skip') {
            await this._listCharges(currentAddress.id);
            let subscriptionCharge = allCharges.find((charge) => {
                return charge.line_items.some(item => (item.purchase_item_id === subscriptionData.id) && charge.status.toLowerCase() == 'queued' && moment(subscriptionData.next_charge_scheduled_at).isSame(charge.scheduled_at));
            })
            document.body.classList.add('pointer-events-none')
            while (subscriptionCharge == undefined) {
                await new Promise(resolve => setTimeout(resolve, 5000));
                await this._listCharges(currentAddress.id);
                subscriptionCharge = allCharges.find((charge) => {
                    return charge.line_items.some(item => (item.purchase_item_id === subscriptionData.id) && charge.status.toLowerCase() == 'queued' && moment(subscriptionData.next_charge_scheduled_at).isSame(charge.scheduled_at));
                })
            }
            let purchaseItemIds = [subscriptionData.id];
            if (skipAllCharges) {
                purchaseItemIds = this._getActiveSubscriptions(currentAddress.id) ? this._pluck(this._getActiveSubscriptions(currentAddress.id), 'id') : [subscriptionData.id];
            }
            let response = await rechargeSdk._skipCharge(subscriptionCharge.id, purchaseItemIds);

            // Remove Addons if it's last subscription
            let skippedChargesOnsameAddress = allCharges.find((charge) => {
                return (subscriptionData.address_id == charge.address_id && charge.status.toLowerCase() == 'skipped');
            })
            let isRemove = false;
            if (skippedChargesOnsameAddress) {
                isRemove = skippedChargesOnsameAddress.line_items.length == (currentAddressSubscriptions.length - 1) ? true : false;
            }
            if (currentAddressSubscriptions.length == 1) {
                isRemove = true;
            }
            if (skipAllCharges) {
                isRemove = true;
            }
            if (isRemove && allAddons.length) {
                let addons = allAddons.filter(item => item.address_id == currentAddress.id);
                for (const addon of addons) {
                    await rechargeSdk._removeOnetime(addon.id);
                }
            }
            await this._loadSubscriptionData();
            if (response) {
                successResponse = true;
                this._toastMessage('Subscription Successfully Skipped', 'success');
            }
        } else {
            let address_id = event.target.closest('[data-single-container]')?.getAttribute('data-single-container') || subscriptionData.address_id;
            currentAddress = allAddresess.find(address => {
                return address.id == address_id
            });
            let properties = subscriptionData.properties.filter(prop => !ignoreProperties.includes(prop.name));

            document.body.classList.add('pointer-events-none')
            let is_old_charge_date = subscriptionData.properties.find((prop) => {
                return prop.name == "old_charge_date" && prop.value != null
            });
            if (is_old_charge_date) {
                let next_charge_date = moment(subscriptionData.next_charge_scheduled_at).add(eventType == 'skip' ? 1 : -1, 'months').format('YYYY-MM-DD');
                successModal = null;
                let config = {
                    next_charge_scheduled_at: next_charge_date,
                    properties: properties
                }
                let response = await rechargeSdk._updateSubscription(subscriptionData.id, config);
                if (response) {
                    successResponse = true;
                    await this._loadSubscriptionData();
                }
            } else {
                let subscriptionCharge = allCharges.find((charge) => {
                    return charge.line_items.some(item => item.purchase_item_id === subscriptionData.id && charge.status.toLowerCase() == 'skipped');
                })
                let purchaseItemIds = [subscriptionData.id];
                if (skipAllCharges) {
                    purchaseItemIds = this._getActiveSubscriptions(currentAddress.id) ? this._pluck(this._getActiveSubscriptions(currentAddress.id), 'id') : [subscriptionData.id];
                }
                let response = await rechargeSdk._unskipCharge(subscriptionCharge.id, purchaseItemIds);
                successModal = null;
                await this._loadSubscriptionData();
                if (response) {
                    this._toastMessage('Subscription Successfully Un-Skipped', 'success');
                    successResponse = true;
                }
            }
        }

        document.body.classList.remove('pointer-events-none')
        if (!successResponse) {
            event.target.closest('button')?.classList?.remove('loading');
            this._toastMessage('Something went wrong. Try again!', 'error')
        }
    }

    async _startProcessCharge() {
        try {
            this.querySelector('#ship_now_flow [data-ship-now-step-1]')?.classList.add('d-none');
            this.querySelector('#ship_now_flow [data-ship-now-step-2]')?.classList.remove('d-none');
            this.querySelectorAll('[data-dismiss="modal"]').forEach((ele) => {
                ele.classList.add('disabled')
            })
            if (!processOrderNow) {
                await this._convertToSameChargeDate();
            }
            this.querySelector('[data-ship-now-step-2] [data-total-items]').innerHTML = currentAddressItems.length;
            let totalItems = currentAddressItems.length;
            let singleItemTime = 3;
            let singleItemProcessPercentage = 100 / totalItems;
            let processItemNumber = 0;
            // this.querySelector('[data-progress-bar]').style.width = `0%`;
            let totalSeconds = (totalItems * singleItemTime) + 2;
            let secondsPerItem = parseInt(totalSeconds / totalItems);
            setInterval(() => {
                let percentage = singleItemProcessPercentage * processItemNumber;
                let dataShipContent = this.querySelector('[data-ship-status-content]');
                if (processItemNumber < totalItems) {
                    processItemNumber++;
                    // this.querySelector('#ship_now_flow [data-progress-bar]').style.width = `${percentage}%`;
                    this.querySelector('#ship_now_flow [data-proceed-items]').innerHTML = processItemNumber;

                    if (totalItems <= 2) {
                        if (percentage >= 0 && percentage <= 33) {
                            dataShipContent.innerHTML = `Assembling your box ...`;
                        } else if (percentage > 33) {
                            dataShipContent.innerHTML = `Preparing your shipment ...`;
                            this.querySelector('#ship_now_flow [data-ship-note]').style.color = '#B6B6B6';
                        }
                    } else {
                        if (percentage >= 0 && percentage <= 33) {
                            dataShipContent.innerHTML = `Assembling your box ...`;
                        } else if (percentage > 33 && percentage <= 66) {
                            dataShipContent.innerHTML = `Labeling your package ...`;
                        } else if (percentage > 66 && percentage <= 100) {
                            dataShipContent.innerHTML = `Preparing your shipment ...`;
                            this.querySelector('#ship_now_flow [data-ship-note]').style.color = '#B6B6B6';
                        }
                    }
                }
            }, secondsPerItem * 1000)
            await this._listUpcomingQueuedCharges(currentAddress.id);

            const response = await this._processCharge();
            if (response) {
                setTimeout(async () => {
                    this.querySelector('#ship_now_flow [data-ship-email]').innerHTML = customerData?.email;
                    this.querySelector('#ship_now_flow [data-ship-date]').innerHTML = moment().add(1, 'months').format('MMMM Do');
                    this.querySelector('#ship_now_flow [data-ship-now-step-2]')?.classList.add('d-none');
                    this.querySelector('#ship_now_flow [data-ship-now-step-3]')?.classList.remove('d-none');
                    await this._loadSubscriptionData();
                }, totalItems * secondsPerItem * 1000);
            } else {
                this._toastMessage('Something went wrong. try again!', 'error');
                this.querySelector('#ship_now_flow [data-ship-now-step-2]')?.classList.add('d-none');
                this.querySelector('#ship_now_flow [data-ship-now-step-1]')?.classList.remove('d-none');
                this._hideModal('ship-now');
                await this._loadSubscriptionData();
            }
            this.querySelectorAll('[data-dismiss="modal"]').forEach((ele) => {
                ele.classList.remove('disabled')
            })
        } catch (e) {
            this._hideModal('ship-now');
            this.querySelectorAll('[data-dismiss="modal"]').forEach((ele) => {
                ele.classList.remove('disabled')
            })
        }
    }

    async _convertToSameChargeDate(event) {
        let chargeDate = currentAddressItems[0].next_charge_scheduled_at;
        let promises = [];
        for (let item of currentAddressItems) {
            if (!moment(chargeDate).isSame(item.next_charge_scheduled_at)) {
                let config = {
                    next_charge_scheduled_at: chargeDate
                }
                promises.push(await rechargeSdk._updateSubscription(item.id, config));
            }
        }
        if (promises.length > 0) {
            const response = await Promise.all(promises);
            return response.length > 0;
        } else {
            return true;
        }

    }

    async _listUpcomingQueuedCharges(addressID) {
        let config = {
            ...(addressID && { address_id: addressID }),
            status: 'queued',
            limit: 25,
            sort_by: 'id-asc',
        }
        allUpcomingQueuedCharges = await rechargeSdk._getCharges(config);
    }

    _getActiveSubscriptions(address_id) {
        const subscriptions = [];
        allSubscriptions.forEach(sub => {
            if (sub.address_id == address_id && sub.status === 'active') {
                subscriptions.push(sub);
            }
        })
        return subscriptions;
    }

    _pluck(array, key) {
        return array.map(obj => obj[key]);
    }

    async _processCharge() {
        let promises = [];
        let allCharges = allUpcomingQueuedCharges;
        if (processOrderNow && allErrorCharges && allErrorCharges.length) {
            let pendingCardUpdatedError = allErrorCharges.find(err => {
                return err.error_type.toUpperCase() === 'CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT' && err.address_id == currentAddress.id;
            });
            if (pendingCardUpdatedError) {
                allCharges.push(pendingCardUpdatedError)
            }
        }
        for (let charge of allCharges) {
            promises.push(await rechargeSdk._processCharge(charge.id));
        }
        const response = await Promise.all(promises);
        if (response) {
            if (response[0] && response[0].status && response[0].status !== 'error' && !response[0].error) {
                return await true;
            } else {
                return await false;
            }
        }
    }

    async _cancelSubscription(event) {
        let offer = document.querySelector('[data-cancel_reason]:checked').value;
        retantionOffer = document.querySelector(`[data-retantion_offer="${offer}"]`);
        var isRetantion = false;
        if (this.querySelector(`[data-retantion_offer="${offer}"]`)) {
            retantionOffer = JSON.parse(retantionOffer.innerHTML)
            if (retantionOffer.retantion_type == 'swap') {
                isRetantion = this._triggerRetantionOffer(event);
            } else if (retantionOffer.retantion_type == 'skip') {
                if (currentAddressSubscriptions.length > 1) {
                    isRetantion = false;
                } else {
                    isRetantion = this._triggerSkipRetantionOffer(event);
                }
            }
        }
        if (!isRetantion) {
            if ((retantionOffer != undefined || retantionOffer != null) && retantionOffer.retantion_swapping_reason == "I’m unhappy with the product" && this.querySelector('[data-cancel_comment]').value == "" && isRetantionCompleted) {
                this._showCancelReasonError(true);
                return false;
            } else {
                this._showCancelReasonError(false);
            }
            event.target.closest('.btn').classList.add('loading');
            let config = {
                cancellation_reason: `${this.querySelector('[data-cancel_reason]:checked').value}${currentAddressSubscriptions.length == 1 ? '.' : ''}`,
                cancellation_reason_comments: this.querySelector('[data-cancel_comment]').value
            }
            const response = await rechargeSdk._cancelSubscription(subscriptionData.id, config);
            // let response = false;
            if (response) {
                if (currentAddressSubscriptions.length == 1 && allAddons.length > 0) {
                    let addons = allAddons.filter(item => item.address_id == currentAddress.id);
                    this._detleBulkAddons(addons);
                    // Utility.notification('','Your Subscription has been cancelled','success');
                } else {
                    // Utility.notification('','Your Subscription has been cancelled','success');
                    this.querySelector('[data-cancel_reason]:checked').checked = false;
                    this.querySelector('[data-cancel_comment]').value = "";
                    this.querySelectorAll('[data-cancel-subscription]').forEach((ele) => {
                        ele.classList.add('disabled')
                    })
                    this.querySelector('[data-accept_policy]').checked = false;
                }
                successModal = 'cancel';
                await this._loadSubscriptionData();
                this._toastMessage('Subscription successfully cancelled', 'success');
            }
        }
    }

    _loadSkipGuide(event) {
        let container = event.target.closest('[data-single-container]')
        let skipModal = this.querySelector('#skipGuideV2');
        document.body.classList.add('overflow-hidden');
        try {
            let skipModalContent = skipModal ? skipModal.querySelector('.skip-guide-modal') : null;
            skipModalContent.classList.add('d-block');

            let skipGuideDynamicSection = skipModal.querySelector('#skipGuideDynamicSection');
            let skipGuideTooltipTextEl = skipGuideDynamicSection.querySelector('.wx-tooltip-text');

            let isMobile = window.innerWidth <= 576;
            let selectors = [
                isMobile ? '.mobile-part [data-modal-opener="unskip-modal"]' : '.desktop-part [data-modal-opener="unskip-modal"]',
            ];

            let tooltipPositions = ['top-right'];
            let tooltipStyles = ['95%'];
            let tooltipMobileStyles = ['50%'];

            skipModal.querySelectorAll('[data-skip-step], [data-skip-guide]').forEach(button => {
                button.addEventListener('click', (event) => {
                    skipModalContent?.classList.remove('d-block');
                    skipGuideDynamicSection?.classList.add('d-none');
                    container.querySelector(selectors[0])?.classList?.remove('p-2');
                    container.querySelector(selectors[0])?.classList?.remove('current_tutorial_step');
                    document.body.classList.remove('overflow-hidden');
                })
            });

            document.body.addEventListener('keypress', (event) => {
                let key = event.key?.toLowerCase();
                if (key === 'enter') {
                    skipModalContent?.classList.remove('d-block');
                    skipGuideDynamicSection?.classList.remove('d-none');
                }
            })

            try {
                skipGuideDynamicSection.classList.remove('tooltip-active');

                skipGuideDynamicSection.querySelector(`.wx-tooltip-text [data-skip-tooltip-content="1"]`)?.classList.remove('d-none');

                skipGuideDynamicSection.classList.remove('d-none');
                skipGuideDynamicSection.classList.add(tooltipPositions[0]);

                skipGuideTooltipTextEl.style.left = !isMobile ? tooltipStyles[0] : tooltipMobileStyles[0]

                let selector = selectors[0] || 0;
                let element = container.querySelector(selector);

                if (!element) return;

                element.classList.add('px-8');
                element.classList.add('current_tutorial_step');

                let elementPosition = {};

                //set width
                elementPosition.width = element.offsetWidth;

                //set height
                elementPosition.height = element.offsetHeight;

                //calculate element top and left
                elementPosition.top = 0;
                elementPosition.left = 0;

                while (element && !isNaN(element.offsetLeft) && !isNaN(element.offsetTop)) {
                    elementPosition.top += element.offsetTop;
                    elementPosition.left += element.offsetLeft;
                    element = element.offsetParent;
                }

                skipGuideDynamicSection.style.height = `${elementPosition.height + 4}px`;
                skipGuideDynamicSection.style.width = `${elementPosition.width + 4}px`;
                skipGuideDynamicSection.style.top = `${elementPosition.top - 3}px`;
                skipGuideDynamicSection.style.left = `${elementPosition.left - 3}px`;

                skipGuideDynamicSection.classList.add('tooltip-active');

                this.querySelector(selector)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
            } catch (e) {
                console.error(e)
            }
        } catch (e) {
            console.error(e);
        }
    }

    _manageOldTopSubscriberTag = async () => {
        let customerTags = JSON.parse(window.customerDetails?.customerTags || '[]');
        if (window.customerDetails?.customerTags.length) {
            if (customerTags.includes('OLD_TOP_SUBSCRIBER')) {
                if (allTopSubscription.length == 0) {
                    // Remove the "OLD_TOP_SUBSCRIBER" tag
                    customerTags = customerTags.filter(tag => tag !== "OLD_TOP_SUBSCRIBER");
                    await this._callGraphQL(customerTags);
                    window.location.reload();
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    _getChargeErrorReason(type) {
        let preText = 'The transaction was declined';
        let prePaymentText = 'Your payment was declined';
        let postText = 'Please update your payment method and we will automatically reprocess your order within 24 hours.';
        let lastText = `<a href="javascript:void(0);" class="text-decoration-underline fw-bold" data-zowie-start="">Contact</a> customer service if the issue persists.`
        switch (type) {
            case 'CARD_DECLINED': return `${preText} because your card needs to be updated. ${postText} ${lastText}`;
            case 'CARD_EXPIRED': return `${prePaymentText} because your card has expired. ${postText}`;
            case 'CARD_NUMBER_INCORRECT': return `${prePaymentText} because the card number is incorrect. ${postText}`;
            case 'EXPIRED_PAYMENT_METHOD': return `${prePaymentText} because your card has expired. ${postText}`;
            case 'INSUFFICIENT_FUNDS': return `${prePaymentText} due to insufficient funds. ${postText}`;
            case 'CARDNUMBER_INCORRECT': return `${prePaymentText} because the card number is incorrect. ${postText}`;
            case 'PURCHASE_TYPE_NOT_SUPPORTED_BY_CARD': return `${prePaymentText} because this purchase type is not supported by your card. ${postText}`;
            case 'BUYER_CANCELED_PAYMENT_METHOD': return `${preText} because your card needs to be updated. ${postText} ${lastText}`;
            case 'INVALID_PAYMENT_METHOD': return `${preText} because your card needs to be updated. ${postText} ${lastText}`;
            case 'PAYMENT_METHOD_DECLINED': return `${preText} because your card needs to be updated. ${postText} ${lastText}`;
            case 'PAYMENT_METHOD_NOT_FOUND': return `${preText} because your card needs to be updated. ${postText} ${lastText}`;
            default: return `${preText} because your card needs to be updated. ${postText} ${lastText}`;
        }
    }

    _getGeneralErrorReason(type) {
        switch (type) {
            case "VARIANT_DOES_NOT_EXIST": return 'due to variant error';
            case "UNEXPECTED_VARIANT_ERROR_TYPE": return 'due to variant error';
            case 'SHIPPING_RATE_ERROR': return 'due to shipping rate error';
            default: return ''
        }
    }

    _manageCustomerDashboardLoadingTag=async ()=>{
        let customerTags = JSON.parse(window.customerDetails?.customerTags || '[]');
        if (window.customerDetails?.customerTags.length) {
            if (isLoadedDone && customerTags.includes('Dashboard Failed')) {
                customerTags = customerTags.filter(tag => tag !== "Dashboard Failed")
            }else if(!isLoadedDone && !customerTags.includes('Dashboard Failed')){
                customerTags.push('Dashboard Failed')
            }
            else if(!isLoadedDone && customerTags.includes('Dashboard Failed')){
                return false;
            }else if(isLoadedDone && !customerTags.includes('Dashboard Failed')){
                return false;
            }
            await this._callGraphQL(customerTags);
        }
    }

    _callGraphQL = async (customerTags) => {
        if (!customerData?.external_customer_id?.ecommerce) return;
        let input = {
            id: `gid://shopify/Customer/${customerData.external_customer_id.ecommerce}`,
            tags: customerTags
        };

        let query = `
        mutation customerUpdate($input: CustomerInput!) {
            customerUpdate(input: $input) {
            customer {
                id
                tags
            }
            }
        }`;

        let url = '/community/api/graphql';

        let requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: { input: input }
            })
        };

        try {
            let response = await fetch(url, requestOptions);
            if (response.ok) {
                let data = await response.json();
                let tags = data?.data?.customerUpdate?.customer?.tags
                if (tags.length) {
                    tags = JSON.stringify(tags);
                    window.customerDetails.customerTags = tags;
                }
                return data;
            }
        } catch (error) {
            console.error('Error:', error);
        }
        return await false;
    }

    _getProduct = async (productId) => {
        let id = `gid://shopify/Product/${productId}`;

        let query = `
        query GetProductById($id: ID!) {
            product(id: $id) {
                title
                images(first: 15) {
                  edges {
                    node {
                      url
                    }
                  }
                }
                 featuredImage {
                  url
                }
            }
        }`;

        let url = '/community/api/graphql';

        let requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: { id: id } // Pass the input as a variable
            })
        };

        try {
            let response = await fetch(url, requestOptions);
            if (response.ok) {
                let data = await response.json();
                if (data) {
                    let lastImageUrl = data?.data?.product?.images?.edges?.slice(-1)[0]?.node?.url;
                    let featuredImage = data?.data?.product?.featuredImage?.url;

                    allMissingProducts[productId] = {
                        last_image:  lastImageUrl,
                        featured_image: featuredImage
                    };
                }
                return data;
            }
        } catch (error) {
            console.error('Error:', error);
        }
        return false;
    }


    _triggerRetantionOffer = (event) => {

            if (retantionOffer) {
                if (retantionOffer.retantion_swapping_reason == 'I’m unhappy with the product') {
                    this.querySelector('[data-change-popup="swap"][data-link-subcategory]')?.setAttribute('data-link-subcategory', 'UnhappyYesSwap')
                } else if (retantionOffer.retantion_swapping_reason == 'I have too much product') {
                    this.querySelector('[data-change-popup="swap"][data-link-subcategory]')?.setAttribute('data-link-subcategory', 'TooProductYesSwap')
                } else {
                    this.querySelector('[data-change-popup="swap"][data-link-subcategory]')?.setAttribute('data-link-subcategory', 'RetentionYesSwap')
                }
            } else {
                return false;
            }
            let tempSwaprule = retantionOffer.swap_rules.split('--');
            let swapRuleObj = {};
            for (const swapStyle of tempSwaprule) {
                let tempSwapStyle = swapStyle.toLowerCase().replaceAll(' ', '-').split('=');
                swapRuleObj[tempSwapStyle[0]] = tempSwapStyle[1];
            }

            if (!isRetantionCompleted) {
                let tempProduct = shopifyProductJson[subscriptionData.external_product_id.ecommerce];
                let tempType = tempProduct.type.toLowerCase().replaceAll(' ', '-');
                retantionSwapStyle = swapRuleObj[tempType];
                let tempBulletsStyleNames1 = retantionOffer.retention_bullet_point_name_1.toLowerCase().replaceAll(' ', '-').split('--');
                let tempBulletsStyleNames2 = retantionOffer.retention_bullet_point_name_2.toLowerCase().replaceAll(' ', '-').split('--');
                let tempBulletsStyleNames3 = retantionOffer.retention_bullet_point_name_3.toLowerCase().replaceAll(' ', '-').split('--');
                if (this.querySelector('[data-retantion_bullet]')) {
                    this.querySelector('[data-retantion_bullet]').innerHTML = "";
                    if (tempBulletsStyleNames1.includes(tempType)) {
                        let bulletPoints = retantionOffer.retention_bullet_point_1.split('--');
                        let bulletHtml = '';
                        bulletPoints.forEach(ele => {
                            bulletHtml += `<li>${ele.trim()}</li>`
                        });
                        this.querySelector('[data-retantion_bullet]').innerHTML = bulletHtml;
                    }
                    if (tempBulletsStyleNames2.includes(tempType)) {
                        let bulletPoints = retantionOffer.retention_bullet_point_2.split('--');
                        let bulletHtml = '';
                        bulletPoints.forEach(ele => {
                            bulletHtml += `<li>${ele.trim()}</li>`
                        });
                        this.querySelector('[data-retantion_bullet]').innerHTML = bulletHtml;
                    }
                    if (tempBulletsStyleNames3.includes(tempType)) {
                        let bulletPoints = retantionOffer.retention_bullet_point_3.split('--');
                        let bulletHtml = '';
                        bulletPoints.forEach(ele => {
                            bulletHtml += `<li>${ele.trim()}</li>`
                        });
                        this.querySelector('[data-retantion_bullet]').innerHTML = bulletHtml;
                    }
                    if (this.querySelector('[data-retantion_bullet]').innerHTML == "") {
                        this.querySelector('[data-retantion_bullet]').classList.add('d-none')
                    } else {
                        this.querySelector('[data-retantion_bullet]').classList.remove('d-none')
                    }
                }

                if (retantionSwapStyle == undefined || retantionSwapStyle == null) {
                    return false;
                }
                let tempSubHeadingStyleNames1 = retantionOffer.retention_sub_heading_style_1.toLowerCase().replaceAll(' ', '-').split('--');
                let tempSubHeadingStyleNames2 = retantionOffer.retention_sub_heading_style_2.toLowerCase().replaceAll(' ', '-').split('--');
                let tempSubHeadingStyleNames3 = retantionOffer.retention_sub_heading_style_3.toLowerCase().replaceAll(' ', '-').split('--');
                let tempSubHeadingStyleNames4 = retantionOffer.retention_sub_heading_style_4.toLowerCase().replaceAll(' ', '-').split('--');
                if (this.querySelector('[data-retantion-swap-subheading]')) {
                    this.querySelector('[data-retantion-swap-subheading]').innerHTML = "";
                    if (tempSubHeadingStyleNames1.includes(tempType)) {
                        this.querySelector('[data-retantion-swap-subheading]').innerHTML = retantionOffer.retention_sub_heading_message_1.replaceAll('--', '"')
                    }
                    if (tempSubHeadingStyleNames2.includes(tempType)) {
                        this.querySelector('[data-retantion-swap-subheading]').innerHTML = retantionOffer.retention_sub_heading_message_2.replaceAll('--', '"')
                    }
                    if (tempSubHeadingStyleNames3.includes(tempType)) {
                        this.querySelector('[data-retantion-swap-subheading]').innerHTML = retantionOffer.retention_sub_heading_message_3.replaceAll('--', '"')
                    }
                    if (tempSubHeadingStyleNames4.includes(tempType)) {
                        this.querySelector('[data-retantion-swap-subheading]').innerHTML = retantionOffer.retention_sub_heading_message_4.replaceAll('--', '"')
                    }
                    if (this.querySelector('[data-retantion-swap-subheading]').innerHTML == "") {
                        this.querySelector('[data-retantion-swap-subheading]').classList.add('d-none')
                    } else {
                        this.querySelector('[data-retantion-swap-subheading]').classList.remove('d-none')
                    }
                }
                this.querySelector('[data-retantion-swap-heading]').innerHTML = retantionOffer.retention_heading;
                if (this.querySelector('[data-retantion_old_style]')) {
                    this.querySelectorAll('[data-retantion_old_style]').forEach(ele => {
                        ele.innerHTML = tempType.replaceAll('-', ' ');
                    });
                }
                if (this.querySelector('[data-retantion_customer_name]')) {
                    this.querySelectorAll('[data-retantion_customer_name]').forEach(ele => {
                        ele.innerHTML = customerData.first_name
                    });
                }
                if (this.querySelector('[data-retantion_swap]')) {
                    this.querySelector('[data-retantion_swap]').innerHTML = retantionSwapStyle.replaceAll('-', ' ');
                }

                // RM script
                var searchVariable = this.querySelectorAll('[data-retantion-swap-subheading]');
                searchVariable.forEach( (element) => {
                    var innerHTML = element.innerHTML.toLowerCase();
                    if (innerHTML.includes("baller")) {
                        // Do something if "baller" is found in the inner HTML
                        var imgElement = this.querySelector('img.custom-dynamic-icon');
                        if (imgElement) {
                            imgElement.setAttribute("src", "https://cdn.shopify.com/s/files/1/1412/6778/files/baller-icon.png");
                        }
                    }
                    if (innerHTML.includes("biker")) {
                        // Do something if "baller" is found in the inner HTML
                        var imgElement = this.querySelector('img.custom-dynamic-icon');
                        if (imgElement) {
                            imgElement.setAttribute("src", "https://cdn.shopify.com/s/files/1/1412/6778/files/biker_94c551f2-e89c-412a-9522-00022d9a5915.png?v=1709896191");
                        }
                    }
                    if (innerHTML.includes("star")) {
                        // Do something if "baller" is found in the inner HTML
                        var imgElement = this.querySelector('img.custom-dynamic-icon');
                        if (imgElement) {
                            imgElement.setAttribute("src", "https://cdn.shopify.com/s/files/1/1412/6778/files/star_07f62cac-c850-4c8d-a4c6-d28b0d835601.png?v=1709896190");
                        }
                    }

                });
                // end RM script

                this.querySelector('#swap-product-offer').show();
                isRetantionCompleted = false;
                return true;
            } else {
                return false;
            }

    }

    _triggerSkipRetantionOffer = (event) => {
        try {
            if (!isRetantionCompleted) {
                this.querySelector('#skip-product-offer')?.show();
                isRetantionCompleted = false;
                if (this.querySelector('[data-retantion-skip-heading]')) {
                    this.querySelector('[data-retantion-skip-heading]').innerHTML = retantionOffer.retention_heading;
                    console.log("test:", retantionOffer.retention_heading);
                }
                if (this.querySelector('[data-retantion-skip-subheading]')) {
                    this.querySelector('[data-retantion-skip-subheading]').innerHTML = retantionOffer.retention_sub_heading;
                }
                return true;
            } else {
                return false;
            }
        } catch (err) {
            console.log(err, 'err')
            return false;
        }
    }

    _handleCancelComment = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this._manageCancelButton();
        if (isRetantionCompleted) {
            if (event.type === 'input' || event.type === 'blur') {
                this._showCancelReasonError(true);
            } else if (event.type === 'focus') {
                this._showCancelReasonError(false);
            }
        }
    }

    _showCancelReasonError = (error) => {
        if (error && this.querySelector('[data-cancel_comment]').value == "") {
            this.querySelector('[data-cancel_comment]').classList.add('border', 'border-danger', 'blink');
            this.querySelector('[data-cancel_comment]').classList.remove('border-0');
            this.querySelector('[data-cancel-reason-container]').classList.add('border', 'border-danger')
        } else {
            this.querySelector('[data-cancel_comment]').classList.remove('border', 'border-danger', 'blink');
            // this.querySelector('[data-cancel_comment]').classList.add('border-0');
            this.querySelector('[data-cancel-reason-container]').classList.remove('border', 'border-danger')
        }
    }
    _retantionOfferSwap = () => {
        this.querySelector('#swap-product-offer')?.hide();
        this.querySelector('#cancel-swap-popup')?.show();

        let imageSrc = this._findDefaultImageByCollection(retantionSwapStyle);
        this.querySelector('[data-retantion-item-default-img] img').setAttribute('src', imageSrc)

        // Append available colors in retantion offer
        let retantionStyleCollection = allCollections[retantionSwapStyle];
        this.querySelector('[data-retantion-item-swap]')?.classList.add('disabled');
        // this.querySelector('[data-retantion-item-swap-text]').innerText = "Choose color";


        let retantionSizeProducts = {};
        let tempSizeCollections = retantionStyleCollection.products.filter(product => {
            return product.variants.some(variant => {
                return variant?.option1?.toLowerCase() === selectedSize && variant?.available === true && variant?.inventory_quantity >= 5;
            });
        });

        let retantionColorsWiseProducts = {};
        tempSizeCollections.forEach((product) => {
            const productObj = { ...product };
            retantionSizeProducts[productObj.id] = productObj;
            retantionColorsWiseProducts[productObj.variants[0].option2.toLowerCase().replaceAll(' ', '-')] = productObj;
        });

        let colorsHtml = ``;

        let limitedColorsHtml = "";
        let coreColorsHtml = "";
        Object.keys(retantionSizeProducts).forEach(key => {
            let product = retantionSizeProducts[key]
            let color = product.variants[0]?.option2?.toLowerCase();
           if (color && !product?.type?.includes('pack')) {
               let colorSrc = this._findColorSwatchByProduct(product);
               let tempHtml = `
                <div class="col-md-auto col-2 text-center my-2 style-color position-relative">
                    <a href="#" data-select-color-product="${product.id}" class="d-block rounded-circle color-swatch-img color-swatch ${color === 'pride pure' ? 'highlight-color' : ''}" data-retantion-color="${color}" aria-label="${color}">
                        <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
                    </a>
                </div>`;

               let isLimited = product.tags.includes('pp-limited_color') || false;
               if (isLimited) {
                   limitedColorsHtml += tempHtml;
               } else {
                   coreColorsHtml += tempHtml;
               }
           }
        })
        this.querySelector(`#cancel-swap-popup [data-cancel-limited-colors]`).innerHTML = limitedColorsHtml;
        this.querySelector(`#cancel-swap-popup [data-cancel-core-colors]`).innerHTML = coreColorsHtml;

        if (!limitedColorsHtml) {
            this.querySelectorAll(`[data-cancel-limited-container]`).forEach(el => el.classList.add('d-none'));
        } else {
            this.querySelectorAll(`[data-cancel-limited-container]`).forEach(el => el.classList.remove('d-none'));
        }

        // this.querySelector('[data-retantion-available-colors]').innerHTML = colorsHtml;

        this.allRetantionColorElements = this.querySelectorAll('[data-retantion-color]');

        let retantionSelectedColor = null;
        this.allRetantionColorElements.forEach(ele => ele.addEventListener('click', (event) => {
            this.querySelector('[data-retantion-color].selected')?.classList.remove('selected');
            event.target.closest('[data-retantion-color]')?.classList.add('selected');
            // this.querySelector('[data-review_button]')?.classList.remove('hide');
            // this.querySelector(`[data-subscription_action="${actionType}"]`).classList.remove('d-none')
            retantionSelectedColor = event.target.closest('[data-retantion-color]').getAttribute('data-retantion-color')?.replace(/\u00A0/g, ' ');
            let templColor = retantionSelectedColor.toLowerCase().replaceAll(' ', '-');
            selectedProduct = retantionColorsWiseProducts[templColor];
            selectedVariant = selectedProduct.variants.filter(variant => {
                return variant.option1.toLowerCase() === selectedSize;
            })[0];
            // this.querySelector('[data-retantion-item-swap-text]').innerText = "Swap";
            this.querySelector('[data-retantion-item-default-img] img').setAttribute('src', this._findImageByProduct(selectedProduct));
            this.querySelector('[data-retantion-item-swap]').classList.remove('disabled');
        }));
    }

    async _detleBulkAddons(addons) {
        Shopify.queue = [];
        addons.forEach((item) => {
            Shopify.queue.push(item.id)
        })
        let _this = this;
        Shopify.moveAlong = async function () {
            if (Shopify.queue.length > 0) {
                const request = Shopify.queue.shift();
                await rechargeSdk._removeOnetime(request);
                Shopify.moveAlong();
            } else {
                await _this._onLoadData();
                this.querySelector('[data-accept_policy]').checked = false;
                this.querySelector('[data-cancel_reason]:checked').checked = false
                this.querySelector('[data-cancel_comment]').value = "";
                this.querySelectorAll('[data-cancel-subscription]').forEach((ele) => {
                    ele.classList.add('disabled')
                })
            }
        }
        Shopify.moveAlong();
    }

    _funnelEvents() {
        this.querySelectorAll('[data-style-activator]').forEach((ele) => {
            ele.addEventListener('click', (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                let container = e.target.closest('[data-modal-section]');
                let isStyleSectionOpen = e.target.closest('[data-style-activator]').dataset.styleActivator == 1;
                if (isStyleSectionOpen) {
                    e.target.closest('[data-style-activator]').setAttribute('data-style-activator', 0);
                    container.querySelector('[data-edit-style-part]')?.classList?.add('d-none');
                    container.querySelector('[data-collapsed-details]')?.classList?.add('d-none');
                    container.querySelector('[data-edit-size-part]')?.classList?.remove('d-none');

                    if (container.dataset.modalSection === 'one-time-edit') {
                        this._fillOneTimeItemDetails(e, container.dataset.modalSection);
                    } else {
                        this._fillItemDetailsInModal(e, container.dataset.modalSection);
                    }
                    container.querySelectorAll('[data-submit-edit-subscription], [data-submit-edit-one-time]').forEach(ele => {
                        ele.classList?.add('disabled');
                        if (ele.querySelector('.add-text')) {
                            ele.querySelector('.add-text').innerHTML = 'Save changes';
                        }
                    });
                } else {
                    e.target.closest('[data-style-activator]').setAttribute('data-style-activator', 1);
                    container.querySelector('[data-edit-style-part] [data-style-tab-button="underwear"]')?.click();
                    container.querySelector('[data-edit-style-part]')?.classList?.remove('d-none');
                    container.querySelector('[data-collapsed-details]')?.classList?.remove('d-none');
                    container.querySelector('[data-edit-size-part]')?.classList?.add('d-none');
                }

                if (container.dataset.modalSection === 'subscription-edit' && container.querySelector('[data-purchase-type-checkbox]')) {
                    container.querySelector('[data-purchase-type-checkbox]').checked = true;
                    container.querySelector('[data-purchase-option]').setAttribute('data-purchase-option', 'subscription');
                }

                if (container.querySelector('[data-subscription-consent]')) {
                    container.querySelector('[data-subscription-consent]').checked = false;
                }
            })
        })

        this.querySelectorAll('[data-size-activator]').forEach((ele) => {
            ele.addEventListener('click', (e) => {
                let container = e.target.closest('[data-modal-section]');
                container.querySelector('[data-style-activator]')?.setAttribute('data-style-activator', 0);
                container.querySelector('[data-edit-size-part]')?.classList?.remove('d-none');
                container.querySelector('[data-collapsed-details]')?.classList?.add('d-none');
                container.querySelector('[data-edit-style-part]')?.classList?.add('d-none');
            })
        })

        this.querySelectorAll('[data-skip-subscription]').forEach((ele) => {
            ele?.addEventListener('click', (event) => {
                skipAllCharges = true;
                this._skipSubscription(event, 'skip')
            })
        })

        this.querySelectorAll('[data-unskip-subscription]').forEach((ele) => {
            ele?.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                skipAllCharges = true;
                this._skipSubscription(event)
            })
        })

        this.querySelector('[data-update-payment-method]').addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            this._updateStripePaymentMethod(event)
        })

        this.querySelector('[data-submit-pick-color]')?.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            this._swapSubscription(event, 'color-picker');
        })

        this.querySelectorAll('[data-style-tab-button]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                let container = ele.closest('[data-modal-section]');
                if (container.querySelector('[data-edit-style-part]')) {
                    container = container.querySelector('[data-edit-style-part]');
                }
                let tabButton = ele.closest('[data-style-tab-button]');
                this._fillStyleTabDetails(container, tabButton);

                this._resetItemAddModal(container);
            })
        })

        this.querySelectorAll('[data-style-select-container] [data-single_style]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let container = ele.closest('[data-modal-section]');
                let element = ele.closest('[data-single_style]');
                let style = element.getAttribute('data-single_style');
                if (ele.closest('[data-quick-add-box]')) {
                    container = ele.closest('[data-quick-add-box]');
                    let type = container.dataset.quickAddBox;
                    // this._resetQuickAdd(this.querySelector(`[data-quick-add-box=${type === 'tops' ? 'underwear' : 'tops'}]`));
                    container.setAttribute('data-quick-collection', style)
                    container.setAttribute('data-quick-select-size', '');
                    container.setAttribute('data-quick-select-color', '');
                    container.setAttribute('data-quick-select-product', '');

                    container.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.remove('disabled'));
                    let quickAddButton = container.querySelector('[data-quick-add-process]');
                    if (quickAddButton) {
                        quickAddButton.querySelector('[data-button-text]').innerHTML = 'Select a size';
                        quickAddButton.setAttribute('data-quick-add-process', 0)
                    }
                }
                if (container.querySelector('[data-edit-style-part]')) {
                    container = container.querySelector('[data-edit-style-part]');
                }

                let price = element.getAttribute('data-price-value');
                let actualPrice = element.getAttribute('data-actual-price');
                let discountPercentage = actualPrice ? Math.round(((actualPrice - price) / actualPrice) * 100) : 0;

                if(container.querySelector('[data-discount-percentage]')){
                    container.querySelector('[data-discount-percentage]').innerHTML = discountPercentage;
                }
                container.querySelectorAll('[data-single_style].selected').forEach(el => el.classList.remove('selected'));
                element.classList.add('selected');

                style = this._formatCollectionHandle(style);
                let futureSubscription = document.querySelector('[data-modal-section="item-add"] [data-purchase-option="oneTime"] [data-purchase-type-checkbox]')
                if (style == 'boxer') {
                    if (futureSubscription) {
                        futureSubscription.checked = false;
                        futureSubscription?.closest('[data-purchase-option="oneTime"]')?.classList.add('d-none');
                    }
                }else{
                    if (futureSubscription) {
                        futureSubscription?.closest('[data-purchase-option="oneTime"]')?.classList.remove('d-none');
                    }
                }
                selectedSize = selectedColor = selectedProduct = selectedVariant = null;
                selectedStyleCollection = allCollections[style];
                let imgSrc = this._findDefaultImageByCollection(style);
                container.querySelector('[data-style-step-image]')?.classList?.remove('d-none');
                container.querySelectorAll('[data-style-step-image],[data-quick-add-img]').forEach(img => img.src = imgSrc);
                container.querySelector('[data-price-interval]').innerHTML = this._formatMoney(price);
                actualLocalePrice = price;
                let actualPriceEl = container.querySelector('[data-actual-style-price]');
                if (actualPriceEl && actualPrice) {
                    actualPriceEl.classList.remove('d-none');
                    actualPriceEl.innerHTML = this._formatMoney(actualPrice);
                }
                container.querySelector('[data-account-color-step]')?.classList?.remove('d-none');
                container.querySelector('[data-account-size-step]')?.classList?.remove('d-none');
                // container.querySelector('[data-size-select-tag]').value = '';
                this._selectSizeValue('', container);
                this._handleSizeSection(container);
                this._handleItemAddColorSection(container);
                if (container.dataset.modalSection === 'item-add') {
                    container.querySelector('[data-one-time-price]').innerHTML = this._formatMoney(price);
                }
                container.querySelectorAll('[data-submit-edit-subscription], [data-submit-edit-one-time], [data-submit-add-product]').forEach(ele => {
                    if (ele.querySelector('.add-text')) {
                        ele.querySelector('.add-text').innerHTML = 'Select a size';
                    }
                });
                container.querySelectorAll('[data-color-print]').forEach(ele => ele.classList.add('d-none'));
            })
        })

        this.querySelectorAll('[data-purchase-option] input[name="purchaseOption"]').forEach(ele => {
            ele.addEventListener('change', (event) => {
                let container = event.target.closest('[data-purchase-option]');
                let value = event.target.value;
                container?.setAttribute('data-purchase-option', value);
            })
        })

        this.querySelectorAll('[data-purchase-option] [data-purchase-type-checkbox]').forEach(ele => {
            ele.addEventListener('change', (event) => {
                let container = event.target.closest('[data-purchase-option]');
                let value = event.target.checked;
                container?.setAttribute('data-purchase-option', value ? 'subscription' : 'oneTime');

                if (container.closest('[data-modal-section="subscription-edit"]')) {
                    container.closest('[data-modal-section="subscription-edit"]').querySelector('[data-submit-edit-subscription]')?.classList?.remove('disabled')
                }
            })
        })

        this.querySelectorAll('[data-submit-add-product]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let action = event.target.closest('[data-modal-section]')?.querySelector('[data-purchase-option]')?.getAttribute('data-purchase-option');
                if (action === 'subscription') {
                    this._addNewSubscription(event);
                } else {
                    this._addNewAddon(event);
                }
            })
        })

        this.querySelectorAll('[data-submit-edit-subscription]').forEach(ele => {
            ele.addEventListener('click', async (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let container = event.target.closest('[data-modal-section]');
                if (container.querySelector('[data-purchase-option="oneTime"]')) {
                    // await this._deleteSubscription(event);
                    try {
                        this._loadButton(event.target);
                        let config = {
                            cancellation_reason: `Due to conversion of subscription to oneTime`,
                            cancellation_reason_comments: 'Customer wanted to disable all future purchase'
                        }
                        const response = await rechargeSdk._cancelSubscription(subscriptionData.id, config);
                    } catch (error) {
                        console.error(error, 'Cancelled subscription error')
                    }
                    await this._addNewAddon(event);
                    this._loadButton(event.target, false);
                } else {
                    this._swapSubscription(event, 'swapped');
                }
            })
        })

        this.querySelectorAll('[data-one-time-remove]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                this._loadButton(this.querySelector('.one-time-edit [data-submit-edit-one-time]'));
                event.target.closest('[data-one-time-remove]').classList?.add('disabled');
                this._removeAddon(event);
            })
        })

        this.querySelectorAll('[data-submit-edit-one-time]').forEach(ele => {
            ele.addEventListener('click', async (event) => {
                event.stopImmediatePropagation();
                let container = ele.closest('[data-modal-section]');
                this._loadButton(event.target);
                let addonId = addonData.id;
                let response = await rechargeSdk._removeOnetime(addonId);
                if (response) {
                    let isSubscription = container.querySelector('[data-subscription-consent]:checked')?.value;
                    if (isSubscription) {
                        this._addNewSubscription(event);
                    } else {
                        this._addNewAddon(event);
                    }
                } else {
                    this._toastMessage('Something went wrong. Try again!', 'error');
                    this._loadButton(event.target, false);
                }
            })
        })

        this.querySelector('[data-subscription-consent]')?.addEventListener('change', (event) => {
            let container = event.target.closest('[data-modal-section]');
            container.querySelectorAll('[data-submit-edit-one-time]').forEach(ele => ele.classList.remove('disabled'));
        })

        this.querySelectorAll('[data-quick-add-submit]').forEach(ele => {
            ele.addEventListener('click', event => {
                event.stopImmediatePropagation();
                this._loadButton(event.target)
                let matchProductInCollection = this._isMatchInCollection(true);

                if (!matchProductInCollection) {
                    this._toastMessage('The selected collection does not have matching options', 'error');
                    this._loadButton(event.target, false)
                } else {
                    this._addOneTimeItemInSubscription(event);
                    selectedSize = selectedColor = selectedProduct = selectedVariant = null;
                }
            })
        })

        this.querySelectorAll('[data-cancel-swap-subscription]').forEach(ele => {
            ele.addEventListener('click', event => {
                if (subscriptionData) {
                    let subscriptionBox = this.querySelector(`[data-subscription-id="${subscriptionData.id}"]`);
                    if (subscriptionBox) {
                        subscriptionBox.querySelector('[data-modal-opener="subscription-edit"]')?.click();
                        this._hideModal('cancel-popup')
                    }
                }
            })
        })

        this.querySelector('.merge-box [data-merge-box-submit]')?.addEventListener('click', event => {
            event.stopImmediatePropagation();
            let container = event.target.closest('[data-merge-box-container]');
            if (container.dataset.mergeBoxContainer == 1) {
                container.querySelector('[data-merge-box-first]')?.classList?.add('d-none');
                container.querySelector('[data-merge-box-second]')?.classList?.remove('d-none');
                this.querySelector('[data-merge-box-title]')?.classList?.add('d-none');
                this.querySelector('[data-merge-box-container]')?.setAttribute('data-merge-box-container', '2');
                this._prepareMergeBoxStep();
            } else {
                mergeParentAddress = container.querySelector('[data-merge-final-payment]')?.dataset?.mergeFinalPayment;
                mergeShippingDate = container.querySelector('[data-merge-final-date]')?.dataset?.mergeFinalDate;

                this._mergeAddresses(event);
            }
        })

        this.querySelectorAll('[data-quick-add-process]').forEach(ele => {
            ele.addEventListener('click', async (event) => {
                event.stopImmediatePropagation();
                let status = ele.dataset.quickAddProcess;
                if (status == 1) {
                    let container = ele.closest('[data-quick-add-box]');
                    let collectionHandle = this._formatCollectionHandle(container.getAttribute('data-quick-collection'));
                    selectedColor = container.getAttribute('data-quick-select-color')?.replace(/\u00A0/g, ' ');
                    selectedSize = container.getAttribute('data-quick-select-size');
                    if (collectionHandle) {
                        selectedStyleCollection = allCollections[collectionHandle];
                        let productId = container.getAttribute('data-quick-select-product');
                        productId && (selectedProduct = this._findProductByCollection(productId));
                        selectedVariant = selectedProduct ? this._findColorVariantBySize() : null;
                    }

                    await this._addOneTimeItemInSubscription(event);
                    this._resetQuickAdd(ele.closest('[data-quick-add-box]'));
                }
            })
        })

        this.querySelectorAll('[data-same-billing-checker]')?.forEach(ele => {
            ele.addEventListener('change', event => {
                let container = event.target.closest('[data-payment-form]') || event.target.closest('[data-modal-section]');
                if (event.target.checked) container.querySelector('[data-billing-address-container]')?.classList?.add('d-none');
                else container.querySelector('[data-billing-address-container]')?.classList?.remove('d-none');
            })
        })

        this.querySelectorAll('.skip_sub_button').forEach(ele => {
            ele.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                if (currentAddress?.id) {
                    document.querySelector(`[data-single-container="${currentAddress?.id}"] [data-modal-opener="skip-modal"]`)?.click();
                }
            })
        })
    }

    _bindMouseOverEffectColor(container) {
        container.querySelectorAll('[data-color-container] [data-color-product-id], [data-quick-add-swatches] [data-product-id]').forEach(ele => {
            ele.addEventListener('mouseover', () => {
                let color = ele.closest('[data-color]')?.getAttribute('data-color');
                let container = ele.closest('[data-color-container]') || ele.closest('[data-quick-add-swatches]');
                let type = ele.closest('[data-color]').getAttribute('data-color-type');
                let colorPrint = container.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                ele.closest('[data-color]')?.classList?.add('select_hover');
                if (colorPrint) {
                    colorPrint?.classList?.remove('d-none');
                    colorPrint.innerHTML = color;
                }
            })
            ele.addEventListener('mouseout', () => {
                let container = ele.closest('[data-color-container]') || ele.closest('[data-quick-add-swatches]');
                let type = ele.closest('[data-color]').getAttribute('data-color-type');
                let colorPrint = container.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                if (colorPrint) {
                    colorPrint.innerHTML = '';
                }
                ele.closest('[data-color]')?.classList?.remove('select_hover');

                let selectedColorEl = container.querySelector('[data-color-product-id].selected') || container.querySelector('[data-product-id].selected');
                if (selectedColorEl) {
                    let color = selectedColorEl.closest('[data-color]')?.getAttribute('data-color');
                    let container = selectedColorEl.closest('[data-color-container]') || selectedColorEl.closest('[data-quick-add-swatches]');
                    let type = selectedColorEl.closest('[data-color]').getAttribute('data-color-type');
                    let colorPrint = container.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                    if (colorPrint) {
                        colorPrint?.classList?.remove('d-none');
                        colorPrint.innerHTML = color;
                    }
                }
            })
        });
    }

    _prepareMergeBoxStep() {
        let dateHtml = ``;
        let cardHtml = ``;
        let firstDate = '';
        let firstPayment = '';

        allAddresess.forEach((address, i) => {
            if (addressesToMerge.includes(address.id.toString())) {
                let addressRelatedSubscriptions = allSubscriptions.filter((subscription) => subscription.address_id == address.id);
                let chargeDate = addressRelatedSubscriptions[0].next_charge_scheduled_at;
                if (chargeDate != null) {
                    chargeDate = moment(chargeDate).format('MMMM Do')
                }
                let paymentMethod = allPayments.find((payment) => payment.id == address.payment_method_id) || false;

                dateHtml += `<div style="gap: 11px;margin-top: 12px" class="select-radio d-flex align-items-center" data-address-id="${addressRelatedSubscriptions[0].next_charge_scheduled_at}">
                        <input class="radio-input cursor-pointer" type="radio" name="select_ship_date"
                               id="select_ship_date_${i}" ${i === 0 ? 'checked' : ''} value="${addressRelatedSubscriptions[0].next_charge_scheduled_at}">
                        <label class="ml-3 edit-modal-font cursor-pointer" for="select_ship_date_${i}">
                            ${chargeDate}
                        </label>
                    </div>`;

                cardHtml += `<div class="select-radio d-flex align-items-start ${i !== 0 ? 'mt-4' : ''}" style="gap: 11px;margin-top: 12px" data-address-id="${address.id}">
                        <input class="radio-input cursor-pointer" type="radio" name="select_your_payment"
                               id="select_your_payment_${i}" ${i === 0 ? 'checked' : ''} value="${address.id}">
                        <label class="ml-3 edit-modal-font cursor-pointer d-flex flex-column " for="select_your_payment_${i}">
                            <span>${address.first_name} ${address.last_name}</span>
                            <span class="mt-2">${address?.address1}</span>
                            <span style="padding-right: 80px" class="text-capitalize mt-2">${paymentMethod?.payment_details?.brand || 'Credit card'} ending in ${paymentMethod?.payment_details?.last4}</span>
                            <span class="${!paymentMethod?.payment_details?.exp_month ? 'd-none' : ''}">
                            Expires ${paymentMethod?.payment_details?.exp_month && parseInt(paymentMethod?.payment_details?.exp_month) < 10 ? '0' + paymentMethod?.payment_details?.exp_month : paymentMethod?.payment_details?.exp_month}/${paymentMethod?.payment_details?.exp_year}</span>
                        </label>
                    </div>`

                if (i === 0) {
                    firstDate = addressRelatedSubscriptions[0].next_charge_scheduled_at;
                    firstPayment = address.id;
                }
            }
        });

        let boxContent = `
        <div class="text-start" data-merge-final-date="${firstDate}">
                <span class="fw-normal">Select a Ship Date:</span>
                <div class="d-flex flex-column radio-content mt-2">
                    ${dateHtml}
                </div>
            </div>

            <div class="text-start mt-4" data-merge-final-payment="${firstPayment}">
                <span class="fw-normal">Select your Shipping address and Payment method :</span>
                <div class="d-flex flex-column radio-content mt-2">
                    ${cardHtml}
                </div>
            </div>
        `;

        this.querySelector('[data-merge-box-second]') && (this.querySelector('[data-merge-box-second]').innerHTML = boxContent);

        this.querySelectorAll('[data-address-id] input[type="radio"]').forEach(ele => {
            ele.addEventListener('change', event => {
                event.stopImmediatePropagation();
                event.target.closest('[data-merge-final-date]')?.setAttribute('data-merge-final-date', event.target.value)
                event.target.closest('[data-merge-final-payment]')?.setAttribute('data-merge-final-payment', event.target.value)
            })
        })
    }


    _fillStyleTabDetails(container, tabButton) {
        let type = tabButton.dataset.styleTabButton;
        container.querySelectorAll('[data-style-tab-button].selected').forEach(ele => ele.classList.remove('selected'));
        tabButton.classList.add('selected');
        container.querySelectorAll('[data-single_style]').forEach(ele => ele.classList.add('d-none'));
        container.querySelectorAll(`[data-single_style][data-style-type="${type}"]`).forEach(ele => ele.classList.remove('d-none'));
        let lastOption = container.querySelectorAll('.custom-option[data-style-type="underwear"]:not(.d-none)');
        if (lastOption.length > 0) {
            let lastElement = lastOption[lastOption.length - 1];
            lastElement.classList.add('last_padding_child');
        }
        container.querySelectorAll('[data-single_style]').forEach(item => {
            let styleHandle = item.getAttribute('data-single_style');
            if (!this._isAnySizeAvailableInCollection(styleHandle)) {
                item.classList.add('disabled');
            }
        })
        container.querySelector('[data-style-type-name]').innerHTML = type;
        let prices = this._getPriceInterval(container);
        container.querySelector('[data-price-interval]').innerHTML = `${this._formatMoney(prices[0])}-${this._formatMoney(prices[1])}`;
        container.querySelector('[data-actual-style-price]')?.classList.add('d-none');
        container.querySelector('[data-style-step-image]')?.classList?.remove('d-none')
        container.querySelector('[data-style-step-image]')?.setAttribute('src', this._findDefaultImageByCollection(type === 'tops' ? 'boss' : 'baller'))
    }

    _resetItemAddModal(container) {
        this._selectStyleValue('', container);
        this._selectSizeValue('', container);
        selectedColor = selectedVariant = selectedProduct = selectedSize = selectedStyleCollection = null;
        let prices = this._getPriceInterval(container);

        container.querySelector('[data-account-color-step]')?.classList?.add('d-none');
        container.querySelector('[data-account-size-step]')?.classList?.add('d-none');
        container.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));

        container.querySelectorAll('.custom-options,.custom-select-wrapper').forEach(ele => ele.classList.remove('open'));
        container.querySelector('[data-color-product-id].selected')?.classList?.remove('selected');

        container.querySelectorAll('[data-submit-edit-subscription], [data-submit-edit-one-time], [data-submit-add-product]').forEach(ele => {
            ele.classList?.add('disabled');
            if (ele.querySelector('.add-text')) {
                ele.querySelector('.add-text').innerHTML = 'Select a style';
            }
        });

        if (container.dataset.modalSection === 'item-add') {
            container.querySelector('[data-one-time-price]').innerHTML = this._formatMoney(prices[0]);
        }
        if (container.querySelector('[data-purchase-type-checkbox]')) {
            container.querySelector('[data-purchase-type-checkbox]').checked = false;
            container.querySelector('[data-purchase-option]')?.setAttribute('data-purchase-option', 'oneTime');
        }
    }

    _handleItemAddColorSection(container) {
        let limitedColorsHtml = "";
        let coreColorsHtml = "";
        let allColorsInHtml = [];
        let selectedSwatchType = '';
        let isCoreColorAvailable = false;
        selectedStyleCollection.products?.forEach((product) => {
            let color = product.variants[0]?.option2?.toLowerCase();
            if (color && !product?.type?.includes('pack')) {
                let colorSrc = this._findColorSwatchByProduct(product);
                let isLimited = product.tags.includes('pp-limited_color') || false;
                let isColorAvailable = selectedSize ? this._isColorAvailableForSize(color) : true;
                let isColorAvailableForAnySize = this._isColorAvailableForAnySize(color);
                let repeatedColor = allColorsInHtml.includes(color);
                let colorHtml = `
                <a href="#" data-color-product-id="${product.id}" data-color="${color}" aria-label="${color}" ${color === selectedColor && isColorAvailable ? 'selected' : ''}
                class="d-block rounded-circle swatch-image position-relative ${color === 'pride pure' ? 'highlight-color' : ''} ${!isColorAvailable ? 'unavailable ' : ''}
                ${!isColorAvailableForAnySize || repeatedColor ? 'd-none' : ''} ${selectedProduct && selectedProduct.id == product.id ? 'selected' : ''}"
                 data-color-type="${isLimited ? 'limited' : 'core'}" title="${color}">
                    <img class="w-100 h-100 rounded-circle" src="${colorSrc}" role="presentation" alt="${color}">
                </a>
            `;
                allColorsInHtml.push(color);
                if (color === selectedColor) {
                    selectedSwatchType = color === selectedColor && isLimited ? 'limited' : 'core';
                }
                if (isLimited) {
                    limitedColorsHtml += colorHtml;
                } else {
                    coreColorsHtml += colorHtml;
                    if (isColorAvailableForAnySize && !repeatedColor) isCoreColorAvailable = true;
                }
            }
        });

        container.querySelector(`[data-limited-container]`).innerHTML = limitedColorsHtml;
        container.querySelector(`[data-core-container]`).innerHTML = coreColorsHtml;

        if (!limitedColorsHtml) {
            container.querySelectorAll(`[data-limited-color-container]`).forEach(el => el.classList.add('d-none'));
        } else {
            container.querySelectorAll(`[data-limited-color-container]`).forEach(el => el.classList.remove('d-none'));
        }

        if (!isCoreColorAvailable) {
            container.querySelectorAll(`[data-core-color-container]`).forEach(el => el.classList.add('d-none'));
        } else {
            container.querySelectorAll(`[data-core-color-container]`).forEach(el => el.classList.remove('d-none'));
        }

        if (selectedColor) {
            container.querySelectorAll('[data-color-print]').forEach(ele => ele.innerHTML = selectedColor);
            container.querySelector(`[data-color-print="${selectedSwatchType === 'limited' ? 'limited' : 'core'}"]`)?.classList?.remove('d-none');
        }
        let isMobile = window.innerWidth <= 575;
        if (!isMobile) {
            this._bindMouseOverEffectColor(container);
        }
        this._bindItemAddColorEvents(container);
    }

    _bindItemAddColorEvents(container) {
        container.querySelectorAll('[data-color-product-id]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                ele.closest('[data-color-container]')?.querySelector('.selected')?.classList.remove('selected');
                ele.closest('[data-color-product-id]')?.classList.add('selected');
                selectedColor = ele.getAttribute('data-color')?.replace(/\u00A0/g, ' ');
                let productId = ele.getAttribute('data-color-product-id');
                selectedProduct = this._findProductByCollection(productId);

                //handle quick add box
                if (container.closest('[data-quick-add-box]')) {
                    let collectionHandle = this._formatCollectionHandle(container.getAttribute('data-quick-collection'));
                    selectedSize = container.getAttribute('data-quick-select-size');
                    if (collectionHandle) selectedStyleCollection = allCollections[collectionHandle];
                }
                selectedSize && (selectedVariant = this._findColorVariantBySize());
                this._handleSizeSection(container);
                let imgSrc = this._findImageByProduct(selectedProduct);
                let wireImage = this._findImageByProduct(selectedProduct);
                let swapImageSource = this._findColorSwatchByProduct(selectedProduct);
                container.querySelectorAll('[data-style-step-image],[data-quick-add-img]').forEach(ele => ele.src = imgSrc);
                container.querySelectorAll('[data-mobile-image]').forEach(ele => ele.src = this._getFeaturedImageSource(selectedProduct));
                container.querySelectorAll('[data-desktop-image]').forEach(ele => ele.src = wireImage);
                container.querySelector('[data-swap-color-image]') && (container.querySelector('[data-swap-color-image]').src = swapImageSource);
                container.querySelectorAll('[data-item-color]').forEach(ele => ele.innerHTML = selectedColor || '-');
                container.closest('[data-quick-select-color]')?.setAttribute('data-quick-select-color', selectedColor)
                container.closest('[data-quick-select-color]')?.setAttribute('data-quick-select-product', productId)

                if (selectedVariant) {
                    container.querySelectorAll('[data-submit-add-product], [data-submit-edit-subscription], [data-submit-edit-one-time], [data-quick-add-submit]')
                        .forEach(ele => {
                            ele.classList?.remove('disabled');
                            ele.querySelector('.add-text') && (ele.querySelector('.add-text').innerHTML
                                = ele.querySelector('.add-text').getAttribute('data-default-text') || 'Save Changes');
                        });
                    let quickAddButton = container.querySelector('[data-quick-add-process]');
                    if (quickAddButton) {
                        quickAddButton.querySelector('[data-button-text]').innerHTML = 'Add to box';
                        quickAddButton.setAttribute('data-quick-add-process', 1)
                    }
                } else {
                    container.querySelectorAll('[data-submit-add-product], [data-submit-edit-subscription], [data-submit-edit-one-time], [data-quick-add-submit]')
                        .forEach(ele => {
                            ele.querySelector('.add-text') && (ele.querySelector('.add-text').innerHTML = 'Select a size');
                        });
                    let quickAddButton = container.querySelector('[data-quick-add-process]');
                    if (quickAddButton) {
                        quickAddButton.querySelector('[data-button-text]').innerHTML = 'Select a size';
                        quickAddButton.setAttribute('data-quick-add-process', 0)
                    }
                }

                let type = ele.getAttribute('data-color-type');
                let colorPrint = container.querySelector(`[data-color-print="${type === 'limited' ? 'limited' : 'core'}"]`);
                if (colorPrint) {
                    container.querySelectorAll(`[data-color-print]`).forEach(ele => ele.classList.add('d-none'));
                    colorPrint?.classList?.remove('d-none');
                    colorPrint.innerHTML = selectedColor;
                }
            })
        })
    }

    _handleSizeSection(container) {
        if (selectedStyleCollection) {
            let option1ValuesArray = selectedStyleCollection.products.flatMap(entry => entry.variants.flatMap(variant => {
                if (variant?.available && variant?.inventory_quantity >= 5) return variant.option1?.toLowerCase()
            }));
            let uniqueOptionValuesArray = Array.from(new Set(option1ValuesArray));

            container.querySelector('[data-size-select-container]')?.querySelectorAll('[data-single_size]').forEach(ele => {
                let option = ele.getAttribute('data-single_size');
                let isSizeAvailable = selectedColor ? this._isSizeAvailableForColor(option) : true;

                if (uniqueOptionValuesArray.includes(option) && isSizeAvailable) {
                    ele.closest('[data-single_size]')?.classList.remove('disabled');
                } else {
                    ele.closest('[data-single_size]')?.classList.add('disabled');
                }
            });
            this._selectSizeValue(selectedSize ? selectedSize.toUpperCase() : '', container);
        } else {
            container.querySelectorAll('[data-size-select-container] .custom-option').forEach(ele => ele.classList?.add('disabled'));
        }

        this._bindItemAddSizeEvent(container);
    }

    _bindItemAddSizeEvent(container) {
        let modalId = container?.closest(`[data-modal-section]`)?.dataset.modalSection;

        container.querySelector('[data-size-select-container]')?.querySelectorAll('[data-single_size]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                event.stopImmediatePropagation();
                let element = event.target.closest('[data-single_size]');
                selectedSize = element.getAttribute('data-single_size');
                container.querySelectorAll('[data-single_size].selected').forEach(el => el.classList.remove('selected'));
                element.classList.add('selected');

                //for quick add box
                if (container.closest('[data-quick-add-box]')) {
                    let collectionHandle = this._formatCollectionHandle(container.getAttribute('data-quick-collection'));
                    selectedColor = container.getAttribute('data-quick-select-color')?.replace(/\u00A0/g, ' ');
                    if (collectionHandle) {
                        selectedStyleCollection = allCollections[collectionHandle];
                        let productId = ele.getAttribute('data-color-product-id');
                        productId && (selectedProduct = this._findProductByCollection(productId));
                    }
                }
                selectedVariant = selectedProduct ? this._findColorVariantBySize() : null;
                selectedSizeProducts = {};
                selectedSizeProducts = selectedStyleCollection.products.filter(product => {
                    return product.variants.some(variant => {
                        return variant?.option1?.toLowerCase() === selectedSize && variant?.available === true && variant?.inventory_quantity >= 5;
                    });
                });
                if (modalId === 'item-add' || modalId === 'featured-colors'
                    || container.closest('[data-edit-style-part]') || container.closest('[data-quick-add-box]')) {
                    this._handleItemAddColorSection(container);
                } else {
                    this._prepareColorsHtml(container);
                }
                container.querySelectorAll('[data-item-size]').forEach(e => e.innerHTML = selectedSize || '-');
                container.closest('[data-quick-select-size]')?.setAttribute('data-quick-select-size', selectedSize)

                if (selectedVariant) {
                    container.querySelectorAll('[data-submit-add-product], [data-submit-edit-subscription], [data-submit-edit-one-time], [data-quick-add-submit]')
                        .forEach(ele => {
                            ele.classList?.remove('disabled');
                            ele.querySelector('.add-text') && (ele.querySelector('.add-text').innerHTML
                                = ele.querySelector('.add-text').getAttribute('data-default-text') || 'Save Changes');
                        });

                    let quickAddButton = container.querySelector('[data-quick-add-process]');
                    if (quickAddButton) {
                        quickAddButton.querySelector('[data-button-text]').innerHTML = 'Add to box';
                        quickAddButton.setAttribute('data-quick-add-process', 1)
                    }
                } else {
                    container.querySelectorAll('[data-submit-add-product], [data-submit-edit-subscription], [data-submit-edit-one-time], [data-quick-add-submit]')
                        .forEach(ele => {
                            ele.querySelector('.add-text') && (ele.querySelector('.add-text').innerHTML = 'Select a color');
                        });
                    let quickAddButton = container.querySelector('[data-quick-add-process]');
                    if (quickAddButton) {
                        quickAddButton.querySelector('[data-button-text]').innerHTML = 'Select a color';
                        quickAddButton.setAttribute('data-quick-add-process', 0)
                    }
                }
            })
        })
    }

    _dashboardEvents() {
        this.querySelectorAll('[data-trigger-cancel-flag]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                isRetantionCompleted = true;
                if (this.querySelector('[data-cancel-reason-container] textarea') && retantionOffer.retantion_swapping_reason == "I’m unhappy with the product") {
                    this.querySelector('[data-cancel-reason-container] textarea').placeholder = 'Please tell us why you are unhappy with your product'
                    this._showCancelReasonError(true)
                }
            })
        })

        this.querySelectorAll('[data-shipping-edit-btn]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                let boxContainer = event.target.closest('[data-single-container]');
                let address_id = boxContainer?.getAttribute('data-single-container');
                currentAddress = allAddresess.find(address => {
                    return address.id == address_id
                });
                boxContainer.querySelector('[data-change-shipping_address]').classList.add('disabled');
                boxContainer.querySelectorAll('[data-shipping-edit-form] [data-input-container].error').forEach(ele => ele.classList.remove('error'));
                boxContainer.querySelector('[data-subscription-details]')?.classList?.add('d-none');
                boxContainer.querySelector('[data-shipping-edit-form]')?.classList?.remove('d-none');
            })
        })

        this.querySelectorAll('[data-shipping-close]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                let boxContainer = event.target.closest('[data-single-container]');
                boxContainer.querySelector('[data-subscription-details]')?.classList?.remove('d-none');
                boxContainer.querySelector('[data-shipping-edit-form]')?.classList?.add('d-none');
            });
        })

        this.querySelectorAll('[data-payment-close]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                let boxContainer = event.target.closest('[data-single-container]');
                boxContainer.querySelector('[data-subscription-details]')?.classList?.remove('d-none');
                boxContainer.querySelector('[data-payment-form]')?.classList?.add('d-none');
            });
        })

        this.querySelectorAll('[data-collapse-order]').forEach(ele => {
            ele.addEventListener('click', (event) => {
                let boxContainer = event.target.closest('[data-single-container]');
                let isCollapsed = ele.dataset.collapseOrder == 1;
                if (isCollapsed) {
                    ele.setAttribute('data-collapse-order', '0');
                    ele.classList?.add('collapsed');
                    ele.querySelector('[data-collapse-text]').innerHTML = 'View order';
                    boxContainer.querySelector('[data-subscription-info]')?.classList?.add('d-none');
                    boxContainer.querySelector('[data-subscription-items]')?.classList?.add('d-none');
                    boxContainer.querySelector('.add-product-button')?.classList?.add('d-none');
                } else {
                    ele.setAttribute('data-collapse-order', '1');
                    ele.classList?.remove('collapsed');
                    ele.querySelector('[data-collapse-text]').innerHTML = 'Collapse order';
                    boxContainer.querySelector('[data-subscription-info]')?.classList?.remove('d-none');
                    boxContainer.querySelector('[data-subscription-items]')?.classList?.remove('d-none');
                    boxContainer.querySelector('.add-product-button')?.classList?.remove('d-none');
                }
            })
        })

        this.querySelectorAll('[data-view-more-mobile]').forEach(ele => {
            ele.addEventListener('click', event => {
                let element = ele.closest('[data-view-more-mobile]');
                let isCollapsed = element.dataset.viewMoreMobile == 1;
                element.dataset.viewMoreMobile = isCollapsed ? 0 : 1;
                setTimeout(() => {
                    element.innerHTML = `${isCollapsed ? 'View Order' : 'Collapse'}<i class="fa fa-thin fa-chevron-down f-12 ms-2 view-order-icon" aria-hidden="true"></i>`;
                }, 50)

            })
        })

        this.querySelectorAll('[data-shipping-edit-form] [data-shipping_address]').forEach(ele => {
            ele.addEventListener('input', event => {
                let container = event.target.closest('[data-shipping-edit-form]');
                if (event.target.value) {
                    ele.closest('[data-input-container]')?.classList?.remove('error');
                    if (!this.querySelector('[data-input-container].error')) {
                        container.querySelector('[data-change-shipping_address]').classList.remove('disabled');
                    }
                } else if (!ele.closest('[data-shipping_address="address2"]')) {
                    container.querySelector('[data-change-shipping_address]').classList.add('disabled');
                    ele.closest('[data-input-container]')?.classList?.add('error');
                }
                if (ele.closest('[data-shipping_address="address2"]')) {
                    if (!this.querySelector('[data-input-container].error')) {
                        container.querySelector('[data-change-shipping_address]').classList.remove('disabled');
                    }
                }

                if (ele.closest('[data-shipping_address="phone"]')) {
                    let x = ele.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    ele.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

                    const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
                    if (!ele.value || !phoneRegex.test(ele.value.replace(' ', '').replace('+1', '').replaceAll('-', '').replace('(', '').replace(')', ''))) {
                        ele.closest('[data-input-container]')?.classList?.add('error');
                        this.querySelector('[[data-shipping-edit-form]] [data-change-shipping_address]').classList.add('disabled');
                    }
                }
            })
        })

        this.querySelectorAll('[data-submit-quick-add]').forEach(ele => {
            ele.addEventListener('click', async (event) => {
                event.stopImmediatePropagation();
                let container = event.target.closest('[data-quick-add-collection]');
                selectedSize = container.getAttribute('data-selected-size')?.toLowerCase().trim();
                let clickAllowed = container.querySelector('[data-submit-quick-add]')?.getAttribute('data-submit-quick-add') == 1;
                if (!clickAllowed) return;
                if (!selectedSize) {
                    container.querySelector('[data-submit-quick-add]')?.setAttribute('data-submit-quick-add', 0);
                    container.querySelector('[data-submit-quick-add]').classList.remove('primary-btn');
                    container.querySelector('[data-submit-quick-add] [data-button-text]').innerHTML = 'Make selections';
                }
                this._loadButton(event.target)
                let style = container.getAttribute('data-quick-add-collection');
                let collectionHandle = this._formatCollectionHandle(style);
                selectedStyleCollection = allCollections[collectionHandle];
                selectedColor = container.getAttribute('data-selected-color')?.toLowerCase().trim();
                let matchProductInCollection = this._isMatchInCollection(true);

                if (!matchProductInCollection) {
                    this._toastMessage('The selected collection does not have matching options', 'error');
                    this._loadButton(event.target, false)
                } else {
                    await this._addOneTimeItemInSubscription(event);
                    this._resetQuickAddBox(container);
                    selectedSize = selectedColor = selectedProduct = selectedVariant = null;
                }
            })
        })

        this.querySelectorAll('.passIcon').forEach(item => {
            item.addEventListener("click", function(e){
                var target = e.currentTarget
                let showIcon =  document.querySelector('.passShow')
                let hideIcon =  document.querySelector('.passHide')
                if(target.classList.contains('passHide')){
                    document.querySelector("#customerPassword").setAttribute("type", "password");
                    hideIcon.classList.add('d-none');
                    showIcon.classList.remove('d-none')
                }else{
                    document.querySelector("#customerPassword").setAttribute("type", "text");
                    showIcon.classList.add('d-none');
                    hideIcon.classList.remove('d-none');
                }
            })
        })
    }

    _resetQuickAddBox(container) {
        container.querySelector('[data-submit-quick-add]')?.setAttribute('data-submit-quick-add', 0);
        container.querySelector('[data-submit-quick-add]').classList.remove('primary-btn');
        container.querySelector('[data-submit-quick-add] [data-button-text]').innerHTML = 'Select a style';

        this._selectSizeValue('', container);
        container.closest('[data-selected-size]').setAttribute('data-selected-size', '')
    }

    async _removeAddon(event) {
        let subscriptionId = addonData.id;
        let response = await rechargeSdk._removeOnetime(subscriptionId);
        if (response == true) {
            await this._loadSubscriptionData();
            this._toastMessage('Product successfully removed.', 'success');
        } else {
            this._toastMessage('Something went wrong. try again!', 'error');
        }
        this._loadButton(this.querySelector('.one-time-edit [data-submit-edit-one-time]'), false);
        event.target.classList?.remove('disabled');
    }

    _singleTimeEvents() {
        this.querySelectorAll('[data-zowie-start]').forEach((zowie) => {
            zowie.addEventListener('click', (event) => {
                event.preventDefault();
                if (zowie != null) {
                    let id = zowie.getAttribute('subscriptions-payment-declined');
                    if (id != null) {
                        Zowie.start(id);
                    } else {
                        Zowie.start();
                    }
                    // this._hideModal('cancel-popup');
                    this._hideModal('subscription-edit');
                }
            })
        })

        this.querySelectorAll('[data-modal-close]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                ele.closest('[data-v2-modal]')?.hide();
            })
        })
    }

    async _listCharges(addressID) {
        let config = {
            ...(addressID && { address_id: addressID }),
            status: 'queued,skipped',
            limit: 100,
            sort_by: 'id-asc',
        }
        allCharges = await rechargeSdk._getCharges(config);
        try {
            // Filter charges with status "skipped" and scheduled date in the past using filter and moment.js
            const filteredCharges = allCharges.filter(charge => {
                return !(charge.status === "skipped" && this.isScheduledDateInPast(charge.scheduled_at));
            });
            allCharges = filteredCharges;
        } catch (err) {
            allCharges = await rechargeSdk._getCharges(config);
        }
    }

    isScheduledDateInPast(scheduledDate) {
        if (!scheduledDate) return false;
        return moment(scheduledDate).isSame(moment(), "day") || moment(scheduledDate).isBefore(moment(), "day");
    }

    //new-badge
    async _loadCollectionData() {
        try {
            let url1 = '/collections/section-api-resource?section_id=subsciption-style-for-section';
            let url2 = '/collections/section-api-resource?section_id=subsciption-style-for-section-2';

            let [response1, response2] = await Promise.all([
                fetch(url1),
                fetch(url2)
            ]);

            if (response1.status === 500 || response2.status === 500) {
                throw new Error('One of the requests failed with status 500');
            }

            let data1 = await response1.text();
            let data2 = await response2.text();

            let tempDiv1 = document.createElement('div');
            tempDiv1.innerHTML = data1;

            let tempDiv2 = document.createElement('div');
            tempDiv2.innerHTML = data2;

            document.body.appendChild(tempDiv1);
            document.body.appendChild(tempDiv2);

            let tempAllCollectionsEle = document.querySelectorAll('[data-style-collection-json]');
            let tempCollections = [];
            tempAllCollectionsEle.forEach((scriptEle) => {
                tempCollections.push(JSON.parse(scriptEle.innerText));
            })
            tempCollections.forEach((collection) => {
                const collectionObj = { ...collection };
                let handle = collectionObj.collection.handle.replaceAll('highwaisted', 'high-waisted');
                let collectionProducts = Object.values(collectionObj['new-products']);
                let tempProducts = collectionProducts.map((product) => {
                    let tempProduct = product.product;
                    tempProduct['color_swatch'] = product.icon
                    return tempProduct;
                });
                collectionObj['products'] = tempProducts;
                delete collectionObj['new-products'];
                allCollections[handle] = collectionObj;
                isCollectionLoaded = true;
            });
        } catch (e) {
            console.log('Error from section rendering api => ' + e);
        }
    }

    _formatMoney(price) {
        return Shopify.formatMoney(price, window.globalVariables.money_format);
    }

    _toastMessage(message, type, permanent = false) {
        let isMobile = window.innerWidth <= 575;
        if (type === 'success') {
            let currentAddressId = currentAddress?.id || allAddresess[0]?.id;
            let containers = this.querySelectorAll(`[data-single-container="${currentAddressId}"]`)
            containers.forEach((container) => {
                let messageBox = container.querySelector('[data-success-message]');
                if (messageBox) {
                    messageBox.querySelector('[data-message-text]').innerHTML = message;
                    messageBox.classList.remove('d-none');

                    messageBox.addEventListener('click', (event) => {
                        event.target.closest('[data-success-message]').classList.add('d-none');
                        setTimeout(() => {
                            document.body.classList.remove('pointer-events-none');
                        }, 100)
                    })

                    if (!permanent) {
                        setTimeout(() => {
                            messageBox?.classList.add('d-none');
                        }, 5000);
                    }
                }
            })

            let scrollElement = this.querySelector(`${isMobile ? '.mobile-part' : '.desktop-part'} [data-single-container="${currentAddressId}"]`);
            if (scrollElement) {
                scrollElement.querySelector('[data-success-message]')?.scrollIntoView({
                    top: scrollElement.querySelector('[data-success-message]').getBoundingClientRect().top,
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
            }
        }
        if (type === 'error') {
            let toastMessageContainer = this.querySelector('[data-dashboard-toast-message]');
            if (toastMessageContainer) {
                let layout = toastMessageContainer.querySelector('.layout-section');
                toastMessageContainer.querySelector('.message').innerHTML = message;
                if (type === 'success') {
                    layout.classList.add('success');
                    layout.classList.remove('error');
                } else {
                    layout.classList.add('error');
                    layout.classList.remove('success');
                }

                toastMessageContainer.classList.remove('d-none');
                toastMessageContainer.addEventListener('click', (event) => {
                    event.target.closest('[data-dashboard-toast-message]').classList.add('d-none');
                    setTimeout(() => {
                        document.body.classList.remove('pointer-events-none');
                    }, 100)
                })
                if (!permanent) {
                    setTimeout(() => {
                        toastMessageContainer?.classList.add('d-none');
                    }, 15000)
                }
            }
        }
    }

    _subscriptionSuccessToast(message, subscription_id) {
        let isMobile = window.innerWidth <= 575;
        let container = isMobile ? this.querySelector(`[data-mobile-subscription-container] [data-subscription-id="${subscription_id}"]`)
            : this.querySelector(`[data-desktop-subscription-container] [data-subscription-id="${subscription_id}"]`);
        let toastContainer = container.querySelector('[data-subscription-success-message]');
        if (toastContainer) {
            toastContainer.classList?.remove('d-none');
            toastContainer.innerHTML = message;
            toastContainer.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
        }

    }

    async _addNewAddon(event) {
        try {
            this._loadButton(event.target);
            let price = selectedVariant.selling_plan_allocations[0].price / 100.00 || selectedVariant.price / 100.00;
            let address_id = currentAddress.id;
            let properties = [{ "name": "connected_address_id", "value": address_id.toString() }];

            if (currentAddress.presentment_currency == "CAD" && selectedProduct) {
                if (Shopify?.currency?.active === 'CAD' && actualLocalePrice) {
                    price = actualLocalePrice/100
                } else {
                    await this._getCARate2(selectedProduct.id);
                    price = price*(canadaRate || 1)
                }
            }

            let config = {
                address_id: address_id,
                add_to_next_charge: true,
                quantity: 1,
                external_variant_id: {
                    ecommerce: selectedVariant.id.toString()
                },
                presentment_currency: currentAddress.presentment_currency,
                price: price.toString(),
                use_shopify_variant_defaults: true,
                properties: properties
            }

            let response = await rechargeSdk._createOnetimeAddon(config);
            if (response) {
                await this._loadSubscriptionData();
                this._toastMessage('One-time product added successfully!', 'success');
            } else {
                this._toastMessage('Something went wrong. Try again!', 'error');
            }
        } catch (e) {
            this._toastMessage('Something went wrong. Try again!', 'error');
        }
        this._loadButton(event.target, false);
    }

    async _addNewSubscription(event) {
        let price = selectedVariant.selling_plan_allocations[0].price / 100.00 || selectedVariant.price / 100.00;
        let properties = [{ "name": "product_add_by", "value": "admin" }, {
            "name": "isSwapping",
            "value": "true"
        }, { "name": "_first_order", "value": 'true' }];
        let isLimitedColorProduct = selectedProduct?.tags.includes('pp-limited_color') || false;
        if (event.target.closest('[data-step-block-color="1"]') && !isLimitedColorProduct) {
            properties.push({ name: "COLOR_BLOCK", value: "true" });
        }

        let firstSubscription = allSubscriptions.find(item => {
            return item.address_id == currentAddress.id
        })
        let nextChargeDate = firstSubscription?.next_charge_scheduled_at;
        if (!firstSubscription) {
            nextChargeDate = moment().add(1, 'months').format('YYYY-MM-DD');
        }
        if (currentAddress.presentment_currency == "CAD" && selectedProduct) {
            if (Shopify?.currency?.active === 'CAD' && actualLocalePrice) {
                price = actualLocalePrice/100
            } else {
                await this._getCARate2(selectedProduct.id);
                price = price*(canadaRate || 1)
            }
        }
        let config = {
            address_id: currentAddress.id,
            next_charge_scheduled_at: nextChargeDate,
            // order_interval_unit: 1,
            order_interval_frequency: 1,
            charge_interval_frequency: 1,
            order_interval_unit: 'month',
            quantity: 1,
            external_product_id: {
                ecommerce: selectedProduct.id.toString()
            },
            external_variant_id: {
                ecommerce: selectedVariant.id.toString()
            },
            presentment_currency: currentAddress.presentment_currency,
            price: price.toString(),
            use_shopify_variant_defaults: true,
            properties: properties
        }
        this._loadButton(event.target)
        let response = null;
        if (currentAddress.presentment_currency == "CAD") {
            response = await commonAPI._createSubscriptionProduct(config);
        }else{
            response = await rechargeSdk._createSubscriptionProduct(config);
        }
        if (response) {
            await this._loadSubscriptionData();
            this._toastMessage('Subscription product added successfully!', 'success');
        } else {
            this._toastMessage('Something went wrong. Try again!', 'error');
        }
        this._loadButton(event.target, false)
    }

    _hideModal(id) {
        try {
            let section = this.querySelector(`[data-modal-section="${id}"]`);
            if (section) {
                let modalContainer = section.closest('[data-v2-modal]');
                let modalId = modalContainer?.getAttribute('id');
                modalId && this.querySelector(`#${modalId}`)?.hide();
            } else {
                this.querySelector(`#${id}`)?.hide();
            }
        } catch (e) {
            console.log(e)
        }
    }

    _showChargeError(addressId) {
        let chargeError = allErrorCharges.find((charge) => {
            return charge.address_id == addressId
        });
        let address = allAddresess.find((add) => {
            return add.id == addressId
        });
        let payment = allPayments.find((payment) => {
            return address?.payment_method_id == payment?.id
        });
        let type = payment?.processor_name.toLowerCase();
        if (type == 'stripe') {
            PAYMENT_METHOD_DECLINED = PAYMENT_METHOD_DECLINED.replaceAll('shopify_payments', 'editPaymentCard');
        } else {
            PAYMENT_METHOD_DECLINED = PAYMENT_METHOD_DECLINED.replaceAll('editPaymentCard', 'shopify_payments');
        }
        if (chargeError != null && chargeError != undefined) {
            chargeFailedDate = moment(chargeError.scheduled_at).format('MMMM Do');
            let error_type = chargeError.error_type.toUpperCase();
            if (error_type == "INVALID_SHIPPING_ADDRESS") {
                return INVALID_SHIPPING_ADDRESS;
            } else if (['CONTRACT_UNDER_REVIEW', 'EMPTY_CHARGE_ENTRY', 'INVALID_CUSTOMER_BILLING_AGREEMENT', 'SHIPPING_RATE_ERROR', 'UNEXPECTED_REGEN_ERROR', 'VARIANT_DOES_NOT_EXIST',
                'PENDING_SCA_AUTHENTICATION', 'SHOPIFY_REJECTED', 'UNEXPECTED_ERROR', 'UNEXPECTED_VARIANT_ERROR_TYPE', null].includes(error_type)) {
                return GENERAL_MESSAGE;
            } else if (error_type == 'CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT') {
                return CARD_UPDATED_NOW_PENDING_NEXT_ATTEMPT;
            } else {
                return PAYMENT_METHOD_DECLINED;
            }
        } else {
            return false;
        }
    }

    async _errorCharges() {
        let config = {
            status: 'error',
            limit: 25,
            sort_by: 'id-asc',
        }
        return await rechargeSdk._getCharges(config);
    }

    _calCulatePrice(product) {
        let productTags = product.tags;
        let price = selectedVariant ? (selectedVariant.selling_plan_allocations[0].price / 100.00 || selectedVariant.price / 100.00) : 0;
        productTags.forEach(tag => {
            if (tag.includes('ws-') && oldPriceJson[tag] !== undefined) {
                price = parseFloat(oldPriceJson[tag]) / 100.00;
            }
        })
        return price;
    }

    async _updateColorBlockStatus(addProp = false) {
        let properties = subscriptionData.properties.filter(prop => prop.name !== 'COLOR_BLOCK');
        if (addProp) properties.push({ name: "COLOR_BLOCK", value: "true" });

        let config = {
            properties: properties
        }

        return await rechargeSdk._updateSubscription(subscriptionData.id, config);
    }

    async _swapSubscription(event, action = null) {
        this._loadButton(event.target)
        let price = selectedVariant.selling_plan_allocations[0].price / 100.00 || selectedVariant.price / 100.00;
        let properties = subscriptionData.properties.filter(prop => !ignoreProperties.includes(prop.name) && prop.name !== 'COLOR_BLOCK');
        let isLimitedColorProduct = selectedProduct?.tags.includes('pp-limited_color') || false;
        let isColorBlocked = false;
        if (!isLimitedColorProduct && isColorBlocked) {
            properties.push({ name: "COLOR_BLOCK", value: "true" });
        }
        properties.push({ name: "isSwapping", value: "true" });

        // Manage same_product
        let sameProduct = subscriptionData.external_variant_id.ecommerce == selectedVariant.id;
        if (sameProduct) {
            properties.push({ name: "same_product", value: 'true' })
        }

        if (currentAddress.presentment_currency == "CAD" && selectedProduct) {
            if (Shopify?.currency?.active === 'CAD' && actualLocalePrice) {
                price = actualLocalePrice/100
            } else {
                await this._getCARate2(selectedProduct.id);
                price = price*(canadaRate || 1)
            }
        }

        let config = {
            external_product_id: {
                ecommerce: selectedProduct.id.toString()
            },
            external_variant_id: {
                ecommerce: selectedVariant.id.toString()
            },
            presentment_currency: currentAddress.presentment_currency,
            price: price.toString(),
            use_shopify_variant_defaults: true,
            properties: properties
        }

        let response = null;
        if (currentAddress.presentment_currency == "CAD") {
            response = await commonAPI._updateSubscription(subscriptionData.id, config);
        }else{
            response = await rechargeSdk._updateSubscription(subscriptionData.id, config);
        }

        if (response) {
            await this._loadSubscriptionData();
            let message = this.__subscriptionSuccessMessage(action);
            this._toastMessage(message, 'success');
            // this._subscriptionSuccessToast(message, subscriptionData.id);
        } else {
            this._toastMessage('Something went wrong. Try again!', 'error');
            this._loadButton(event.target, false)
        }
    }

    /*async _deleteSubscription(event) {
        try {
            this._loadButton(event.target);

            let response =  await rechargeSdk._deleteSubscription(subscriptionData.id);
            this._loadButton(event.target, false);

            return response;
        } catch (e) {
            console.log(e);
        }

    }*/

    async _mergeAddresses(event) {
        this._loadButton(event.target)
        let sourceAddresses = [];
        addressesToMerge.forEach((address) => {
            if (address != mergeParentAddress) {
                sourceAddresses.push({ id: address });
            }
        })
        let config = {
            target_address: { id: mergeParentAddress },
            source_addresses: sourceAddresses,
        }

        let response = await rechargeSdk._mergeAddresses(config);

        if (response) {
            currentAddressItems = allProducts.filter(item => {
                return addressesToMerge.includes(item.address_id.toString());
            });

            let promises = [];
            for (let item of currentAddressItems) {
                if (!moment(mergeShippingDate).isSame(item.next_charge_scheduled_at)) {
                    let config = {
                        next_charge_scheduled_at: mergeShippingDate
                    }
                    promises.push(await rechargeSdk._updateSubscription(item.id, config));
                }
            }

            if (sourceAddresses && sourceAddresses.length) {
                await sourceAddresses.forEach(async (address) => {
                    promises.push(await rechargeSdk._deleteAddress(address.id));
                })
            }

            if (promises.length > 0) {
                const response = await Promise.all(promises);
                if (response.length > 0) {
                    currentAddress = allAddresess.find(address => {
                        return address.id == mergeParentAddress
                    });
                    await this._loadSubscriptionData();
                    this._toastMessage('Your boxes were successfully merged!', 'success');
                } else {
                    this._toastMessage('Something went wrong. Try again!', 'error');
                }
            } else {
                currentAddress = allAddresess.find(address => {
                    return address.id == mergeParentAddress
                });
                await this._loadSubscriptionData();
                this._toastMessage('Your boxes were successfully merged!', 'success');
            }
        } else {
            this._toastMessage('Something went wrong. Try again!', 'error');
        }
        this._loadButton(event.target, false)
    }

    _cancelSubscriptionsAndRemoveOnetimes = async(event) => {
        this._loadButton(event.target)

        try {
            let isSuccess = true;
            let config = {
                cancellation_reason: `Others`,
                cancellation_reason_comments: 'NEW CANCEL FTC FLOW'
            }
            for (const subscriptionData of currentAddressSubscriptions) {
                const response = await rechargeSdk._cancelSubscription(subscriptionData.id, config);
                if (!response) isSuccess = false;
            }

            let addressRelatedAddons = allAddons.filter(addon => addon.address_id == currentAddress.id);
            for (const addon of addressRelatedAddons) {
                const response = await rechargeSdk._removeOnetime(addon.id);
                if (!response) isSuccess = false;
            }

            if (isSuccess) {
                successModal = 'cancel-success';
                this.querySelector('[data-modal-section="cancel-box"]')?.classList?.add('success');
                await this._loadSubscriptionData();
            } else {
                this._toastMessage('Something went wrong. Try again!', 'error');
            }
        } catch (e) {
            console.log(e)
        }
        this._loadButton(event.target, false)
    }

    _getCARate2 = async (productId) => {
        if (!productId) return;
        let id = `gid://shopify/Product/${productId}`;

        let query = ` query GetProductById($id: ID!) {
            product(id: $id) {
                priceRangeV2 {
                  maxVariantPrice {
                    amount
                  }
                }
                contextualPricing(context: {country: CA}) {
                    maxVariantPricing {
                        price {
                            amount
                        }
                    }
                }
            }
        }`;

        let url = '/community/api/graphql';

        let requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: query,
                variables: { id: id },
                version: "2025-04"
            })
        };

        try {
            let response = await fetch(url, requestOptions);
            if (response.ok) {
                let data = await response.json();
                let actualPrice = data?.data?.product?.priceRangeV2?.maxVariantPrice?.amount || 0;
                let canPrice = data?.data?.product?.contextualPricing?.maxVariantPricing?.price?.amount || 0;

                if (actualPrice && canPrice) {
                    canadaRate = parseFloat(canPrice)/parseFloat(actualPrice);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    __subscriptionSuccessMessage(type) {
        switch (type) {
            case 'color-picker':
                return 'Item color was picked successfully.';
            case 'swapped':
                return 'The item was swapped successfully.';
            default:
                return 'The subscription was updated successfully.'
        }
    }

    _checkDigit(e, target) {
        var keycode = e.which;
        if (!(keycode >= 48 && keycode <= 57)) {
            e.preventDefault();
            return false;
        }
        if (target == 'CN') {
            if (e.target.value.length == 4 || e.target.value.length == 9 || e.target.value.length == 14) {
                e.target.value = e.target.value + ' ';
            }
        } else if (target == 'EX') {
            if (e.target.value.length == 2) {
                e.target.value = e.target.value + '/';
            }
        }
    }

    _loadButton(el, load = true) {
        if (el) {
            if (el?.closest('a')) {
                load ? el.closest('a').classList.add('loading')
                    : el.closest('a').classList.remove('loading');
            } else if (el?.closest('.btn')) {
                load ? el.closest('.btn').classList.add('loading')
                    : el.closest('.btn').classList.remove('loading');
            } else {
                load ? el.closest('button').classList.add('loading')
                    : el.closest('button').classList.remove('loading');
            }
        }
    }
}

customElements.define("new-account-dashboard-v2", NewDashboardV2);